export const carbonEmissions2024Every6Hours = {
  BEL: [
    579.78, 607.24, 569.72, 498.73, 484.13, 507.21000000000004, 527.61,
    569.8199999999999, 564.37, 588.1999999999999, 561.53, 539.23, 556.7099999999999,
    769.5799999999999, 948.4799999999999, 761.37, 606.76, 803.87, 749.96, 852.24,
    709.23, 881.02, 814.0999999999999, 893.42, 614.11, 672.27, 625.98, 857.33,
    812.5699999999999, 1342.73, 1326.14, 1293.28, 1126.25, 1378.04, 1300.25, 1475.98,
    1532.06, 1605.2099999999998, 1643.79, 1815.3600000000004, 1779.9, 1582.09,
    1493.98, 1807.54, 1762.6599999999999, 1900.03, 1909.05, 2021.0900000000001,
    1635.0900000000001, 1544.97, 1626.3600000000001, 1585.9800000000002, 1389.45,
    1442.08, 1434.7099999999998, 1239.61, 1236.96, 1285.8999999999999, 1396.29,
    1662.6399999999999, 1757.44, 1668.8700000000001, 1610.75, 1490.05,
    1460.3799999999999, 1769.75, 1569.98, 1542.8099999999997, 1349.47, 1583.01,
    1672.36, 1780.1399999999999, 1524.85, 1700.21, 1546.4, 1429.3799999999999,
    1157.47, 1142.19, 1147.99, 1096.01, 780.54, 782.19, 731.59, 744.79, 725.84,
    739.26, 708.4399999999999, 790.6899999999999, 806.5400000000001, 967.39,
    736.0999999999999, 723.8199999999999, 682.1400000000001, 728.9499999999999,
    792.9499999999999, 1000.96, 1255.23, 1288.7399999999998, 1027.73, 946.99, 626.84,
    654.89, 816.72, 1249.71, 1211.52, 1055.92, 916.4599999999999, 984.0699999999999,
    740.6500000000001, 721.71, 745.6000000000001, 967.25, 919.28, 1035.1, 928.03,
    933.02, 760.7199999999999, 876.8799999999999, 984.04, 1544.78, 1152.15,
    1042.1499999999999, 811.1400000000001, 896.84, 903.9499999999999, 1108.66,
    1011.81, 1124.05, 781.4, 902.5699999999999, 824.88, 899.3299999999999, 823.81,
    872.6299999999999, 850.8199999999999, 868.8499999999999, 781.48,
    764.5899999999999, 745.26, 754.87, 725.59, 789.4300000000001, 784.79, 793.37,
    549.5899999999999, 670.8000000000001, 607.5400000000001, 567.04, 544.89,
    830.1500000000001, 1018.6599999999999, 1259.33, 980.59, 859.6, 710.7800000000001,
    601.74, 556.8999999999999, 650.29, 715.54, 831.59, 944.52, 1134.1799999999998,
    1063.3000000000002, 1169.5900000000001, 770.52, 790.31, 777.7400000000001,
    1101.5, 1119.55, 1158.3799999999999, 1053.09, 1279.68, 1075.65, 988.7,
    924.6500000000001, 1026.87, 842.3200000000002, 908.6300000000001,
    883.7900000000001, 941.2099999999999, 848.34, 875.3399999999999,
    891.6800000000001, 813.83, 646.93, 863.1600000000001, 824.5600000000001,
    1008.1099999999999, 1036.3, 966.2700000000001, 838.73, 896.03, 734.6700000000001,
    679.8400000000001, 704.4399999999999, 942.76, 923.25, 846.0400000000001, 887.78,
    1042.17, 945.27, 880.6500000000001, 769.22, 921.29, 819.6800000000001,
    696.1299999999999, 647.0500000000001, 670.08, 726.4200000000001,
    737.6899999999999, 703.06, 747.14, 721.3199999999999, 754.08, 805.2299999999999,
    1166.83, 961.1899999999999, 910.95, 775.74, 1055.89, 1104.29, 1025.74,
    873.7399999999999, 798.5899999999999, 821.0000000000001, 984.6899999999999,
    936.38, 938.97, 849.0400000000001, 1289.3600000000001, 1380.92,
    1635.1399999999999, 1560.87, 1558.61, 1257.7200000000003, 1077.52, 800.25, 976.9,
    898.74, 996.33, 968.0099999999999, 779.43, 872.24, 986.72, 912.9399999999999,
    809.73, 1069.5, 1509, 1523.31, 1369.56, 1127.37, 1702.9299999999998,
    1774.6399999999999, 1532.63, 1376.5800000000002, 1722.87, 1545.6299999999999,
    1759.0700000000004, 1845.73, 2206.0899999999997, 2079.87, 1650.3100000000002,
    1629.78, 2003.56, 1563.7, 1171.49, 879.1399999999999, 1003.5600000000002,
    870.6700000000001, 773.3, 736.23, 936.2499999999999, 866.24, 818.3699999999999,
    912.49, 1101, 931.05, 928.4399999999999, 1108.95, 1577.0500000000002,
    1312.8999999999999, 1472.44, 1287.58, 1534.09, 1441.9299999999998, 1451.22,
    1262.69, 1311.27, 1019.09, 1085.31, 1071.76, 1142.79, 947.9499999999999,
    847.9100000000001, 878.0300000000001, 897.1800000000001, 746.3100000000001,
    668.2800000000001, 688.0699999999999, 818.86, 686.79, 911.29, 922.52, 883.26,
    643.8399999999999, 499, 623.09, 904.02, 944, 1004.56, 953.4200000000001,
    1118.3600000000001, 965.0899999999999, 917.1500000000001, 1002.1299999999999,
    1541.22, 1377.48, 1022.2299999999998, 1117.8400000000001, 1510.72, 1175.06,
    1153.14, 1020.5, 1163.17, 898.6600000000001, 759.4399999999998, 870.75, 1061.32,
    604.14, 508.48, 552.04, 616.17, 543.05, 482.59, 607.81, 960.39, 1253.9, 994.9,
    1047.64, 1157.79, 1080.95, 1105.1499999999999, 1112.17, 1212.8999999999999,
    820.5600000000001, 738.79, 738.34, 858.5699999999999, 681.8599999999999, 633.78,
    587.18, 663.3399999999999, 751.1700000000001, 747.0799999999999,
    673.5900000000001, 845.6300000000001, 826.2, 910.19, 919.8099999999998, 939.47,
    693.44, 723.54, 793.84, 762.7500000000001, 636.74, 621.44, 649.48,
    734.4000000000001, 768.05, 626.23, 603.04, 719.06, 778.1400000000001, 681.17,
    666.89, 707.21, 650.8299999999999, 577.3399999999999, 628.51, 728.17, 719.27,
    596.58, 645.44, 836.75, 545.19, 493.18, 490.84000000000003, 676.04, 591.59,
    467.34, 575.94, 778.8699999999999, 942.5600000000001, 1056.37, 860.63,
    1103.4299999999998, 833.17, 658.3799999999999, 683.1800000000001, 826.2, 908.87,
    801.0200000000001, 740.95, 868.38, 790.22, 807.5699999999999, 981.34, 958.21,
    794.9200000000001, 713.1700000000001, 706.5899999999999, 827.8100000000001,
    847.49, 686.97, 473.15, 783.73, 1039.6399999999999, 750.54, 590.3199999999999,
    588.4799999999999, 639.4, 614.1800000000001, 659.81, 778.9000000000001,
    745.6600000000001, 651.6600000000001, 741.6399999999999, 999.72, 1067.54, 929.59,
    971.9200000000001, 1395.23, 1344.6299999999999, 969, 941.9499999999999, 987.75,
    741.2, 687.65, 700.9200000000001, 789.24, 713.8199999999999, 648.84,
    610.2900000000001, 638.3, 585.75, 552.12, 568.85, 667.0899999999999, 798.14,
    865.53, 641.07, 948.5999999999999, 979.6100000000001, 935.83, 703.92,
    970.7900000000001, 933.2700000000001, 750.37, 757.5999999999999, 1141.87,
    1105.46, 904.38, 875.98, 1230.24, 1192.06, 973.1999999999999, 882.5699999999999,
    1017.7900000000001, 596.22, 532.03, 526.6, 602.9, 433.15999999999997,
    464.85999999999996, 597.88, 944.5, 967.8199999999999, 833.6600000000001,
    875.5600000000001, 1218.84, 1032.31, 745.3699999999999, 791.1200000000001,
    820.4499999999999, 524.0999999999999, 551.0699999999999, 490.26000000000005,
    613.0600000000001, 613.8199999999999, 660.15, 458.75, 638.96, 535.35, 412.42,
    439.31, 623.41, 607.41, 540.02, 722.36, 930.6200000000001, 682.55, 609.4, 756.89,
    1130.64, 1125.63, 970.73, 952.68, 993.86, 861.5200000000001, 807.7, 704.32,
    708.59, 754.6000000000001, 831.0500000000001, 782.1800000000001, 835.19, 625.77,
    671.3699999999999, 625.9200000000001, 645.71, 632.5500000000001, 600.99, 599.36,
    648.67, 584.19, 597.0899999999999, 596.55, 673.9399999999999, 463.30999999999995,
    467.97, 548.38, 487.42, 433.13999999999993, 535.48, 592.21, 656.06, 430.69,
    474.33000000000004, 529.88, 604.96, 732.5, 640.1899999999999, 568.4000000000001,
    863.81, 689.21, 669.0799999999999, 640.64, 795.75, 716.55, 668.8, 613.36, 789.98,
    602.09, 700, 589.63, 661.29, 623.91, 758.26, 617.93, 637.3599999999999,
    609.5699999999999, 676.8199999999999, 617.2, 678.99, 748.77, 793.98, 774.03,
    860.78, 659.31, 621.14, 608.13, 685.53, 683, 689.14, 703.1, 862, 821.8, 844.47,
    828.64, 995.59, 728.55, 689.45, 663.8700000000001, 757.97, 619.63,
    817.8299999999999, 640.49, 693.29, 752.58, 743.38, 750.08, 771.4300000000001,
    647.1200000000001, 681.38, 620.1, 674.62, 531.67, 464.06000000000006, 653.04,
    727.6700000000001, 636.22, 593.12, 652.85, 750.7099999999999, 695.2,
    664.5500000000001, 731.63, 682.12, 614.71, 668.4200000000001, 693.5600000000001,
    622.7700000000001, 431.77, 570.95, 624.55, 623.76, 679.7, 784.2900000000002,
    1066.19, 1484.29, 1002.1300000000001, 802.4200000000001, 773.04,
    790.1199999999999, 835.35, 697.12, 840.76, 1146.36, 952.05, 721.05,
    821.0699999999999, 1194.8000000000002, 939.3399999999999, 689.15,
    741.8299999999999, 1024.45, 671.5699999999999, 524.0799999999999, 548.95,
    730.9000000000001, 542.2, 591.87, 684.01, 647.62, 548.3799999999999,
    518.7900000000001, 606.34, 772.3299999999999, 821.93, 709.3700000000001, 691.34,
    893.27, 805.0500000000001, 728.0699999999999, 836.21, 1074.96, 799.73, 619.54,
    588.76, 713.09, 638.58, 598.38, 597.4200000000001, 685.3899999999999, 532.97,
    519.56, 547.94, 543.04, 510.95000000000005, 580.87, 547.65, 555.09, 438.77,
    500.0199999999999, 669.53, 881.29, 637.3, 652.6800000000001, 769.16,
    1044.6399999999999, 544.74, 590.5, 635.87, 687.15, 680.38, 811.9399999999999,
    866.41, 1100.83, 832.41, 840.7099999999999, 719.3800000000001, 770.48,
    561.2199999999999, 603.31, 595.96, 602.62, 565.5699999999999, 484.03, 496.95,
    642.48, 481.96000000000004, 564.46, 632.6800000000001, 750.81, 585.1, 609.58,
    643.0699999999999, 828.88, 629.63, 699.58, 731.6999999999999, 1009.84, 667.73,
    623.1800000000001, 539.5, 613.51, 510.77, 527.85, 565.4100000000001, 722.49,
    567.7, 475, 570.59, 651.1, 443.48, 571.94, 569.28, 697.8399999999999, 600.85,
    730.46, 665.78, 851.96, 619.33, 617.1800000000001, 608.42, 794.26,
    626.6700000000001, 675.66, 562.34, 606.3100000000001, 528.33, 554.38, 498.27,
    541.66, 540.76, 599.8, 555.5500000000001, 667.74, 596.65, 519.51, 478.02,
    684.1800000000001, 730.4000000000001, 559.45, 551.3, 690.1300000000001, 674.53,
    706.89, 798.8800000000001, 1047.15, 718.35, 672.03, 734.89, 1022.24, 621.5,
    612.5999999999999, 640.66, 1002.87, 711.19, 566.52, 763.75, 1019.46, 669.8,
    633.01, 620.4499999999999, 738.0100000000001, 497.90999999999997, 572.31, 638.51,
    742.5799999999999, 487.7300000000001, 554.16, 679.78, 847.4599999999999,
    534.8000000000001, 677.6, 799.33, 840.06, 469.78, 596.68, 601, 823.63,
    519.5500000000001, 596.3599999999999, 579.17, 873.51, 642.96, 620.82, 796.82,
    1126.8600000000001, 749.2, 677.9800000000001, 663.54, 989.51, 510.39, 578.15,
    582.89, 672.52, 421.22, 584.62, 562, 573.5799999999999, 542.77, 548.75, 578.97,
    634.82, 540.52, 509.19999999999993, 631.16, 841.3700000000001, 660.72, 676.82,
    672.92, 833.4200000000001, 719.65, 627.87, 673.75, 865.15, 475.68999999999994,
    535.4399999999999, 752.3500000000001, 998.01, 704.3299999999999, 613.23, 619.56,
    683.71, 426.27000000000004, 564.23, 597.15, 644.49, 596.2900000000001,
    605.1899999999999, 651.92, 856.62, 600.6700000000001, 603.71, 727.9300000000001,
    967.4399999999999, 736.86, 748.4599999999999, 770.4100000000001, 955.35, 753.77,
    827.5699999999999, 684.44, 947.2800000000001, 678.1099999999999, 655.98, 595.02,
    659.27, 520.96, 522.25, 485, 540.51, 379.46999999999997, 546.09,
    575.3299999999999, 565.01, 429.35999999999996, 503.96000000000004, 614.01,
    872.75, 534.4000000000001, 549.51, 656.1700000000001, 837.4100000000001, 685.26,
    671.8800000000001, 591.24, 764.04, 697.97, 590.3299999999999, 541.52, 687.11,
    546.8, 537.02, 526.62, 640.7300000000001, 601.05, 572.83, 493.95, 697.45, 595.2,
    565.54, 541.18, 608.91, 603.77, 576.13, 653.6300000000001, 935.05, 721.75, 653.5,
    717.1200000000001, 950.63, 736, 607.5, 658.17, 866.0400000000001, 490.39, 489.71,
    504.2, 696.96, 636.65, 578.6700000000001, 673.0899999999999, 951.38, 760.87,
    644.26, 702.03, 784.2800000000001, 624.28, 573.6400000000001, 556.79, 624.51,
    616.72, 595.1200000000001, 679.23, 834.48, 630.79, 599.27, 644.31, 732.04,
    598.8299999999999, 567.75, 555.61, 653.1, 643.3799999999999, 497.7199999999999,
    515.3100000000001, 630.35, 530.09, 498.88, 586.84, 753.8800000000001, 793.93,
    693.48, 657.64, 653.1899999999999, 798.91, 633.21, 579.8, 654.33, 600.9,
    553.0300000000001, 727.42, 1052.27, 713.3, 653.4200000000001, 738.8700000000001,
    1149.49, 842.23, 716.89, 744.7300000000001, 1253.2800000000002, 960.38, 746.06,
    914.39, 1382.07, 1127.5500000000002, 974.47, 924.25, 1065.99, 687.48, 576.8,
    738.28, 858.6899999999999, 790.3800000000001, 647.28, 674.42, 1197.58, 1076.95,
    935.03, 999.0200000000001, 1559.9900000000002, 1359.76, 1227.67, 1205.28,
    1466.09, 1481.84, 1292.64, 1354.5500000000002, 1297.51, 872.79, 768.53,
    824.2099999999999, 1037.66, 704.02, 882.53, 820.09, 1082.46, 866.74, 568.23,
    764.3100000000001, 872.89, 384.45, 481.93000000000006, 546.0699999999999, 728.26,
    742.6600000000001, 763.6, 694.54, 881.48, 661.6, 671.74, 574.14,
    549.0799999999999, 593.22, 607.1600000000001, 612.67, 866.0600000000001, 872.67,
    693.11, 775.3699999999999, 1073.35, 983.44, 740.7099999999999, 705.34,
    972.8499999999999, 861.53, 690.75, 691, 713.35, 658.4000000000001, 581.34,
    591.71, 901.03, 1023, 886.3200000000002, 704.0999999999999, 776.46, 812.82,
    698.32, 628.55, 736.54, 799.8299999999999, 753.3699999999999, 665.38, 759.78,
    758.92, 657.1299999999999, 696.34, 844.2299999999999, 892.2499999999999, 755.05,
    784.5699999999999, 983.59, 846.6499999999999, 666.42, 793.81, 976.6500000000001,
    724.53, 731.83, 791.22, 1007.5999999999999, 972.5500000000001, 799.9, 843.1,
    961.99, 811.08, 758.6899999999999, 802.5, 909.0799999999999, 763.25, 762.19,
    756.9300000000001, 672.8500000000001, 580.7199999999999, 555.51, 632.78, 594.95,
    602.73, 581.3199999999999, 624.65, 733.58, 713.6500000000001, 680.8399999999999,
    713.43, 1035.24, 627.36, 627.46, 591.0500000000001, 629.5, 577.99,
    548.1800000000001, 569.97, 595.76, 568.49, 588.27, 843.75, 1244.95,
    1020.2800000000001, 951.4, 996.15, 1014.41, 746.35, 735.8, 803.09, 1038.44,
    857.46, 850.22, 822.56, 1312.3400000000001, 827.81, 669.87, 716.6999999999999,
    825.5899999999999, 631.61, 627.76, 662.79, 730, 705.1600000000001,
    728.3100000000001, 912.1899999999999, 810.34, 615.28, 667.41, 815.02, 708.01,
    615.35, 635.63, 853.5, 762.15, 618.62, 748.45, 886.44, 1050.19, 994.02, 940.97,
    921.8399999999999, 881.49, 606.0999999999999, 708.14, 690.77, 728.2800000000001,
    724.11, 774.17, 945.3000000000001, 1156.99, 898.66, 1270.57, 1321.7399999999998,
    1263.7799999999997, 986.5899999999999, 995.9200000000001, 828.95,
    812.2199999999999, 710.46, 792.04, 794.74, 735.58, 786.52, 888.2, 1033.1, 894.2,
    911.8599999999999, 1074.92, 1135.22, 871.09, 623.6899999999999, 638.14, 787.04,
    835.94, 641.64, 608.7599999999999, 561.17, 746.32, 745.3799999999999, 797.8,
    1178.12, 1079.85, 997.98, 965.61, 1105.11, 1277.76, 1097.04, 902.76, 1027.66,
    1091.63, 795.58, 843.89, 934.3599999999999, 936.49, 862.8100000000001, 870.28,
    974.8100000000001, 1044.1200000000001, 837.82, 651.99, 696.83, 1047.67, 629.24,
    516.9, 700.1700000000001, 1046.61, 794.5900000000001, 831.27, 947.8199999999999,
    1044.55, 993.27, 1269.17, 1406.66, 1497.89, 1472.32, 1385.3500000000001,
    1354.3899999999999, 1556.17, 1361.6499999999999, 1123.8899999999999,
    1141.1200000000001, 1649.48, 1235.5, 1013.31, 1032.26, 1409.08, 1221.48, 946.75,
    1206.02, 1438.2200000000003, 899.6099999999999, 927.5099999999999,
    1184.3799999999999, 1650.7499999999998, 1449.6599999999999, 1532.97,
    1610.1999999999998, 1934.13, 1795.63, 1652.88, 1726.25, 1979.47, 1791.04,
    1671.29, 1708.19, 1847.66, 1884.83, 1642.84, 1725.1899999999998, 1926.67,
    1965.8799999999999, 1989.91, 2047.27, 2252.2799999999997, 2042.62, 1783.67,
    1663.5800000000002, 1962.05, 1716.5700000000002, 1506.3600000000001, 1565.47,
    1922.3600000000004, 1590.73, 1310.6, 1282.3799999999999, 1280.3799999999999,
    1143.47, 1364.23, 1433.5300000000002, 1663.07, 1960.6499999999999, 1624.53,
    1714.28, 2026.84, 1867.99, 1878.4699999999998, 1783.77, 2209.18, 2122.02,
    1648.4299999999998, 1654.71, 1822.9199999999998, 1334.3199999999997, 1294.53,
    1209.3000000000002, 1241.17, 962.56, 961.77, 1043.44, 1208.89, 1121.01, 1437.42,
    1584.3400000000001, 1532.2199999999998, 735.45, 1216.15, 1394.3400000000001,
    1453.6799999999998, 952.5400000000001, 1118.1100000000001, 1188.52, 1309.56,
    1341.32, 1758.2099999999998, 1769.9099999999999, 1580.18, 991.81, 1044.69,
    1044.99, 1489.96, 1085.5, 732.9200000000001, 668.3199999999999,
    734.4200000000001, 657.55, 656.9099999999999, 665.22, 696.0500000000001, 595.49,
    787.0500000000001, 933.47, 1026.53, 1000.08, 1168.6, 1418.83, 1639.4700000000003,
    1064.52, 916.55, 820.5, 1005.14, 1100.59, 1410.7199999999998, 1581.4300000000003,
    1803.6600000000003, 1595.8799999999999, 1253.8, 1418.8799999999999, 1363.79,
    1283.99, 1252.8, 1368.28, 1645.9, 1087.7399999999998, 989.7800000000001,
    943.1399999999999, 1050.74, 739.3899999999999, 1221.54, 1200.98, 1369.57, 1324.4,
    1753.21, 1762.8899999999999, 2066.83, 1980.3400000000001, 1665.5400000000002,
    1674.08, 1591.84, 906.1, 889.52, 961.5, 828.65, 687.3, 823.82, 1214.67, 1096.53,
    606.8799999999999, 579.98, 587.24, 626.56, 532.8, 608.28, 743, 748.5699999999999,
    687.76, 1037.49, 1115.7600000000002, 1086.8700000000001, 969.66,
    1396.2299999999998, 1428.53, 1564.79, 1559.3500000000001, 1562.29, 1560.09,
    1832.2299999999998, 1870.54, 1730.3700000000001, 1714.26, 1903.6000000000001,
    1849.89, 1779.0699999999997, 1693.2799999999997, 2003.08, 1540.99, 1403.04,
    1320.76, 1256.0700000000002, 789.14, 743.74, 774.02, 705.3000000000001, 709.78,
    1030.22, 1158.83, 1187.15, 1129.37, 1496.5699999999997, 1200.69, 974.05,
    585.0799999999999, 656.51, 699.3399999999999, 685.2900000000001, 594.38, 669.54,
    692.72, 835.75, 896.8399999999999, 1071.3899999999999, 891.0500000000001,
    805.5899999999999, 777.77, 711.0600000000001, 631.18, 638.03, 632.8399999999999,
    610.85, 622.4, 678.46, 563.71, 722.1700000000001, 950.51, 1225.8600000000001,
    763.6100000000001, 1086.3799999999999, 1208.1200000000001, 1404.1,
    918.5300000000002, 764.99, 871.37, 1247.1999999999998, 1008.48,
    1202.8000000000002, 1209.79, 1386.1499999999999, 1190.28, 1375.25, 1308.74,
    1528.9499999999998, 1441.23, 1330.1, 1314.37, 1665.85, 1290.76, 1335.69, 1317.78,
    1232.71, 953.9000000000001, 1041.61, 1007.78, 1025.77, 854.1800000000001,
    852.4100000000001, 819.94, 747.2900000000001,
  ],
  CHE: [
    338.47, 291.99, 192.23, 177.43, 218.59999999999997, 160.95000000000002, 159.78,
    216.13, 242.38, 232.98999999999998, 198.05000000000004, 184.67000000000002,
    212.77, 228.53, 176.42000000000002, 192.05, 223.84999999999997, 274.23, 219.9,
    213.48, 236.22000000000003, 182.67, 180.15, 222.31, 198.49, 229.56000000000003,
    188.76000000000005, 383.81, 387.7, 417.83000000000004, 376.57, 678.2,
    625.3199999999999, 438.46000000000004, 360.09999999999997, 570.62,
    673.5799999999999, 181.44, 178.56, 336.69, 666.06, 313.77, 266.68,
    389.44999999999993, 660.59, 184.82000000000002, 205.81, 643.77, 792.41, 531.68,
    429.03, 655.8700000000001, 683.44, 654.43, 559.4499999999999, 727.5999999999999,
    620.93, 573.52, 452.72, 602.5699999999999, 636.9200000000001, 176.31, 285.71,
    531.6400000000001, 456.03, 197.34999999999997, 178.00000000000003,
    310.14000000000004, 320.92, 172.56, 190.89, 624.39, 634.05, 475.09999999999997,
    554.12, 564.21, 652, 535.71, 331.21, 569.23, 483.87, 427.94999999999993,
    329.36999999999995, 444.63, 405.2900000000001, 360.14000000000004, 332.85,
    433.31, 440.38, 344.18, 351.08000000000004, 372.16999999999996, 357.5, 360.17,
    338.12000000000006, 411.97, 449.14000000000004, 305.85, 200.19, 283.65, 371.85,
    324.13, 331.36, 481.65999999999997, 439.96999999999997, 357.68,
    244.76999999999998, 359.23, 307.73, 299.89, 220.98000000000002, 390.11,
    410.72999999999996, 365.40999999999997, 242.95999999999998, 368.10999999999996,
    441.90999999999997, 315.02000000000004, 225.9, 421.18999999999994, 470.27,
    187.31, 198.72000000000003, 502.86999999999995, 513.4, 399.4, 310.34, 347.96,
    336.93999999999994, 295.51, 309.79, 550.92, 526.89, 420.19, 339.12,
    469.84000000000003, 455.23999999999995, 377.54999999999995, 329.8, 439.02,
    472.15999999999997, 356.38, 332.38, 403.54999999999995, 434.75, 417.47,
    354.45000000000005, 363.99999999999994, 338.83, 238.34000000000003, 179.69,
    218.60000000000002, 328.55999999999995, 173.72, 171.3, 244.26,
    294.92999999999995, 305.09, 242.62, 298.53, 334.05, 209.45999999999998, 194.6,
    338.47, 230.21, 269.42, 212.57, 301.83, 415.91, 196.43, 260.33,
    405.71000000000004, 510.49, 387.85, 274.16999999999996, 474.73, 444.07, 210.98,
    200.78000000000003, 364.96000000000004, 396.15000000000003, 218.04, 225.22,
    307.55, 337.97, 337.02, 243.78999999999996, 302.19, 357.68, 305.88,
    192.78000000000003, 181.45000000000002, 316.13, 296.49, 220.07, 273.78, 328.79,
    183.67, 176.5, 257.03999999999996, 288.46000000000004, 181.32, 183.8, 349.17,
    369.35999999999996, 238.54000000000002, 222.70000000000002, 281.51, 273.88,
    166.82000000000002, 181.86, 314.32, 342.28000000000003, 297.99,
    226.54999999999998, 254.47, 364.15000000000003, 368.25, 242.37,
    394.06999999999994, 480.73999999999995, 420.02, 235.29999999999998, 283.64,
    336.69, 296.38, 300.90000000000003, 339.74, 274.7, 271.02, 263.48, 200.13,
    234.19, 169.74, 185.45000000000002, 238.32999999999998, 229.26000000000002,
    241.9, 212.24, 290.89000000000004, 306.81, 196.15, 170.39000000000001, 262.56,
    393.8, 325.87, 285.72, 379.7900000000001, 442.32, 355.01, 274.43, 317.85, 410.37,
    263.21, 259.53, 353.01, 374.8, 232.3, 236.3, 394.4, 457.48999999999995, 262.93,
    230.88, 337.80999999999995, 422.61, 221.12, 177.96, 204.02999999999997, 231.12,
    290.18, 255.46, 275.14, 197.51000000000002, 278.98, 279.74, 352.37, 328.1,
    307.98, 307.89, 397.03, 382.53, 386.29999999999995, 244.31, 273.33000000000004,
    269.59, 210.40000000000003, 184.84, 320.09, 298.14000000000004, 184.72, 178.82,
    224.26, 180.29, 186.96, 170.38, 174.95999999999998, 180.12, 181.5, 175.04,
    217.44, 224.57000000000002, 238.11999999999998, 230.91000000000003, 195.74,
    196.15999999999997, 177.34, 173.92000000000002, 174.39, 173.54,
    196.76999999999998, 181.25, 188.22, 181.20999999999998, 218.92000000000002,
    186.84999999999997, 203.00000000000003, 178.87, 229.95, 195.84, 174.92, 172.18,
    172.72, 173.91, 171.33, 168.02, 170.75, 171.88, 161.67, 170.76999999999998,
    179.61, 184.61, 176.93, 186.94, 194.50000000000003, 184.88, 179.27, 175.26,
    199.83, 206.39000000000001, 189.32, 199.55, 231.16, 225.66, 183.3, 171.86,
    185.18, 172.82, 165.61, 170.9, 183.43, 188.01999999999998, 166.96, 183.85,
    216.26000000000002, 179.34, 155.97, 190.34, 214.75, 178.31, 196.47000000000003,
    498.91, 383.53999999999996, 373.9, 544.8, 518.2, 430.25, 324.63,
    218.32999999999998, 242.15, 156.23, 162.14999999999998, 152.62, 155.91, 163.27,
    157.7, 141.24, 143.60999999999999, 162.76999999999998, 155.94,
    146.69000000000003, 151.12, 170.73000000000002, 175.37, 146.56, 147.04, 162.04,
    171.23, 170.14, 231.24, 188.63, 175.67000000000002, 150.81, 150.8, 159.16, 156.8,
    149.55, 146.87, 155.51, 150.87, 146.82, 150.37, 156.07000000000002,
    162.00000000000003, 149.22, 150.2, 169.04, 160.7, 149.79, 149.2,
    168.30999999999997, 170.78, 150.08, 143.82, 166.45999999999998,
    160.17000000000002, 218.82000000000002, 201.40999999999997, 166.58, 179.16,
    150.78, 150.56, 152.58, 153.14, 153.81, 151.25, 159.63, 156.19, 153.15, 149.5,
    155.60000000000002, 154.76, 155.14, 153.84, 166.23000000000002, 166.57, 153.13,
    195.28, 162.68, 164.16, 174.55, 151.73999999999998, 202.47000000000003,
    183.07999999999998, 154.5, 277.28, 215.79, 157.98, 147.06, 150.95, 162.63,
    161.14999999999998, 154.76, 153.04999999999998, 201.1, 180.70000000000005,
    161.89, 153.77, 162.57, 159.66, 162.03999999999996, 247.93, 284.08,
    234.90000000000003, 253.04, 175.28, 304.24, 232.65999999999997, 160.64,
    168.70999999999998, 301.77, 207.54000000000002, 188.22, 195.71,
    254.79000000000002, 202.95000000000002, 158.98, 155.01000000000002, 215.09,
    211.35000000000002, 176.03, 189.63, 208.79999999999998, 203.18999999999997,
    161.8, 160.82999999999998, 236.38, 215.73000000000002, 185.55, 164.11, 194.97,
    183.66, 169.82, 160.77999999999997, 164.07, 165.28000000000003, 163.83, 160.22,
    201.85000000000002, 187.47000000000003, 164.01999999999998, 165.89, 239.98,
    194.35999999999996, 164.17000000000002, 158.91, 183.21, 167.9,
    160.89000000000001, 157.59000000000003, 165.01999999999998, 161.94, 156.91,
    155.06, 162.43, 164.98, 159.29000000000002, 157, 226.97, 198.61,
    160.59000000000003, 156.56, 173.58, 168.64, 161.32000000000002, 161.38, 170.84,
    171.23000000000002, 158.69, 157.38000000000002, 198.20999999999998, 180.65,
    154.49999999999997, 153.02, 213.57, 199.63000000000002, 153.21999999999997,
    148.49, 220.88, 213.58, 155.85999999999999, 157.66000000000003,
    217.54999999999998, 218.92000000000002, 162.98000000000002, 154.88, 210.56,
    179.06000000000003, 168.09, 160.48000000000002, 164.83, 165.17000000000002,
    162.03, 156.06, 170.45, 175.1, 165.33, 159.4, 170.66000000000003, 171.99,
    165.40000000000003, 164.42, 220.13000000000002, 218.35, 159.94, 157.41, 177.37,
    170.76000000000002, 157.01999999999998, 155.7, 163.08, 165.67000000000002, 158.3,
    155.12, 175.06, 168.01, 162.38000000000002, 158.76, 170.58999999999997, 167.68,
    165.77, 156.26, 168.29999999999998, 171.01999999999998, 164.11, 156.85, 207.74,
    189.19, 158.17000000000002, 155.8, 185.32000000000002, 175.23999999999998,
    157.24, 156.09, 174.14000000000001, 175.32, 159.49, 193.08999999999997,
    178.11999999999998, 175.23, 160.12, 157.60000000000002, 186.08999999999997,
    187.14000000000001, 161.45, 157.97, 163.18, 158.95999999999998, 157.49, 154.75,
    215.72000000000003, 183.29999999999998, 154.59, 155.99, 217.25, 191.54, 165.75,
    158.55, 165.95, 164.14000000000001, 164.81, 157.68, 164.89999999999998, 164.19,
    155.57, 152.17, 169.61, 162.65, 159.71, 157.44, 167.01999999999998, 171.97,
    162.89, 154.21, 168.94, 170.79, 161.07000000000002, 155.12, 194.42, 162.01,
    155.84, 153.57, 206.14, 175.39, 157.71000000000004, 154.59000000000003, 162.3,
    162.26000000000002, 154.84, 149.96, 165.39, 161.11, 152.58999999999997,
    151.20999999999998, 159.83000000000004, 161.31, 155.5, 151.22000000000003,
    156.23, 157.81, 151.55, 151.31000000000003, 156.75, 159.01, 155.63, 157.48,
    199.56000000000003, 171.96, 147.4, 144.45999999999998, 162.09, 160.27, 151.08,
    150.61, 158.47, 157.57, 156.35, 150.26999999999998, 161.34, 160.86, 155.93,
    147.82999999999998, 160.36999999999998, 156.74, 155.1, 153.31, 162.42,
    159.73000000000002, 155.8, 156.65000000000003, 163.88, 155.43, 152.08, 147.09,
    160.38, 168.04999999999998, 152.87, 151.25, 178.2, 162.68, 152.70000000000002,
    148.45000000000002, 157.7, 156.51999999999998, 153.54000000000002, 149.2, 168.88,
    164.09, 154.14999999999998, 151.95, 169.81, 160.62, 153.76, 151.10999999999999,
    156.14, 154.1, 151.69, 148.35999999999999, 163.39999999999998,
    165.55999999999997, 154.26000000000002, 156.11, 165.76999999999998,
    165.92000000000002, 151.83, 148.3, 175.76000000000002, 175.92000000000002,
    152.51, 148.17999999999998, 154.54, 153.2, 149.72, 145.60999999999999,
    155.95999999999998, 151.54999999999998, 149.53, 146.25, 151.74, 149.11, 146.41,
    144.07999999999998, 153.35999999999999, 154.92000000000002, 145.37, 144.38,
    157.83999999999997, 154.45000000000002, 149.23, 144.35999999999999, 170.5,
    156.18, 149.4, 148.18, 151.82, 150.74, 147.51999999999998, 147.67,
    155.73999999999998, 153.78, 147.92, 146.53, 158.79, 155.42999999999998, 147.91,
    148.16000000000003, 153.73000000000002, 152.24, 148.53, 148.18, 155.24,
    154.97999999999996, 148.37, 147.08, 151.3, 151.33, 147.59, 143.10999999999999,
    152.28, 151.4, 146.82999999999998, 142.72, 156.98, 153.18, 147.3,
    147.39000000000001, 160.29, 158.28, 147.41, 141.63, 149.48, 151.18, 147.3,
    146.81, 153.81, 152.41, 147.31, 148.05, 159.44, 156.42000000000002,
    149.51000000000002, 149.32, 160.73000000000002, 155.48, 148.53, 147.82,
    156.26000000000002, 155.26999999999998, 148.10000000000002, 146.94,
    154.54000000000002, 154.42, 148.1, 147.53, 151.44, 151.18, 148.14000000000001,
    145.98000000000002, 154.45, 154.29999999999998, 148.76999999999998,
    147.67000000000002, 153.91, 154.72000000000003, 148.28, 147.85, 157.42, 156.45,
    149.8, 146.09, 154.91, 153.82, 150.16, 144.95000000000002, 153.96, 154.25,
    147.48000000000002, 144.49, 158.85, 168.97, 151.12, 147.06, 160.36,
    158.76999999999998, 149.07999999999998, 148.51, 160.81, 159.43, 149.26, 149.54,
    156.92000000000002, 155.2, 149.51, 152.88, 158.63000000000002,
    157.64000000000001, 152.65, 151.54, 158.39, 156.76, 152.87, 147.48000000000002,
    155.87, 154.86999999999998, 152.42, 149.60000000000002, 157.06, 157.63, 152.11,
    150.66, 157.95, 159.33999999999997, 152.81, 149.18, 162.71000000000004, 160.63,
    153.65, 151.10999999999999, 160.11, 157.45000000000002, 154.38, 154.29,
    157.20999999999998, 157.72, 153.32000000000002, 152.36, 162.51, 177.06, 154.22,
    156.29999999999998, 199.55, 190.09000000000003, 154.11, 153.83,
    193.57999999999998, 191.87, 152.31, 154.15, 182.14000000000001, 171.84,
    154.96000000000004, 154.09, 167.26, 165.56, 154.18, 153.70999999999998,
    160.20000000000002, 161.13, 153.95, 153.19, 183.95999999999998, 159.37, 153.54,
    151.65, 162.96, 159.28, 153.79999999999998, 152.89999999999998, 160.18,
    160.58999999999997, 153.34, 151.52, 155.8, 157.11, 153.77, 153.72,
    157.60999999999999, 158.19, 153.06, 148.14, 154.81, 156.04000000000002, 151.18,
    146.47, 188.72, 174.46999999999997, 152.75, 153.74, 185.73, 174.78, 156.61,
    156.76, 203.14, 198.22000000000003, 154.29, 151.47, 185.04, 185.35999999999999,
    168.92000000000002, 208.58, 194.01999999999998, 161.59, 151.19, 151.52, 212.04,
    178.40000000000003, 154.57, 150.23000000000002, 186, 170.72, 153.54, 153.37,
    208.95, 191.66000000000003, 153.79999999999998, 154.76, 224.09999999999997,
    197.45999999999998, 153.20000000000002, 153.36, 193.82000000000002,
    179.65999999999997, 154.35, 151.64, 228.95, 208.89, 159.84, 153.64000000000001,
    279.37, 227.65000000000003, 153.58, 154.84, 205.32, 178.36999999999998, 157.77,
    156.63, 232.46, 180.33, 162.26, 167.70999999999998, 276.04999999999995,
    219.98999999999998, 160.43, 155.61, 257.12, 212.8, 225.15, 161.64, 207.02,
    183.85000000000002, 159.67000000000002, 152.43, 260.8, 209.32, 168.64, 176.81,
    259.45, 180.51, 148.53, 146.52999999999997, 154.37, 152.35, 149.29000000000002,
    144.54000000000002, 154.64000000000001, 152.68, 159.56, 154.56, 221.87,
    177.45999999999998, 148.42, 144.60999999999999, 155.25, 154.84, 150.3, 147.12,
    155.86, 156.5, 180.38, 183.48, 163.26000000000002, 167.29000000000002, 154.01,
    162.66, 186.51, 172.35, 150.89, 151.4, 156.41000000000003, 154.47, 148.85,
    152.79999999999998, 172.84, 166.21, 145.04999999999998, 145.11,
    189.01000000000002, 175.16, 156.69, 159.23000000000002, 210.71, 185.06,
    155.51999999999998, 156.6, 229.79, 194.67, 155.05, 153.95999999999998,
    196.35000000000002, 175.57999999999998, 149.71, 155.25, 188.46,
    159.76000000000002, 149.34, 150.85, 176.20999999999998, 159.76999999999998,
    155.69, 159.17, 184.63, 189.42000000000002, 161.06, 190.54999999999998, 171.13,
    164.25, 152.07, 155.13, 162.7, 181.89000000000001, 160.41, 143.91000000000003,
    159.66, 154.21, 174, 154.30999999999997, 172.76000000000002, 166.47000000000003,
    154.87, 145.19, 186.64999999999998, 181.55, 143.8, 143.54, 187.66,
    176.67999999999998, 205.05, 184.16999999999996, 184.13, 174.48000000000002,
    173.41, 163.12, 169.13, 170.51999999999998, 175.02999999999997, 177.76, 182.25,
    174.25, 172.26999999999998, 166.89, 167.00000000000003, 161.48000000000002,
    171.01, 154.88, 155.87, 157.32, 161.11, 182.84, 213.70000000000002,
    164.82000000000002, 156.3, 157.81, 167.21999999999997, 162.65000000000003,
    157.66000000000003, 146.32999999999998, 158.4, 157.73, 148.59,
    147.20999999999998, 166.75, 163.29, 152.32, 155.55, 218.32999999999998, 168.04,
    159.41, 155.09, 179.54, 159.42000000000002, 157.54000000000002,
    150.07999999999998, 179.92, 175.13, 237.96999999999997, 289.09, 224.45, 183.93,
    156.78, 152.79, 169.62000000000003, 162.27, 158.26, 153.64000000000001,
    168.56000000000003, 163.24, 147.35, 145.63, 212.65999999999997,
    162.20000000000002, 153.46, 152.82999999999998, 164.37, 162.58999999999997,
    157.95, 157.06, 181.85999999999999, 160.91, 158.95, 153.54999999999998, 157.22,
    158.48999999999998, 158.77, 250.1, 252.39999999999998, 183.23999999999998,
    191.48, 170.85999999999999, 169.82999999999998, 163.13, 153.62, 148.9, 161.39,
    157.51000000000002, 157.95999999999998, 150.24, 160.68, 158.43, 152.95, 148.17,
    160.04000000000002, 159.57, 145.03, 142.46, 156.07999999999998, 161.18,
    156.71999999999997, 149.14, 205.94000000000003, 213.82000000000002, 152.46,
    143.8, 193.01, 154.74, 151.53, 146.12, 207.85, 175.76000000000002, 150.73,
    146.54, 174.08999999999997, 177.59, 159.32999999999998, 154.07,
    175.70000000000002, 167.60000000000002, 159.98000000000002, 167.46, 159.87,
    158.77, 203.89999999999998, 186.32, 282.81, 245.24000000000004,
    212.94000000000003, 206.42000000000002, 237.01, 190.81, 206.92, 170.84, 292.29,
    217.95000000000002, 218.61, 177.53, 186.75, 174.85000000000002, 213.77,
    213.39999999999998, 220.53, 203.7, 209.34000000000003, 255.04000000000002,
    301.92, 253.57, 297.96999999999997, 208.21, 249.72999999999996, 217.37, 266.02,
    413.01, 192.57999999999998, 190.47, 459.73, 603.73, 234.14, 189.06000000000003,
    262.34, 319.65999999999997, 249.51999999999998, 207.6, 264.39,
    314.78999999999996, 182.69000000000003, 177.77, 197.20999999999998, 301.94,
    196.35, 187.01, 206.07, 198.85999999999999, 233.97, 233.20999999999998, 269,
    435.94, 198.86, 190.63000000000002, 434.29999999999995, 486.13000000000005,
    215.82999999999998, 210.13, 539.0600000000001, 686.6500000000001,
    400.84999999999997, 273.53999999999996, 588.68, 542.23, 512.95, 444.91,
    528.8000000000001, 547.78, 445.62, 277.14, 341.77, 428.68, 176.12,
    185.98000000000002, 447.12, 362.45, 248.35999999999999, 212.29,
    461.03000000000003, 509.8599999999999, 331.45, 202.01, 245.20000000000002,
    350.59, 236.07999999999998, 284.4, 684.3000000000001, 584.28, 352.25, 228.28,
    318.57, 340.26, 304.37, 260.09000000000003, 314.18, 309.49, 374.46, 267.99,
    446.47, 388.10999999999996, 242.09, 198.20999999999998, 328.81000000000006,
    283.61, 216.79, 192.67, 412.86999999999995, 512.4399999999999, 341.6, 253.82,
    429.98, 479.5, 181.06999999999996, 187.05999999999997, 398.75, 549.72,
    511.24999999999994, 276.43, 593.28, 516.79, 420.12, 260.18, 475.40999999999997,
    416.39, 280.34999999999997, 189.73999999999998, 335.25, 473.17999999999995,
    197.99, 202.22999999999996, 253.98, 345.59000000000003, 271.4, 260.05,
    312.66999999999996, 375.21, 285.66, 342.86, 417.07000000000005,
    326.3299999999999, 297.78, 179.14, 376.51, 285.15, 226.06, 241.37000000000003,
    263.95000000000005, 297.40999999999997, 375.63, 284.17, 299.38, 296.71, 261.36,
    261.65999999999997, 629.59, 543.01, 219.89000000000001, 195.76,
    352.54999999999995, 521.2, 474.31999999999994, 459.74, 267.10999999999996,
    530.64, 586.86, 598.94, 491.61, 549.65, 549.6199999999999, 487.41,
    628.5600000000001, 836.7900000000001, 602.71, 551.92, 706.88, 549.85,
    565.3299999999999, 543.15, 586.3, 610.48, 558.51, 530.06, 626.14,
    762.1099999999999, 713.73, 351.50999999999993, 450.63, 366.37, 354.39,
    298.40000000000003, 356.32000000000005, 321.71999999999997, 399.92999999999995,
    319.8, 507.2, 552.45, 515.02, 427.67, 443.37000000000006, 368.73,
    335.60999999999996, 304.6, 400.53999999999996, 371.99999999999994,
    298.54999999999995, 278.49, 350.11, 305.16, 401.79, 430.15, 508.99999999999994,
    216.43, 231.87, 230.13, 487.99, 393.57000000000005, 277.7, 236.36999999999998,
    334.18, 452.6, 528.7800000000001, 216.82, 208.29, 362.01, 284.79, 216.93, 184.8,
    424.64, 281.86, 212.95999999999998, 425.29, 626.51, 514.41, 359.52000000000004,
    784.54, 773.3100000000001, 741.8299999999999, 614.9499999999999, 739.32, 642.11,
    647.6999999999999, 659.53, 597.3199999999999,
  ],
  DEU: [
    1104.43, 1049.3000000000002, 1133.2, 1245.55, 1230.23, 1211.25, 1338.95, 1043.51,
    992.2800000000001, 963.66, 1143.58, 1251.0700000000002, 1153.72, 1683.83,
    2395.19, 2760.8399999999997, 2168.9300000000003, 2153.71, 2168.45, 2370.55,
    2334.66, 2583.8900000000003, 2540.1600000000003, 2599.86, 2389.71, 2520.76,
    2460.58, 2480.33, 2239.08, 2581.41, 2671.12, 2919.89, 3043.58, 3143.67, 3186.26,
    3406.98, 3446.44, 3294.5299999999997, 3514.71, 3769.54, 3634.8799999999997,
    3341.9599999999996, 3507.9, 3736.29, 3621.6200000000003, 3449.27, 3369.19,
    3244.09, 2720.35, 2394.99, 2274.3, 2304.37, 2182.97, 2262.35, 2292.2,
    2128.1499999999996, 1998.33, 2355.9700000000003, 2637.5899999999992, 2946.44,
    2983.03, 3256.99, 3248.63, 2858.5400000000004, 2510.77, 3084.78, 3489.09,
    3518.6800000000003, 3301.37, 3268.68, 3186.52, 2921.7, 2348.24, 2523.6, 2422.94,
    2090.92, 1995.12, 1876.6900000000003, 1939.83, 2022.8999999999999, 1530.69,
    1301.84, 1286.5600000000002, 1366.5700000000002, 1257.07, 1340.98, 1348.5,
    1359.8899999999999, 1365.21, 1536.2399999999998, 1451.3000000000002, 1221.81,
    1139.9999999999998, 1253.59, 1269.46, 1392.8500000000001, 1480.18, 1895.73,
    2203.04, 2313.5199999999995, 1891.3600000000001, 1570.6999999999998, 1418.58,
    1747.3500000000001, 1638.6100000000001, 1545.0500000000002, 1793.2,
    2001.9699999999998, 1839.37, 1415.4899999999998, 1603.93, 1555.35,
    1776.8100000000002, 2118.55, 2675.89, 2596.1099999999997, 2270.52,
    2150.9700000000003, 2153.28, 2178.32, 2261.79, 2331.25, 2053.41,
    1713.8900000000003, 1543.79, 1893.3999999999999, 1947.43, 1995.4399999999998,
    1648.8400000000001, 1616.5100000000002, 1380.08, 1447.74, 1261.3999999999999,
    1217, 1194.4299999999998, 1286.6399999999999, 1190.28, 1061.39,
    1068.2199999999998, 1146.45, 1189.74, 1186.5099999999998, 1194.84, 1275.71,
    1184.3400000000001, 1274.41, 1173.7, 1132.92, 1220.8500000000001, 2096.96,
    2851.73, 3038.8500000000004, 3113.7200000000003, 3209.47, 3116.9399999999996,
    2496.2400000000002, 1800.7799999999997, 1800.8600000000001, 2135.26, 2306.75,
    2532.0699999999997, 2570.7, 2528.17, 2174.85, 1745.92, 1864.71, 2304.39, 2645.65,
    2727.02, 2635.9800000000005, 2587.5600000000004, 2639.4900000000002, 2297.78,
    2114.63, 2330.0499999999997, 2381.17, 2193.04, 2425.2000000000003,
    2497.2000000000003, 2479.8199999999997, 2422.6400000000003, 2534.26,
    2595.1299999999997, 2225.83, 1789.62, 1827.6799999999998, 2028.99, 2227.81, 2031,
    1979.69, 2478.13, 2914.62, 2014.8200000000002, 1459.27, 1554.6999999999998,
    1471.4099999999999, 1448.92, 1802.9099999999999, 2017.81, 2074.85, 1965.02,
    2048.12, 1910.8, 1956.23, 1721.81, 1724.17, 1827.96, 1433.8, 1452.2499999999998,
    1839.9199999999998, 1627.5100000000002, 1113.46, 1138.74, 1463.1000000000001,
    1683.7399999999998, 2098.2699999999995, 2245.3500000000004, 1773.6,
    1651.3899999999999, 1960.2499999999998, 1928.3300000000002, 1713.53,
    2118.6800000000003, 2614.9, 2348.86, 2357.1000000000004, 2411.17, 2559.99,
    2704.52, 2990.7000000000003, 3128.6400000000003, 3365.46, 3270.03,
    3027.6000000000004, 2890.71, 2633.29, 1912.64, 1872.19, 2041.4900000000002,
    2207.6400000000003, 2138.2500000000005, 2142.7400000000002, 2305.32, 2290.31,
    2053.3799999999997, 1755.34, 1992.73, 1972.07, 2122.04, 1907.99, 2046.91,
    2755.21, 3237.58, 3030.46, 3100.04, 3240.39, 3110.04, 2993.8, 3100.7400000000002,
    3350.39, 3558.71, 3165.4700000000003, 3233.1099999999997, 3486.07,
    3345.8199999999997, 2644.8, 2529.6899999999996, 2391.51, 2119.45,
    1537.1999999999998, 1243.57, 1401.9799999999998, 1337.93, 1076.4299999999998,
    1302.54, 1482.44, 1328.3100000000002, 1094.1999999999998, 1390.0800000000002,
    1771.3000000000002, 1966.6200000000001, 1884.92, 2216.3, 3065.1800000000003,
    3238.68, 3001.31, 3152.73, 3265.59, 2991.19, 2609.5699999999997, 2621.15,
    2641.01, 2337.15, 1995.97, 1996.04, 2012.7, 1618.12, 1314.11, 1397.8,
    1559.0400000000002, 1219.6599999999999, 1104.25, 1337.16, 2050.57,
    2334.3999999999996, 1531.32, 1827.7399999999998, 2255.25, 2248.2200000000003,
    2222.9, 2636.55, 3083.0899999999997, 2965.72, 2136.41, 2367.91,
    3150.0799999999995, 3364.68, 2531.97, 2905.72, 3327.97, 2710.48, 2321.54,
    2299.77, 2468.52, 1708.3700000000001, 1376.46, 1674.2900000000002, 2217.05,
    1867.44, 1079.54, 1013.9399999999998, 1221.6100000000001, 1064.1799999999998,
    888.67, 1017.28, 1469.2699999999998, 2026.9, 2055.8199999999997, 2352.1, 2807.89,
    2165.8099999999995, 1733.9600000000003, 1828.21, 2080.39, 1959.2800000000002,
    1794.6700000000003, 2070.34, 2328.93, 1903.85, 1353.33, 1044.1799999999998,
    1203.0700000000002, 1062.7, 1069.79, 1400.64, 1913.37, 1795.1999999999998,
    1514.7799999999997, 1706.0500000000002, 2075.12, 1843.48, 1401.18,
    1517.8199999999997, 1720.97, 1756.6899999999998, 1511.75, 1122.6999999999998,
    1074.3500000000001, 1020.15, 835.43, 1024.15, 1604.6599999999999, 2092.02,
    1968.4299999999998, 1994.21, 1587.3400000000001, 1446.8400000000001, 1305.04,
    1163.8, 1293.79, 1563.83, 1096.62, 1071.31, 1469.3500000000001, 1492.17, 1025.06,
    1062.33, 1173.83, 1095.52, 1028.96, 1373.66, 2004.72, 2326.59, 1765.17, 2070.33,
    2225.5, 1557.22, 1259.27, 1182.14, 1439.6699999999998, 1669.8500000000001,
    1467.6999999999998, 1609.3000000000002, 1991.5099999999998, 1602.65, 1229.15,
    1534.58, 2068.85, 1844.95, 1083.3700000000001, 1146.64, 1518.98, 1273.19,
    882.7700000000001, 1005.26, 1172.39, 1146.17, 826.9200000000001, 1037.92,
    2020.72, 2019.1100000000001, 1295.8600000000001, 1121, 1190.85,
    1234.2900000000002, 1188.66, 1571.1299999999999, 2495.02, 2685.23, 2210.38,
    2333.39, 3191.7799999999997, 3201.0000000000005, 2205.67, 1877.9899999999998,
    2204.92, 1441.12, 1182.87, 1182.78, 1311.1999999999998, 1360.67, 1246.86,
    1402.46, 2184.5499999999997, 1894.6899999999998, 1243.75, 1444.6, 2322.63,
    2610.5099999999998, 1925.73, 2255.2, 3125.61, 3008.05, 1880.9,
    2033.8000000000002, 2539.5499999999997, 2453.04, 1918.8399999999997,
    2024.3599999999997, 2819.42, 2809.3599999999997, 2032.1799999999998,
    2146.8799999999997, 2671.6400000000003, 2418.4300000000003, 1868.8200000000002,
    2118.33, 2921.98, 2467.3199999999997, 1149.8200000000002, 1256.42, 1642.65,
    1163.1100000000001, 925.51, 1014.5799999999999, 1639.74, 1897.3700000000001,
    1335.3799999999999, 1613.0500000000002, 2051.04, 1860.87, 1221.17, 1353.63,
    1735.25, 1467.86, 895.43, 881.08, 1090.8700000000001, 1144.23, 914.69, 1076.7,
    1399.76, 1461.92, 1240.77, 1408.42, 2011.8300000000002, 2136.02, 1299.72,
    1543.8200000000002, 2080.55, 1537.0900000000001, 934.96, 1140.15, 2173.38,
    2404.6899999999996, 1902.3400000000001, 2059.17, 2429.72, 2353.75,
    2019.6399999999999, 2114.82, 2630.15, 2675.1700000000005, 1906.1299999999997,
    1980.8999999999999, 2564.2400000000002, 2491.29, 1121.58, 1462.57, 2362.57,
    2290.67, 1121.79, 1420.98, 2252.15, 2184.3399999999997, 1051.04, 1204.17,
    1614.3200000000002, 1335.46, 969.3699999999999, 1050.55, 1258.3899999999999,
    1204.38, 1052.64, 1293.3400000000001, 1453.6899999999998, 1292.39, 876.07,
    1042.4, 1429.5, 1469.2200000000003, 1158.67, 1368.7599999999998, 1581.65,
    1558.26, 1198.61, 1407.25, 1685.82, 1425.62, 1150.8, 1411.69, 1878.1, 1674.04,
    1080.23, 1275.1399999999999, 1975.51, 1859.85, 1118.23, 1228.7,
    2019.0099999999998, 1952.44, 1035.2, 1243.2199999999998, 1751.3,
    1591.6800000000003, 1310.74, 1459.33, 1652.91, 1682.21, 1362.56,
    1516.4299999999998, 2378.6600000000003, 2196.4300000000003, 1439.08,
    1915.2000000000003, 2886.44, 2881.17, 1949.9099999999999, 1879.27, 2577.84,
    2287.96, 1343.52, 1520.4800000000002, 2439.95, 2203.14, 1097.91,
    1339.8899999999999, 2118.37, 2185.53, 1538.3000000000002, 1971.6, 2816.22,
    2534.26, 1700.8000000000002, 1845.77, 2201.04, 1651.48, 1250.8200000000002,
    1552.71, 2386.36, 2456.1900000000005, 1591.65, 1872.2399999999998,
    2506.4599999999996, 2272.47, 1756.29, 1659.7599999999998, 2050.7,
    1509.5800000000002, 1015.3199999999999, 1055.07, 1471.27, 1201.2,
    901.0600000000001, 992.55, 1822.26, 2130.65, 1975.3400000000001,
    2006.8899999999999, 2699.42, 2761.57, 1618.9099999999999, 1563.04, 2143.2,
    1479.48, 1235.56, 1604.33, 2477.3799999999997, 2456.98, 1284.83, 1568.33,
    2695.04, 2598.0299999999997, 1246.8000000000002, 1292.3799999999999, 2232.95,
    1844.3799999999999, 841.24, 1054.07, 1481.71, 1566.2400000000002,
    968.6300000000001, 1086.97, 1745.9700000000003, 1994.5100000000002, 1465.48,
    1410.0900000000001, 1761.57, 1460.4499999999998, 1075.26, 1200.31,
    1911.8200000000002, 1881.45, 1182.71, 1477.03, 2532.7999999999997, 2538.49,
    1376.01, 1675.9099999999999, 2484.47, 1761.67, 1345.73, 1401.6399999999999,
    1676.3400000000001, 1045.9299999999998, 794.0100000000001, 843.79,
    1304.1599999999999, 1117.17, 842.03, 1048.3799999999999, 2062.1099999999997,
    2250.34, 1396.3100000000002, 1725.98, 2950.64, 2841.5299999999997, 1668.52,
    2079.21, 2779.4, 2615.1499999999996, 1794.0900000000001, 1772.74,
    2536.9199999999996, 2489.08, 1722.85, 2143.19, 2926.7799999999997, 2810.94,
    2206.48, 2164.75, 2076.8900000000003, 1145.86, 856.25, 1033.8999999999999,
    1770.6000000000001, 1431.57, 1112.26, 1328.28, 2506.5299999999997, 2435.88,
    1214.82, 1637.9899999999998, 2652.16, 2582.14, 1285.81, 1403.46, 2352.26,
    2551.47, 1425.77, 1787.41, 2571.98, 2560.24, 1463.5099999999998,
    1513.4499999999998, 2621.2799999999997, 2324.5, 890.34, 908.6, 1777.36,
    1893.6699999999998, 925.6800000000001, 1241.48, 1562.6399999999999,
    1228.3600000000001, 1164.73, 1215.99, 2158.7299999999996, 2399.88, 1669.05,
    1510.91, 2226.39, 2044.83, 1616.3999999999999, 1569.05, 2085.62, 2080.9, 1698.51,
    1922.3600000000001, 1918.05, 1031.01, 811.46, 874.48, 1213.29, 1119.62,
    807.5600000000001, 953.13, 1609.42, 1085.54, 765.1100000000001, 846.26, 1179.46,
    1079.96, 848.1299999999999, 1110.3600000000001, 2248.1, 2024.5300000000002,
    1241.9900000000002, 1811.8500000000001, 2845.26, 2308.85, 1222.7499999999998,
    1301.97, 1809.38, 1951.17, 1572.77, 1747.01, 2771.2700000000004,
    2620.3100000000004, 1579.6899999999998, 1736.51, 2895.59, 2676.83,
    1851.0800000000002, 1188.71, 1256.1, 1194.6799999999998, 876.11, 998.37, 1670.08,
    1246.63, 881.55, 1016.17, 1845.28, 1727.5700000000002, 985.0500000000001,
    1502.94, 2091.17, 1587.75, 1037.1299999999999, 1174.6399999999999, 2141.7,
    1649.5500000000002, 1066.55, 1347.62, 2561.7299999999996, 2467.2400000000002,
    1328.6700000000003, 1686.91, 2819.25, 2567.06, 1442.6, 1588.1399999999999,
    2477.1899999999996, 1974.7699999999998, 966.0799999999999, 1138.6599999999999,
    1657.9299999999998, 1613.2, 1000.94, 1364.43, 2133.42, 2014.52, 1134.46, 1251.89,
    2270.32, 2115.67, 1376.08, 1481.87, 2297.8, 2114.34, 1400.5800000000002, 1275.4,
    2524.85, 2557.7999999999997, 1240.3100000000002, 1581.01, 2394.9800000000005,
    2097.92, 1548.7800000000002, 1570.93, 2615.12, 2585.93, 1425.02,
    1812.3000000000002, 2418.2200000000003, 1753.78, 992.2099999999999, 1073.01,
    2033.97, 2032.71, 1129.1299999999999, 1447.83, 2563.8199999999997, 2521.86,
    1350.2100000000003, 1755.6000000000001, 2963.39, 2886.24, 1502.35, 1887.93,
    2965.15, 2949.05, 1892.3700000000003, 2205.34, 2876.19, 2758.5699999999997,
    1977.3100000000002, 1937.9599999999998, 2957.2200000000003, 2457.2799999999997,
    1088.47, 1295.87, 2109.17, 1836.52, 991.79, 1157.58, 2311.36, 2390.81,
    1454.6899999999998, 1699.3, 2949.81, 2770.83, 1285.44, 1674.67, 2675.56, 2557.26,
    1653.0099999999998, 1869.48, 2755.12, 2728.25, 1619.52, 1589.55, 2447.92,
    1475.4899999999998, 830.9699999999999, 949.5, 1588.68, 1611.46, 851.05, 939.66,
    1669.77, 1779.86, 956.6800000000001, 1172.95, 2065.28, 2093.83, 1125.06, 1602.44,
    2535.69, 2268.6, 1357.43, 1573.8500000000001, 2184.87, 2463.78, 1697.55, 2021.64,
    2890.41, 2838.8599999999997, 1517.98, 1446.9899999999998, 2306.6,
    2297.1600000000003, 1353.28, 1853.7700000000002, 3015.35, 2991.0099999999998,
    1539.78, 1747.84, 2895.3, 2805.99, 1759.7200000000003, 1706.3500000000001,
    2415.5, 2465.0499999999997, 1868.6499999999999, 2091.42, 2672.5599999999995,
    2102.59, 1372.6100000000001, 1631.62, 2103.7599999999998, 1464.72,
    989.9499999999999, 964.72, 1540.2, 1598.64, 962.58, 1025.67, 1456.5700000000002,
    1114.45, 731.17, 886.09, 1699.06, 1608.7199999999998, 853.09, 878.56,
    1062.9499999999998, 1090.79, 892.74, 1165.8200000000002, 1923.25,
    1864.0499999999997, 1257.65, 1760.95, 2844.1899999999996, 2690.0800000000004,
    1309.76, 1731.94, 2476.96, 2307.41, 1443.02, 1633.33, 2355.8500000000004,
    2393.82, 1694.8, 1940.09, 2907.73, 2878.0899999999997, 1951.5900000000001,
    2072.2200000000003, 2594.41, 2304.2200000000003, 1145.6399999999999, 1297.1,
    1757.63, 1462.61, 1017.39, 1446.38, 2283.9, 2442.32, 1854.22, 1990.0800000000002,
    2672.9000000000005, 2808.0200000000004, 2047.65, 2319.29, 3099.13,
    3086.8700000000003, 2226.6899999999996, 2207.55, 2614.0299999999997, 2216.6,
    1336.64, 1361.04, 1752.1, 1895.3399999999997, 1622.0399999999997, 1847.62,
    2258.06, 2426.76, 1430.89, 1777.8799999999999, 2422.49, 2371.77, 1364.6,
    1858.0499999999997, 2750.6400000000003, 2693.75, 2203.91, 1974.2399999999998,
    1950.62, 1613.81, 1307.73, 1126.2800000000002, 1314.5, 1429.1999999999998,
    1489.5100000000002, 2052.67, 2449.7899999999995, 2404.38, 2055.85,
    2379.6099999999997, 2873.64, 2524.05, 1723.9799999999998, 1333.72, 1424.77,
    1367.3799999999999, 1168.65, 1288.3500000000001, 1939, 2064.93, 1249.88,
    1474.3300000000002, 2399.8, 2532.25, 2141.92, 2224.77, 2399.7200000000003,
    2441.9799999999996, 1887.05, 1752.72, 2351.75, 2574.22, 1715.9499999999998,
    1553.6000000000001, 2073.9900000000002, 2324.5099999999998, 1507.8200000000002,
    1423.91, 1892.55, 1899.18, 1273.97, 1310.86, 1682.7600000000002, 2065.73,
    1243.78, 1581.2600000000002, 2204.0699999999997, 2451.1899999999996, 1519.33,
    2199.91, 3041.9299999999994, 3121.14, 2296.74, 2672.6800000000003, 3003.96,
    2917.36, 2239.8900000000003, 1970.5100000000002, 1651.38, 1667.03,
    1466.4099999999999, 1989.96, 2119.9100000000003, 1580.6100000000001,
    1218.3799999999999, 1379.0700000000002, 1061.3300000000002, 877.37, 774.66,
    873.8100000000001, 994.6899999999999, 1031, 931.75, 1152.23, 1702.9199999999998,
    1747.96, 1319.8999999999999, 1683.09, 1421.08, 1242.14, 1305.9500000000003,
    1520.44, 1474.58, 1414.6600000000003, 1598.85, 1975.17, 2566.2499999999995,
    2555.61, 2181.45, 2366.0200000000004, 2409.64, 2164.9100000000003,
    1783.4399999999998, 2092.2200000000003, 2612.1200000000003, 2718.17, 2365.75,
    2625.19, 3164.58, 3183.26, 2123.1000000000004, 2377.49, 2443.79, 2118.47,
    1515.19, 1652.63, 1718.2200000000003, 1751.1699999999998, 1904.47, 2388.32,
    2676.17, 2141.89, 1928.77, 2402.79, 2205.68, 1909.08, 1610.82, 1906.22, 1778.68,
    1298.4100000000003, 1333.0700000000002, 1608.5300000000002, 1940.95, 2022.89,
    1807.41, 1967.21, 2207.37, 1849.3100000000002, 1103.58, 1211.56,
    1152.4699999999998, 1064.73, 904.9199999999998, 1157.37, 1481.78, 1876.93,
    2487.16, 2851.54, 3161.89, 3025.87, 2338.41, 2242.72, 1582.53,
    1303.4199999999998, 1302.32, 1464.9, 1516.0200000000002, 1445.0000000000002,
    1575.5900000000001, 2286.7699999999995, 2775.29, 3019.88, 2562.13, 2794.84, 2758,
    2500.88, 1953.4699999999998, 2136.9300000000003, 1926.94, 1432.17, 1204.7,
    1266.25, 1361.5900000000001, 1601.56, 1934.27, 2496.88, 2828.95, 2530.45, 2055.3,
    2304.25, 2611.1099999999997, 2876.65, 2531.1200000000003, 2769.49, 2951.82,
    2892.5700000000006, 2473.71, 2556.82, 2597.43, 2802.17, 2472.46, 2821.07,
    3228.66, 3419.72, 2549.97, 2620.19, 2369.3799999999997, 2039.7, 1781.94, 2255.27,
    2803.87, 2443.08, 2179.27, 2291.35, 2856.0899999999997, 3082.79,
    2803.1500000000005, 2847.51, 3194.8200000000006, 3183.74, 2837.7700000000004,
    2912.48, 3136.68, 2866.31, 2444.7, 2516.54, 2375.35, 1877.39, 1587.85, 1847,
    2247.98, 2642.79, 2640.67, 2905.9, 3126.3300000000004, 2972.95, 2126.78, 2448.04,
    3134.8500000000004, 3343.9, 2916.34, 3014.36, 3128.8700000000003, 3186.03,
    2990.48, 3160.4900000000002, 3562.94, 3672.4399999999996, 3294.6800000000003,
    3347.2200000000003, 3585.94, 3717.66, 3319.71, 3301.68, 3407.02, 3431.79,
    2925.75, 2891.05, 3153.7200000000003, 3371.2999999999997, 3269.67,
    3288.0099999999998, 3547.05, 3559.76, 3200, 3191.23, 3410.9700000000003, 3157.6,
    2817.0899999999997, 2795.58, 3006.7799999999997, 3196.2299999999996, 3016.62,
    3090.5200000000004, 3376.35, 3449.63, 3069.59, 3062.99, 3024.6099999999997,
    2834.6299999999997, 2694, 2817.9300000000003, 3127.96, 3234.21, 2825.24, 2835.51,
    2842.22, 2494.66, 2146.56, 2143.29, 1887.69, 1513.53, 1432.2800000000002,
    1648.93, 1709.2299999999998, 1727.9899999999998, 2005.6800000000003, 2252.59,
    2574.2899999999995, 2603.4900000000002, 2464.6000000000004, 2461.04,
    2679.9399999999996, 2461.55, 2351.95, 2329.6800000000003, 2498.26, 2346.79,
    2269.9500000000003, 2551.31, 2929.55, 2534.0600000000004, 2085.1099999999997,
    1908.4099999999999, 1993.8600000000001, 1866.54, 1572.9699999999998, 1517.88,
    1214.69, 1054.68, 917.87, 987.29, 1097.7399999999998, 1141.84, 1448.45,
    1734.3500000000004, 1974.83, 2137.06, 2324.4700000000003, 2447.7700000000004,
    2523.2500000000005, 2776.66, 2562.2599999999998, 1915.6, 1399.73, 1419.08,
    1836.33, 2159.35, 2820.3399999999997, 3305.2, 2909.73, 2898.03, 2560.55, 2363.07,
    1998.58, 2433.84, 2647.6799999999994, 2654.08, 2391.68, 2270.04, 2110.38,
    2019.6100000000001, 2231.24, 2456.27, 2632.36, 2534.87, 2558.1000000000004,
    2741.1399999999994, 2984.2999999999997, 3134.33, 2921.6, 3002.5, 3028.09,
    2707.6299999999997, 2198.81, 1958.3799999999999, 1639.47, 1245.92, 1836.89,
    2046.9499999999998, 2268.76, 1662.5900000000001, 1457.08, 1680.6000000000001,
    1845.6399999999999, 2011.87, 2248.84, 2146.4, 1869.28, 1592.42, 2022.82, 2015.52,
    2132.7, 2161.45, 2527.85, 2745.93, 3177.4600000000005, 3347.3800000000006,
    3141.1100000000006, 3140.9800000000005, 3385.7400000000002, 3477.8799999999997,
    3211.4799999999996, 3223.61, 3396.3999999999996, 3225.91, 2891.7599999999998,
    3032.1, 3207.96, 2896.7900000000004, 2450.4900000000002, 2258.0600000000004,
    1929.23, 1457.24, 1436.06, 1464.41, 1394.0900000000001, 1312.99, 1515.52,
    1629.5800000000002, 1642.36, 1903.94, 2283.58, 2422.58, 2243.75, 1346.23,
    1266.15, 1201.99, 1075.79, 1000.8000000000001, 1135.17, 1250.53,
    1282.3300000000002, 1375.2, 1568.3500000000001, 1520.44, 1265.93, 1096.48,
    988.6800000000001, 972.52, 957.35, 967.8, 973.24, 1243.07, 1305.59, 1214.78,
    1369.4199999999998, 1561.9099999999999, 1959.8100000000002, 2482.1, 2637.53,
    2631.77, 2712.37, 2644.19, 2568.62, 2776.88, 3124.45, 3382.5599999999995,
    3243.9800000000005, 3226.42, 3475, 3621.89, 3183.5700000000006, 3196.62, 3571.67,
    3841.9900000000002, 3272.0400000000004, 3129.8299999999995, 3246.38,
    3039.850000000001, 2690.35, 2489.13, 2435.74, 2225.46, 2286.3599999999997,
    2314.09, 2293.75, 2295.33, 2022.6399999999999, 1906.76, 1513.97,
  ],
  DNK: [
    884.7, 952.04, 1167.85, 1056.2499999999998, 951.1700000000001, 957.33, 805.66,
    700.3899999999999, 633.62, 750.22, 868.1700000000001, 872.1, 828.65, 1230.99,
    1972.68, 1855.5100000000002, 1567.47, 1370.81, 1397.47, 1475.3700000000001,
    1556.12, 1749.7699999999998, 1842.5100000000002, 1982.9600000000003, 1955.28,
    2127.06, 1965.2699999999998, 1611.98, 1563.91, 2190.25, 2393.91, 2032.83,
    1451.16, 1832.0199999999998, 1961.3000000000002, 1687.9099999999999, 1484.37,
    2171.6600000000003, 1813.9300000000003, 1403.1000000000001, 1083.01,
    1417.0300000000002, 1604.81, 1600.23, 1215.92, 1216.3100000000002, 1128.26,
    1007.36, 794.2200000000001, 744.2299999999999, 862.01, 927.9300000000001,
    1142.95, 1073.18, 1120.97, 994.64, 924.74, 1172.58, 1648.91, 2217.74, 2374,
    2402.92, 1865.46, 1231.04, 839.0000000000001, 1020.03, 1107.34, 1077.78, 1048.23,
    1345.38, 1033.27, 1016.29, 1062.61, 1382.5600000000002, 1484.27, 1105.28, 926.34,
    1276.73, 1394.1, 937.1700000000001, 677.53, 623.2, 651.17, 633.46, 582,
    623.0699999999999, 611.52, 550.73, 538.9, 555.63, 720.06, 653.99, 662.57, 572.92,
    675.4, 617.5699999999999, 685.58, 932.19, 1124.1999999999998, 1107.7199999999998,
    670.8, 696.05, 548.51, 499.16, 573.5500000000001, 735.75, 706.9499999999999,
    656.78, 697.8299999999999, 718.06, 713.92, 572.27, 539.5999999999999, 818.09,
    1116.33, 1100.8700000000001, 997.23, 1100.21, 909.69, 777.88, 688.3599999999999,
    781.6199999999999, 543.18, 482.46999999999997, 478.09, 577.79, 600.72, 689.62,
    716.5, 771.18, 663.7499999999999, 553.81, 441.22, 501.62, 539.3, 613.76, 568.99,
    592.14, 642.15, 751.78, 797.13, 1046.1100000000001, 1096.65, 987.64, 843.35,
    913.4200000000001, 778.86, 816.2900000000001, 884.1600000000001, 1320.28,
    1475.42, 1396.48, 1090.56, 1442.51, 1952.4, 1660.36, 1153.71, 1097.57, 928.61,
    804.0700000000002, 699.51, 750.0899999999999, 875.42, 887.48, 885.02, 884.26,
    863.1899999999999, 843.28, 876.7199999999999, 1519.1100000000001, 1520.11,
    1236.3999999999999, 1104.03, 1091.3, 1198.66, 1058.8500000000001, 1399.69,
    1563.1699999999998, 1562.34, 1265.85, 1094.8, 1219.4899999999998, 1076.37,
    712.1500000000001, 662.67, 655.5, 630.2399999999999, 485.51, 481.65000000000003,
    620.77, 893.75, 1034.55, 748.9300000000001, 741.9499999999999, 869.8000000000001,
    781.26, 1170.25, 1016.22, 867.98, 744.57, 582.31, 825.16, 764.6099999999999,
    566.41, 514.25, 631.45, 668.66, 672.91, 649.48, 782.28, 789.85, 558.69, 572.16,
    566.34, 581.43, 641.52, 712.32, 882.2900000000001, 939.8199999999999, 771.22,
    677.62, 854.71, 947.79, 1037.97, 869.54, 1045.21, 1049.98, 1067.3, 1069.06,
    1273.06, 1232.03, 1035.49, 808.6399999999999, 959.36, 877.4100000000001,
    791.4799999999999, 664.81, 603.12, 663.17, 707.32, 800.65, 793.27,
    1002.5600000000002, 1061.03, 825.7800000000001, 848.91, 1169.8300000000002,
    1075.55, 966.5100000000001, 974.5699999999999, 906.89, 796.9799999999999, 827.23,
    815.09, 699.37, 700.95, 705.29, 717.2900000000001, 749.8000000000001, 822.64,
    913.28, 1106.5300000000002, 1113.68, 1163.8, 1068.59, 1280.26, 1024.94, 1199.99,
    1159.98, 1371.8, 1176.1, 1145.85, 1137.39, 802.63, 767.57, 884.76,
    819.6200000000001, 759.26, 772.68, 865.93, 854.97, 848.9099999999999, 808.05,
    894.2, 1044.8600000000001, 1360.06, 1368.4600000000003, 1311.38,
    1035.0900000000001, 1013.2700000000002, 898.21, 735.2, 669.69, 716.66,
    694.5799999999999, 769.98, 706.09, 751.62, 727.5600000000001, 680.92, 642.24,
    538.15, 566.18, 676.49, 707.8299999999999, 1010.3299999999999, 1039.47,
    851.9399999999998, 780.15, 813.63, 796.88, 883.8299999999999, 759.01, 759.36,
    812.0699999999999, 801.3399999999999, 1051.56, 1138.1399999999999, 1117.99,
    1196.34, 867.38, 968.35, 902.63, 669.41, 510.94, 539.89, 494.26, 531.34, 575.07,
    558.22, 599.27, 687.86, 809.7099999999999, 848.1099999999998, 932.54, 888.67,
    1080.53, 1298.51, 1257.2800000000002, 1255.5, 1074.3, 1068.89, 660.58, 640.26,
    608.41, 605.32, 743.1600000000001, 974.08, 729.32, 803.52, 858.0799999999999,
    605.1700000000001, 550.1899999999999, 572.8000000000001, 690.88,
    745.5200000000001, 611.35, 816.76, 622.6999999999999, 562.18, 714.3999999999999,
    1080.02, 1100.93, 965.1199999999999, 932.1899999999999, 916.5100000000001,
    824.4000000000001, 734.2, 668.84, 700.9100000000001, 829.0799999999999, 826.7,
    956.91, 899.6, 855.18, 637.0799999999999, 593.8299999999999, 774.3399999999999,
    865.27, 655.35, 636.5600000000001, 898.9000000000001, 589.9200000000001, 570.53,
    736.97, 813.1500000000001, 655.2299999999999, 438.95000000000005, 504.92,
    560.8000000000001, 553.31, 611.02, 587.94, 694.9300000000001, 868.9799999999999,
    842.44, 544.5899999999999, 547.14, 553.28, 381.13000000000005,
    287.32000000000005, 265.98, 312.87, 404.59999999999997, 258.85, 295.12, 318.83,
    390.21000000000004, 378.24, 480.39, 404.50000000000006, 425.51,
    384.40999999999997, 568.09, 531.91, 302.37, 267.54, 404.46000000000004, 413.51,
    468.25, 718.0200000000001, 613.3299999999999, 521.8100000000001, 593.25, 624.49,
    657.29, 743.37, 1270.4399999999998, 1070.77, 1000.97, 1037.2299999999998,
    1481.04, 1480.73, 1181.9499999999998, 907.41, 907.84, 678.69, 648.3299999999999,
    504.14, 631.55, 775.1499999999999, 774.77, 761.7900000000001, 936.66, 726.23,
    836.6300000000001, 764.51, 956.66, 1121.63, 953.34, 1294.02, 1777.26,
    1414.0600000000002, 990.16, 1017.0699999999999, 1146.32, 1168.28, 1230.87,
    1340.28, 1419.79, 1558.5, 1150.69, 1282.12, 1186.4800000000002,
    842.5500000000001, 810.1800000000001, 840.6499999999999, 988.2, 1011.5,
    964.6500000000001, 739.6999999999999, 509.22, 781.4499999999999, 611.38, 575.21,
    427.21, 505.90999999999997, 479.49999999999994, 579.71, 631.59,
    461.29999999999995, 430.85999999999996, 378.64, 340.52, 367.99999999999994,
    553.7600000000001, 475.36999999999995, 281.54, 281.77000000000004, 375.73,
    312.35, 312.21000000000004, 339.9599999999999, 323.89, 401.75000000000006,
    658.8900000000001, 680.17, 586, 633.47, 906.0699999999999, 670.82,
    717.3199999999999, 641.4899999999999, 501.95, 594.2, 583.17, 698,
    745.4999999999999, 647.76, 564.98, 770.25, 1051.57, 916.84, 688.64, 742.79,
    799.39, 657.22, 726.4300000000001, 631.3, 534.78, 546.11, 663.89, 683.84, 929.76,
    836.77, 715.48, 648.17, 726.5799999999999, 637.5699999999999, 754.78, 637.09,
    425.95000000000005, 377.06999999999994, 413.85, 312.98, 290.32, 361.01,
    509.9000000000001, 390.06, 261.8, 286.44, 451.58, 332.84999999999997,
    264.96000000000004, 289.01, 321.64, 272.11, 240.64, 251.02999999999997, 312.69,
    269.49, 270.62, 340.98, 408.34999999999997, 404.25, 514.07, 401.45,
    495.79999999999995, 547.68, 488.28000000000003, 595.88, 519.63, 402.23, 300.05,
    279.99, 279.65, 266.81, 258.7, 236.68, 258.26, 266.72, 374.36, 460.07,
    622.5500000000001, 818.68, 844.4699999999999, 782.96, 675.4399999999999, 623.01,
    826.6800000000001, 527.77, 528.51, 580.32, 553.39, 446.96, 713.3000000000001,
    656.29, 395.4599999999999, 478.14, 585.33, 789.8700000000001, 1293.62, 814.81,
    612.12, 611.47, 846.72, 364.19, 348.82, 476.02000000000004, 598.27, 500.38,
    556.15, 495.43999999999994, 633.19, 431.03000000000003, 430.8400000000001,
    461.06999999999994, 589.5699999999999, 490.04, 471.52, 497.51, 365.47, 293.05,
    491.05, 439.48, 213.51, 250.43, 396.67999999999995, 236, 485.58, 716.35, 607.71,
    584.73, 432.19, 306.3, 333.95, 361.99, 420.11, 417.54999999999995,
    427.02000000000004, 468.24, 682.3299999999999, 555.38, 407.63, 401.69, 469.04,
    294.83, 538.56, 497.59000000000003, 240.28, 226.27999999999997,
    528.4399999999999, 447.8399999999999, 226.04, 237.97000000000003, 267.86,
    356.53999999999996, 429.25, 395.72999999999996, 545.0400000000001,
    451.07000000000005, 338.09999999999997, 345.33000000000004, 432.68,
    491.65999999999997, 644.9499999999998, 593.0899999999999, 491.04999999999995,
    557.9399999999999, 983.2400000000001, 627.5500000000001, 516.06, 475.26, 509.22,
    450.51, 521.4499999999999, 505.22, 516.02, 553.87, 576.74, 564.3699999999999,
    586.1299999999999, 557.51, 442.2, 461.14000000000004, 688.61, 653.55,
    375.56000000000006, 511.70000000000005, 701.71, 500.76, 342.26, 298.59, 320.76,
    405.16, 424.12, 732.64, 682.2, 793.51, 494.16, 524.71, 459.17, 401.31, 653.23,
    515.27, 337.3, 310.08, 667.99, 576.1, 445.07000000000005, 505.67,
    527.8199999999999, 706.8299999999999, 863.05, 793.65, 648.19, 640.4000000000001,
    816.8, 883.75, 577.78, 732.8900000000001, 862.6999999999999, 727.72, 530.84,
    555.64, 775.08, 789.37, 604.38, 402.8299999999999, 419.25, 588.9, 565.19,
    636.6899999999999, 897.6999999999999, 635.97, 962.8000000000001, 674.57,
    570.4300000000001, 646.8499999999999, 526.6, 445.89, 600.27, 459.25, 410.78,
    374.51, 365.54, 405.68, 417.58, 553.71, 596.34, 497.35, 482.14000000000004,
    471.25, 373.23, 376.6, 439.01, 392.06999999999994, 393.28999999999996, 754.23,
    759.0699999999999, 747.27, 498.95, 524.67, 701.21, 615.5, 682.01, 751.88, 693.67,
    762.5, 1305.79, 996.87, 736.85, 490.30000000000007, 400.35999999999996,
    372.53000000000003, 462.39, 565.4300000000001, 910.9499999999999,
    813.4399999999999, 656.4300000000001, 622.5400000000001, 847.8600000000001,
    768.3100000000001, 768.3699999999999, 545.11, 347.63, 323.58000000000004, 626.62,
    712.36, 555.8499999999999, 517.99, 822.93, 637.9100000000001, 418.89, 422.74,
    414.82, 698.4499999999999, 948.18, 604.59, 627.63, 640.36, 662.0799999999999,
    606.5699999999999, 544.11, 389.80000000000007, 371.0300000000001,
    399.35999999999996, 419.96, 525.27, 748.6700000000001, 672.1, 504.42999999999995,
    637.76, 751.08, 743.99, 712.26, 735.55, 753.7699999999999, 476.41,
    740.8100000000001, 750.5799999999999, 746.97, 679.76, 504.52, 488.34, 645.69,
    687.8, 585.37, 621.91, 661.6599999999999, 519.96, 476.48, 504.51,
    560.6800000000001, 627.73, 567.41, 643.07, 609.39, 528.46, 586.12,
    586.0500000000001, 776.4300000000001, 792.2800000000002, 575.9399999999999,
    631.4, 898.08, 598.66, 613.6300000000001, 585.75, 409.64, 420.47999999999996,
    689.3, 742.99, 912.3500000000001, 842.5100000000001, 782.89, 727.6800000000001,
    897.72, 761.39, 493.72999999999996, 518.37, 716.23, 780.4100000000001, 563.01,
    581.38, 826.1700000000001, 846.5899999999999, 685.31, 607.7, 838.4299999999998,
    755.54, 692.78, 743.9300000000001, 852.36, 721.27, 746.1800000000001, 573.52,
    513, 623.04, 679.25, 810.19, 1100.6100000000001, 860.35, 672.6100000000001,
    825.8499999999999, 921.6000000000001, 794.31, 754.9599999999999, 686.37, 762.13,
    647.15, 589.1399999999999, 600.03, 831.5, 476.77, 523.51, 458.9,
    383.50000000000006, 380.21000000000004, 519.3199999999999, 482.33000000000004,
    393.45, 372.66999999999996, 663.5, 610.56, 663.6100000000001, 711.96, 609.48,
    676.26, 602.3000000000001, 492.88, 452.60999999999996, 426.02,
    460.34000000000003, 720.8100000000002, 581.8, 793.0899999999999, 1008.7,
    997.0899999999999, 753.01, 560.54, 487.9, 653.76, 613.1099999999999,
    653.3499999999999, 894.7, 873.6700000000001, 560.38, 604.22, 937.58,
    837.6499999999999, 583.55, 538.5699999999999, 617.83, 773.31, 719.78,
    707.5200000000001, 667.4399999999999, 465.99, 433.47, 462.92999999999995, 553.65,
    565.57, 604.2700000000001, 538.65, 447.14, 493.47, 522.34, 469.53000000000003,
    407.9, 489.26, 524.1700000000001, 427.30000000000007, 378.14000000000004, 540.47,
    580.39, 674.95, 459.96, 529.39, 566.08, 420.42999999999995, 405.40000000000003,
    366.55999999999995, 318.56, 514.1, 739.97, 774.85, 540.6199999999999,
    521.4200000000001, 576.17, 599.99, 493.56999999999994, 532.43,
    446.57000000000005, 493.7800000000001, 461.52000000000004, 617.6800000000001,
    875.91, 771.25, 911.7700000000001, 517.12, 641.9799999999999, 559.8199999999999,
    561.25, 590.3299999999999, 540.26, 474.76, 605.48, 666.61, 479.29, 536.37,
    487.18, 544.18, 511.82, 505.88, 510.8299999999999, 632.42, 904.52, 997.68,
    658.61, 676.07, 540.6400000000001, 308.07000000000005, 457.4, 457.86,
    246.90000000000003, 260.71999999999997, 296.07, 337.31, 325.03, 355.29, 391.51,
    478.7099999999999, 461.27, 371.54999999999995, 470.04999999999995, 407.4, 429.4,
    476.19999999999993, 515.8000000000001, 365.22, 258.75, 277.51, 338.5, 368.29,
    270.14, 384.19, 423.83000000000004, 432.92, 398.58000000000004,
    531.6700000000001, 580.0600000000001, 726.57, 810.76, 590.23, 541.28, 387.78,
    454.67999999999995, 442.72999999999996, 589.73, 701.6399999999999, 691.4, 552.19,
    791.31, 840.14, 964.45, 987.9, 870.86, 700.0999999999999, 791.29, 847.56, 683.57,
    750.57, 854.9000000000001, 865.5600000000002, 742.5699999999999, 676.92, 701.17,
    779.3000000000001, 671.4499999999998, 634.54, 561.4200000000001, 638.67, 639.96,
    636.62, 631.75, 548.4399999999999, 591.19, 621, 460.92, 479.2, 592.2,
    660.3399999999999, 640, 814.09, 617.77, 749.6800000000001, 796.79, 741.3, 675.5,
    586.4399999999999, 366.91999999999996, 276.04999999999995, 266.15, 476.16,
    652.82, 544.62, 387.74, 345.15, 516.5699999999999, 751.39, 531.3499999999999,
    510.17, 565.6, 398.38000000000005, 387.56000000000006, 333.60999999999996,
    293.02, 340.48, 718.69, 771.61, 688.6899999999999, 647.53, 510.01,
    408.03000000000003, 416.71, 415.01, 305.08, 335.09, 364.84, 398.58,
    474.25999999999993, 560.24, 555.55, 495.31, 496.42, 720.75, 990.77, 887.29,
    878.6299999999999, 848.91, 860.42, 706.14, 659.5799999999999, 748.4200000000001,
    744.98, 498.18999999999994, 576.02, 724.75, 572.13, 565.89, 378.64000000000004,
    712.2, 786.3399999999999, 730.51, 562.34, 702.8900000000001, 723.97, 689.54,
    712.5, 847.4399999999999, 808.19, 775.82, 439.47, 332.19, 332.13,
    366.90000000000003, 352.99, 432.92, 533.08, 528.7, 445.62, 404.92,
    433.46999999999997, 648.1100000000001, 692.6, 640.7500000000001,
    500.65999999999997, 483.42, 524.84, 659.3300000000002, 697.25, 786.1300000000001,
    789.91, 829.24, 565.78, 550.16, 341.1, 347.84999999999997, 358.93000000000006,
    333.46, 361.34999999999997, 637.66, 732.33, 870.5600000000001, 935.5799999999999,
    940.47, 741.98, 643.95, 744.07, 806.8599999999999, 518.56, 475.27,
    562.8199999999999, 496.27000000000004, 374.96, 422.57000000000005, 325.28,
    555.31, 859.53, 747.73, 766.8399999999999, 519.5799999999999, 489.77, 594.16,
    692.37, 712.66, 644.45, 695.21, 855.47, 900.67, 651.24, 886.19, 1089.31, 1153.2,
    1294.33, 1293.5200000000002, 962.6, 965.76, 585.25, 581.21, 467.67, 543.11,
    650.29, 579.8, 695.51, 912.7099999999999, 942.8399999999999, 996.6899999999999,
    1212.15, 1017.23, 760.77, 492.13, 450.33, 533.7, 661.97, 487.99000000000007,
    392.75, 350.25, 292.36, 291.99, 254.12999999999997, 254.89000000000001, 310.39,
    573.9300000000001, 806.5300000000001, 1024.2, 857.3900000000001,
    501.36000000000007, 392.96, 451.78000000000003, 547.06, 938.9100000000001,
    1147.42, 1149.23, 990.9000000000001, 924.75, 1090.6899999999998, 1150.5, 1139.55,
    939.4599999999999, 1265.94, 1237.8899999999999, 1056.6699999999998, 807.85,
    1416.23, 1428.27, 1176.22, 789.0799999999999, 1414.8899999999999, 1042.96,
    715.43, 841.4000000000001, 931.9499999999999, 1229.22, 1133.39,
    1122.6699999999998, 1200.44, 1336.58, 1122.16, 1083.76, 1472.87,
    1595.3899999999999, 1383.73, 1239.84, 1632.73, 1701.52, 1351.5400000000002,
    1095.21, 1193.72, 971.82, 571.46, 502.84, 739.45, 996.6400000000001, 837.78,
    662.9300000000001, 726.59, 624.35, 377.51, 279.4, 362.65, 406.76, 429.51,
    341.78000000000003, 407.15999999999997, 429.2, 482.12, 580.92, 678.4699999999999,
    713.01, 796.64, 1039.55, 1941.8700000000001, 1933.7799999999997,
    1175.0099999999998, 778.9399999999999, 982.1100000000001, 1261.77, 1180.76,
    901.77, 1342.6399999999999, 1571.37, 1445.63, 1206.9, 1759.85, 1317.77, 901.46,
    597.9300000000001, 742.63, 817.9100000000001, 693.8000000000001, 675.28, 565.72,
    432.83, 383.49, 428, 395.78999999999996, 402.89, 382.37, 404.01, 426.75,
    464.96000000000004, 538.71, 734.37, 1092.98, 1288.97, 701.8199999999999, 677.25,
    636.0600000000001, 942.76, 1129.61, 1112.7399999999998, 1063.44, 871.44,
    739.0400000000001, 481.09999999999997, 435.98, 676.75, 783.4699999999999, 656.99,
    771.55, 773.6300000000001, 503.66, 482.08, 594.0799999999999, 815.29, 777.51,
    719.4000000000001, 835.04, 849.05, 857.01, 884.1600000000001, 1327.6100000000001,
    1294.6000000000001, 1115.38, 837.7399999999999, 922.6999999999999, 630.84,
    524.1899999999999, 508.32000000000005, 815.26, 1093.38, 1113.43,
    675.0999999999999, 521.7099999999999, 506.28, 608.14, 503.01000000000005, 567.09,
    601.22, 488.27000000000004, 442.40999999999997, 548.56, 733.49, 825.72, 834.05,
    1700.9899999999998, 1844.7399999999998, 1495.21, 1422, 1528.05,
    1555.3799999999999, 1446.53, 1540.3199999999997, 1527.37, 1570.0600000000002,
    1491.8100000000002, 1444.09, 1109.6599999999999, 1034.02, 993.8799999999999,
    817.51, 621.37, 454.59999999999997, 441.75, 544.43, 522.62, 425, 394.78, 541.55,
    357.92, 310.50000000000006, 272.59, 362.42999999999995, 430.67999999999995,
    579.07, 495.64, 407.14, 438.59, 427.87, 353.24, 696.45, 550.6, 527.6999999999999,
    400.14000000000004, 332, 367.85, 481.21999999999997, 357.4200000000001,
    321.71999999999997, 345.82, 317.79999999999995, 501.68, 701.3499999999999,
    447.30999999999995, 417.41, 366.37, 347.32, 468.46000000000004, 531.85, 733.78,
    765.18, 766.23, 617.51, 542.32, 481.9800000000001, 573.5600000000001,
    759.0999999999999, 663, 616.06, 713.2600000000001, 902.8299999999999, 884.73,
    808.6, 856.55, 1008.24, 911.4100000000001, 777.08, 843.38, 795.64, 673.83,
    579.43, 404.78000000000003, 340.09, 280.03, 259.64, 396.65, 402.65,
    400.55999999999995, 519.87, 483.12, 363.78, 269.78999999999996,
  ],
  ESP: [
    811.8000000000001, 691.5999999999999, 533.45, 550.51, 617.05, 497.78000000000003,
    452.2, 479.15, 460.11999999999995, 452.63, 589.6099999999999, 724.24, 671.88,
    676.72, 766.2, 846.69, 741.13, 518.9, 421.47, 553.8100000000001,
    561.0400000000001, 471.53, 456.8, 634, 670.1, 545.4300000000001, 496.25, 639.9,
    744.21, 830.19, 957.8699999999999, 1268.27, 1350.36, 1506.5800000000002, 1550.22,
    1580.6499999999999, 1362.5299999999997, 1365.3000000000002, 1284.3400000000001,
    1344.1100000000001, 1097.17, 1159.6399999999999, 1094.66, 1288.56, 1201.77,
    1072.8, 1051.04, 1237.32, 850.23, 737.2400000000001, 800.0600000000001, 913.97,
    776.14, 627.3, 549.76, 674.01, 773.89, 772.23, 760.23, 846.7900000000001, 775.66,
    717.2500000000001, 558.4499999999999, 520.98, 458.08, 387.05, 375, 437.41,
    453.05, 430.46, 591.7900000000001, 879.8999999999999, 671.95, 543.05, 563.49,
    665.3800000000001, 706.3100000000001, 701.01, 653.15, 830.34, 797.7099999999999,
    657.5, 580.29, 735.9200000000001, 644.01, 565.3499999999999, 583.6, 806.23,
    808.94, 832.8700000000001, 819.8900000000001, 1084.3200000000002,
    915.6099999999999, 805.08, 806.2299999999999, 1016, 905.1899999999999,
    908.3199999999999, 849.0500000000001, 1065.16, 891.98, 796.8699999999999,
    777.9200000000001, 936.8100000000001, 873.91, 700.7799999999999, 625.91, 762.71,
    794.0899999999999, 605.8899999999999, 543.3600000000001, 654.72, 794.54, 759.49,
    823.63, 992.28, 956.99, 929.1899999999999, 927.8699999999999, 1089.42, 1033.01,
    1004.5, 870.5100000000001, 1013.38, 829.55, 765.03, 666.99, 769.69, 676, 587.23,
    616.99, 716.3399999999999, 737.16, 612.04, 607.79, 883.96, 996.09,
    793.1599999999999, 616.1, 987.94, 1098.44, 933.06, 907.4300000000001, 1168.1,
    936.15, 772.92, 589.78, 687.79, 578.62, 573.4300000000001, 491.22, 617.01,
    556.5699999999999, 522.6600000000001, 580.89, 525.14, 469.68, 529.02,
    649.3299999999999, 479.23999999999995, 372.83, 363.38, 354.97,
    390.18999999999994, 528.1600000000001, 507.06000000000006, 467.5, 532.35, 491.13,
    456.3, 487.68000000000006, 678.43, 720.55, 759.26, 674.46, 837.82,
    851.0599999999998, 752.15, 676.74, 732.01, 651.89, 628.64, 607.87,
    767.8299999999999, 694.3100000000001, 619.58, 561.24, 731.06, 706.6399999999999,
    537.45, 574.77, 831.01, 900.18, 687.01, 575.17, 740.5, 752.0200000000001,
    617.0699999999999, 569.3499999999999, 761.26, 750.4, 645.31, 634.77, 947.08,
    817.4499999999999, 701.0699999999999, 614.85, 682.5, 542.25, 471.59999999999997,
    414.15, 480.16999999999996, 423.28000000000003, 412.15, 435.53,
    470.67999999999995, 474.60999999999996, 417.71000000000004, 426.15000000000003,
    503.33000000000004, 540.4300000000001, 482.99, 433, 426.03, 488.2900000000001,
    502.06, 454.32000000000005, 450.61999999999995, 451.88, 428.46000000000004,
    450.63, 537.75, 521.3299999999999, 500.65999999999997, 485.6000000000001, 696.63,
    549.6999999999999, 491.56, 408.01, 430.26, 439.71, 404.90999999999997,
    383.70000000000005, 483.1000000000001, 457.57000000000005, 424.95, 395.73,
    425.98999999999995, 515.38, 428.21000000000004, 390.31, 459.54, 493.22, 418.28,
    418.24000000000007, 513.59, 518.63, 569.5, 518.14, 1018.45, 799.19, 643.76,
    542.8500000000001, 775.1700000000001, 457.7, 399.40999999999997, 380.51,
    510.6600000000001, 435.98999999999995, 360.99, 368.98, 421.93999999999994,
    430.34000000000003, 438.24000000000007, 404.75, 486.20000000000005, 544.52,
    522.6, 478.8, 476.63, 540.73, 444.56, 481.87999999999994, 865.3299999999999,
    778.97, 693.5300000000001, 613.23, 1137.16, 838.78, 753.31, 667.61, 1113.41,
    784.66, 676.92, 567.59, 875.0500000000001, 706.92, 604.49, 575.5, 971.57, 865.05,
    609.0000000000001, 560.4, 876.49, 815.61, 591.5799999999999, 577.79, 1010.01,
    939.54, 809.71, 833.9, 1100.8300000000002, 1038.12, 821.8299999999999,
    694.0899999999999, 1090.55, 804.3199999999999, 722.88, 637.7099999999999, 871.99,
    655.8399999999999, 601.22, 561.35, 763.81, 673.7, 646.88, 550.3299999999999,
    751.73, 539.27, 448.9, 443.95000000000005, 535.52, 600.61, 557.22, 500.77,
    664.03, 704.7099999999999, 623.53, 513.97, 686.9, 483.27000000000004, 462.76,
    449.22999999999996, 577.62, 410.04999999999995, 416.21000000000004,
    416.86999999999995, 439.19, 458.85, 424.41999999999996, 389.76, 396.56, 519.81,
    502.66999999999996, 432.27000000000004, 621.59, 676.0500000000001, 520.01,
    451.59, 584.85, 651.4, 507.95, 397.88, 493.37, 541.6500000000001, 445.82,
    449.99000000000007, 592.1400000000001, 588.44, 546.11, 448.67, 640.83, 561,
    524.92, 467.78000000000003, 726.52, 633.6600000000001, 550.0799999999999, 499.74,
    616.3500000000001, 535.1, 482.04999999999995, 405.7, 461.22, 479.30999999999995,
    414.65, 427.87, 564.3299999999999, 625.1000000000001, 553.71, 524.15,
    665.8399999999999, 571.3, 533.98, 460.2299999999999, 559.4300000000001, 528.47,
    483.5199999999999, 530.87, 764.5799999999999, 728.9300000000001, 571.54,
    502.81000000000006, 691.64, 618.46, 548.66, 509.01, 792.3199999999999, 729.24,
    643.65, 525.89, 831.63, 808.1700000000001, 547.84, 460.16, 742.31,
    743.4100000000001, 519.1800000000001, 483.93999999999994, 661.44,
    671.9300000000001, 508.35999999999996, 453.96999999999997, 642.5999999999999,
    635.95, 504.29, 476.09000000000003, 593.53, 549.95, 491.78000000000003, 437.15,
    577.44, 528.2800000000001, 456.57, 407.07, 532.9699999999999, 580.0500000000001,
    499.15999999999997, 469.32000000000005, 687.49, 583.42, 397.57, 396.86, 521.39,
    639.77, 473.11, 405.28, 519.17, 553.49, 400.34999999999997, 398.68, 528.34,
    511.14000000000004, 430.42, 406.71999999999997, 562.65, 540.71,
    438.21999999999997, 436.55, 782.6100000000001, 735.62, 626.0799999999999, 532.77,
    879.39, 910.9200000000001, 703.4, 539.9000000000001, 788.84, 647.7, 498.94,
    449.01, 774.2099999999999, 900.8399999999999, 649.83, 603.49, 843.7199999999999,
    980.9799999999999, 822.45, 760.12, 956.8, 904.5, 660.2999999999998,
    538.1500000000001, 709.1700000000001, 666.9300000000001, 494.52, 481.42,
    548.8900000000001, 642.23, 455.77, 476.22, 689.4799999999999, 663.95,
    492.4100000000001, 452.97, 696.23, 619.2, 441.66999999999996, 437.82, 667.44,
    724.42, 539.22, 473.55999999999995, 781.88, 884.98, 715.05, 499.06, 853.18,
    806.8399999999998, 582.86, 553.63, 677.16, 577.3000000000001, 525.98, 522.87,
    735.1999999999999, 689.7900000000001, 484.37, 467.52, 792.72, 733.3599999999999,
    503.26000000000005, 483.75, 706.91, 704.23, 535.41, 519.88, 693.11, 837.48,
    580.26, 560.64, 766.6099999999999, 775.3000000000001, 523.52, 456.27000000000004,
    594.24, 520.74, 465.83, 457.71, 605.8100000000001, 607.75, 521.3399999999999,
    458.24, 735.3900000000001, 706.8199999999999, 553.92, 516.39, 937.9300000000001,
    940.4399999999999, 748.43, 523.14, 840.8199999999999, 807.19, 548.76,
    508.91999999999996, 767.74, 874.62, 619.5600000000001, 557.3399999999999, 780.78,
    854.31, 507.73, 499.9599999999999, 727.29, 774.0699999999999, 532.74,
    490.81000000000006, 717.5999999999999, 688.0999999999999, 447.64000000000004,
    438.89, 770.9000000000001, 769.28, 556.97, 491.63, 772.02, 782.8800000000001,
    554.9100000000001, 549.14, 900.8800000000001, 825.5899999999999,
    507.51000000000005, 481.29, 799.58, 910.01, 610.93, 544.05, 687.86,
    801.3900000000001, 505.84000000000003, 470.2, 682.76, 672.5799999999999,
    475.44000000000005, 463.9, 750.2, 777.82, 575.26, 525.66, 734.3699999999999,
    691.29, 527.21, 460.0799999999999, 604.05, 513.06, 472.78999999999996, 450.37,
    475.51, 481.91999999999996, 436.85, 426.67, 441.02000000000004,
    501.66999999999996, 405.48, 410.15999999999997, 498.74, 601.03,
    506.71999999999997, 516.65, 815.29, 886.52, 608.61, 513.05, 1145.96, 1224.71,
    687.0999999999999, 522.98, 994.9499999999999, 895.45, 579.05, 557.03,
    876.6999999999999, 844.28, 653.25, 512.0999999999999, 761.12, 852.11,
    692.3599999999999, 488.95, 674.4699999999999, 580.06, 485.91999999999996, 469.14,
    659.26, 661.2900000000001, 553.6899999999999, 503.32000000000005, 745.13,
    805.3299999999999, 593.6500000000001, 513.59, 806.2500000000001, 769.38, 555.6,
    495.17, 779.48, 925.74, 577.1400000000001, 466.77000000000004, 785.89, 815.33,
    505.91999999999996, 407.23, 571.67, 657.3, 431.53999999999996, 411.88, 588.99,
    722.42, 498.84000000000003, 417.96999999999997, 609.22, 708.13,
    445.37000000000006, 367.79, 761.2299999999999, 752.13, 532.42, 495.04, 782.72,
    940.81, 624.38, 525.23, 747.21, 772.8, 606.39, 527.16, 887.35, 913.78, 613.63,
    481.36, 818.74, 786.25, 452.37000000000006, 403.96000000000004, 703.4, 704.62,
    483.91999999999996, 416.93, 595.3599999999999, 635.1, 416.32, 447.76, 822.92,
    816.15, 535.53, 473.84, 860.73, 857.3000000000001, 592.53, 564.66,
    928.6200000000001, 1043.53, 689.48, 471.07, 765.9399999999999, 819.12, 597.94,
    483.61, 745.51, 776.8399999999999, 550.73, 463.18, 835.6200000000001,
    976.0300000000001, 601.8500000000001, 475.67999999999995, 704.8300000000002,
    711.02, 494.14, 440.69, 691.9499999999999, 632.4699999999999, 464.18, 458.14,
    774.86, 723.46, 506.38, 441.09999999999997, 786.51, 721.01, 420.78999999999996,
    437.67999999999995, 821.26, 830.7, 477.41, 431.96000000000004, 789.0799999999999,
    754.02, 425.22, 380.94, 526.04, 704.1999999999999, 488.71, 433.08,
    753.1300000000001, 887.74, 476.18, 437.65, 771.49, 723.6199999999999, 482.85,
    488.84999999999997, 1051.1399999999999, 1076.04, 565.67, 480.85, 1182.6, 1082.69,
    553.51, 488.28999999999996, 887.09, 748.4799999999999, 533.22, 456.53,
    837.2500000000001, 697.54, 459.66, 452.85, 856.3399999999999, 914.2399999999999,
    508.82000000000005, 418.73999999999995, 806.8499999999999, 784.48, 455.78,
    476.72999999999996, 876.0899999999999, 936.51, 580.28, 493.24, 929.48, 984.28,
    633.4000000000001, 543.3199999999999, 1144.27, 1226.22, 818, 782.4399999999999,
    1323.86, 1369.7399999999998, 838.9200000000001, 638.78, 1238.56, 939.3, 488.69,
    417.39000000000004, 700.51, 747.43, 506.21000000000004, 467.71999999999997,
    766.73, 780.2499999999999, 469.99999999999994, 451.53999999999996,
    886.3199999999999, 926.0200000000001, 593.6600000000001, 534.21, 1025.18,
    1070.55, 692.1300000000001, 591.54, 1025.91, 977.5500000000001,
    573.1899999999999, 514.63, 928.1600000000001, 1054.92, 650.83, 562.01, 1068.05,
    1135.83, 544.97, 415.96999999999997, 838.6899999999999, 768.06, 485.5, 424.36,
    937.62, 1082.54, 981.0300000000001, 837.67, 1235.5, 1175.79, 800.3299999999999,
    584.96, 1205.23, 1422.82, 840.1700000000001, 705.75, 1306.3200000000002, 1417.91,
    841.4100000000001, 671.5799999999999, 1098.71, 1071.4299999999998, 633.98,
    522.37, 898.47, 947.0100000000001, 524.6299999999999, 440.96, 897.1999999999999,
    972.45, 556.39, 441.92, 1082.04, 1240.8799999999999, 673.88, 514.88, 1102.43,
    1144.31, 700.5500000000001, 525.39, 990.2199999999999, 821.25, 551.8000000000001,
    494.85999999999996, 941.1700000000001, 908.19, 573.68, 508.66999999999996,
    1019.29, 1049.4199999999998, 619.68, 504.90000000000003, 951.4, 814.13,
    491.14000000000004, 421.62, 865.3199999999999, 748.89, 512.02, 446.37,
    888.1500000000001, 968.4399999999999, 655.35, 508.99, 991.91, 947.55, 655.71,
    540.59, 1023.02, 873.24, 622.6, 518.2900000000001, 796.3199999999999, 783.44,
    479.62999999999994, 451.9, 749.24, 789.5, 505.65, 461.9699999999999, 837.87,
    806.25, 502.47, 465.18, 840.48, 933.63, 558.63, 432.07, 764.38,
    782.4300000000001, 528.5899999999999, 499.86, 998.29, 918.8500000000001, 587.95,
    453.96, 802.75, 709.33, 451.64, 507.01, 1200.3500000000001, 1239.57, 726.44,
    561.43, 1098.9899999999998, 1122.8400000000001, 678.48, 566.74, 1112.33,
    770.8899999999999, 429.59999999999997, 384.27, 769.2499999999999,
    682.9499999999999, 433.6, 379.90999999999997, 753.93, 778.55, 560.66, 631.88,
    1290.99, 1291.96, 789.7099999999999, 655.99, 1408.48, 1416.46, 837.45, 577.95,
    1046.99, 1100.63, 860.9, 739.84, 1215.48, 1202.37, 828.66, 665.61,
    1182.3899999999999, 1146.23, 738.5699999999999, 640.4200000000001, 1262.71,
    1375.42, 786.3600000000001, 591.63, 1295.66, 1314.0500000000002, 911.14,
    745.0999999999999, 1071.4299999999998, 974.8599999999999, 890.64, 685.27, 1064.2,
    930.22, 727.02, 596.6600000000001, 1071.4199999999998, 1008.9300000000001, 710.1,
    653.63, 1091.52, 931.0899999999999, 647.15, 533.82, 1086.8700000000001, 905.27,
    504.64, 557.21, 1158.44, 1115.3000000000002, 619.1199999999999, 480.24, 946.24,
    974.3499999999999, 623.3199999999999, 539.04, 1003.0800000000002, 969.01, 639.53,
    551.76, 1018.95, 869.4899999999998, 622.1999999999999, 554.89, 1034.57, 972.52,
    704.74, 531.6, 901.26, 792.6600000000001, 564.15, 472.88, 581.06,
    539.4100000000001, 445.98, 473.35999999999996, 742.59, 726.66,
    501.54999999999995, 450.15999999999997, 561.97, 556.49, 471.71,
    476.7799999999999, 645.4899999999999, 515.23, 461.48, 450.99, 642.97, 717.73,
    665.53, 613.72, 1048.46, 1091.86, 913.39, 913.6899999999998, 1266.44,
    1239.4199999999998, 994.4600000000002, 820.22, 1115.34, 994.46, 719.24, 584.3,
    1014.02, 1017.3, 705.25, 628.18, 1009.6100000000001, 1040.97, 738.26, 604.67,
    1032.48, 959.27, 829, 686.7199999999999, 1022.8900000000001, 760.8000000000001,
    600.8399999999999, 491.21, 574.5, 502.62, 481.18000000000006, 479.09000000000003,
    574.88, 488.49, 446.74, 460.22, 741.81, 647.89, 452.5300000000001, 514.81,
    820.22, 702.77, 478.3299999999999, 464.01, 776.4100000000001, 945.8600000000001,
    672.14, 632.21, 1131.8100000000002, 862.25, 740.9000000000001, 638.05, 1015.98,
    876.16, 764.3499999999999, 730.32, 752.07, 705.47, 600.3800000000001,
    628.0300000000001, 1027.07, 979.09, 744.4, 680.98, 1077.57, 849.93, 545.37,
    447.34000000000003, 609.75, 570.1899999999999, 438.33, 479.83000000000004,
    695.69, 718.89, 674.47, 584.7, 637.71, 492.15, 484.60999999999996,
    503.55999999999995, 523.69, 525.22, 510.82, 464.45, 521.26, 616.5600000000001,
    620.8199999999999, 785.59, 1301.5, 1058.26, 815.63, 635.81, 664.74, 567.56,
    550.01, 698.94, 846.41, 869.71, 612.7099999999999, 649.78, 993.79,
    997.1999999999999, 1087.63, 965.8999999999999, 948.1999999999999, 731.02, 756.04,
    788.25, 854.5, 558.38, 501.44, 641.4300000000001, 934.45, 820.9300000000001,
    660.0699999999999, 545.05, 673.3, 639.8199999999999, 538.78, 568.24,
    703.0999999999999, 553.06, 456.13, 476.73, 668.65, 690.7500000000001,
    495.58000000000004, 574.57, 915.3299999999999, 909.95, 765.23, 781.51,
    1025.6799999999998, 813.37, 681.38, 673.38, 868.78, 867.47, 799.9899999999999,
    765.55, 937.3100000000001, 740.11, 695.5699999999999, 656.32, 775.8300000000002,
    716.9100000000001, 838.75, 801.09, 985, 748.82, 611.99, 672.65,
    936.8999999999999, 979.28, 770.3, 667.23, 791.3800000000001, 771.66, 648.3,
    680.21, 821.24, 650.05, 684.47, 702.3800000000001, 760.75, 659.1600000000001,
    677.82, 738.3399999999999, 906.1299999999999, 743.15, 873.6999999999999, 949.26,
    1005.92, 912.5699999999999, 717.5799999999999, 795.26, 1107.86,
    1137.3600000000001, 873.4599999999999, 864.78, 1066.56, 963.2400000000001,
    700.39, 643.54, 892.6800000000001, 1029.0900000000001, 852.5600000000001, 951.05,
    1109.1699999999998, 1146.8400000000001, 1025.26, 1188.06, 1566.6100000000001,
    1294, 991.81, 974.44, 1237.6999999999998, 1034.91, 886.71, 992.3399999999999,
    1180.28, 1115.51, 1028.37, 1109.94, 1270.5900000000001, 1075.77, 908, 779.56,
    989.27, 1044.19, 735.99, 642.63, 858.6700000000001, 945.3699999999999,
    635.0400000000001, 570.23, 710.63, 587.04, 542.7800000000001, 592.24, 862.19,
    846.51, 808.73, 802.3, 898.1899999999999, 886.9100000000001, 969.01,
    1118.3899999999999, 1153.6499999999999, 1137.66, 1107.4499999999998, 1091.39,
    1104.3200000000002, 1000.6600000000001, 820.47, 882.3900000000001,
    1093.9299999999998, 1151.12, 934.95, 954.46, 1258.04, 1435.19,
    1230.2900000000002, 1271.87, 1652.4299999999998, 1543.78, 1132.03, 836.52,
    938.29, 682.6200000000001, 613.6600000000001, 560.62, 754.9799999999999, 576.21,
    556.19, 572.9200000000001, 654.53, 607.83, 755.3, 1021.56, 1274.3999999999999,
    832.3499999999999, 572.81, 557.43, 574.9399999999999, 654.2800000000001,
    563.1800000000001, 502.39, 477.43, 662.61, 664.8, 779.49, 1190.42, 1263.86,
    1329.3799999999999, 1411.07, 1682.9899999999998, 1479.94, 1188.2799999999997,
    1109.94, 1618.1399999999999, 1487.97, 1179.33, 1132.6299999999999,
    1418.4299999999998, 1090.69, 1006.95, 1071.99, 1434.25, 1217.7999999999997,
    936.9300000000001, 974.8399999999999, 1231.76, 1164.33, 1044.08, 1119.61,
    1439.8200000000002, 1484.6299999999999, 1468.68, 1526.6, 1687.79, 1613.5, 1516.3,
    1267, 1302.25, 931.79, 874.07, 988.0699999999999, 1360.28, 1157.77, 1005.24,
    879.19, 1089.35, 780.8, 626.51, 699.2500000000001, 932.05, 723.41,
    560.0500000000001, 450.86, 503.03999999999996, 582.75, 505.39, 432.52,
    529.3000000000001, 621.36, 608.26, 608.5999999999999, 858.75, 906.46, 1067.76,
    1184.8500000000001, 1702.5700000000002, 1762.43, 1743.96, 1718.17, 1825.26,
    1711.8600000000001, 1639.58, 1677.3700000000001, 1716.8700000000001, 1780.77,
    1643.89, 1575.6699999999998, 1719.49, 1461.52, 1141.53, 1022.2299999999999,
    1247.4099999999999, 973.9200000000001, 764.7700000000001, 732.6, 976.98,
    1019.6200000000001, 974.17, 991.22, 1388.8999999999999, 1264.15, 1143.52, 1173.5,
    1355.96, 1080.98, 1003.86, 850.36, 957.1, 554.99, 575.9, 577.83,
    799.4100000000001, 783.03, 693.33, 692.1600000000001, 953.9300000000001,
    822.1700000000001, 614.6899999999999, 562.48, 872.3399999999999,
    748.6100000000001, 558.3100000000001, 444.43999999999994, 519.13, 526.04, 484.31,
    511.71000000000004, 673.78, 621.3300000000002, 482.31999999999994, 484.14,
    551.89, 865.14, 750.16, 660.03, 1003.12, 1075.6, 937.3599999999999, 898.44,
    1253.4299999999998, 1116.48, 887.95, 946.1700000000001, 1280.2399999999998,
    1187.42, 932.6199999999999, 938.5600000000001, 1344.14, 1432.14, 1139.19, 988.7,
    1343.09, 1460.1, 1106.6499999999999, 1043.3100000000002, 1481.75,
    1538.8500000000001, 1110.17, 1014.42, 1369.56,
  ],
  FRA: [
    190.87, 195.02, 174.88000000000002, 160.01000000000002, 170.03,
    157.98000000000002, 154.64999999999998, 158.21, 171.55, 158.14999999999998,
    155.01999999999998, 156.42999999999998, 169.78999999999996, 240.73000000000002,
    263.71, 253.77, 202.25, 284.07, 297.72, 303.84000000000003, 211.78, 249.4,
    261.99, 233.72999999999996, 203.93, 212.00000000000003, 232.01, 259.73,
    235.64999999999998, 365.97, 391.68, 425.83, 436.06, 452.07, 447.35, 507.73,
    477.94999999999993, 460.62, 449.51, 472.28999999999996, 464.55,
    467.78999999999996, 407.90999999999997, 442.80000000000007, 472.35, 462.67,
    466.15999999999997, 472.12000000000006, 423.18000000000006, 472.88000000000005,
    482.67, 516.8199999999999, 351.84, 357.5, 336.96999999999997, 346.34, 288.46,
    434.47, 397.74, 426.90999999999997, 436.84000000000003, 463.3, 434.46,
    430.88000000000005, 321.34000000000003, 381.18, 367.97999999999996,
    378.04999999999995, 271.38, 371.57, 387.24, 415.16999999999996, 372.31, 486.12,
    438.03999999999996, 439.52, 378.1, 430.68, 378.40999999999997,
    348.03999999999996, 215.18999999999997, 195.1, 166.28, 160.70999999999998,
    161.35, 156.71, 160.73000000000002, 168.46, 180.67, 232.73, 216.96,
    189.07999999999998, 198.73000000000002, 186.63, 194.22, 191.28999999999996,
    216.23999999999998, 305.58, 276.36, 253.61, 191.82, 192.37, 189.97000000000003,
    213.58999999999997, 174.72, 180.94, 220.33999999999997, 258.66999999999996,
    192.49999999999997, 182.29, 180.29, 168.99999999999997, 198.89999999999998,
    297.27000000000004, 295.71000000000004, 307.5, 267.65, 342.17, 334.5, 365.44,
    333.63, 420.09000000000003, 301.58, 254.46000000000004, 221.95999999999998,
    331.65999999999997, 336.64, 305.46999999999997, 212.42, 211.51999999999998,
    200.45, 210.61, 231.14, 206.97, 188.93, 208.35000000000002, 226.79, 223.55,
    190.79000000000002, 207.85999999999999, 232.75, 204.86999999999998,
    193.67000000000002, 205.02, 187.91000000000003, 186.82999999999998,
    163.95000000000002, 161.16, 164.29999999999998, 168.15, 175.94, 180.94, 180.22,
    171.83999999999997, 175.33, 174.49, 173.65000000000003, 178.61, 193.64,
    197.82999999999998, 222.61, 254.13000000000002, 215.68, 229.49999999999997,
    218.72, 212.00000000000003, 204.25, 222.65, 283.31, 449.26, 451.55, 368.87,
    270.45, 334.19, 349.46, 341.70000000000005, 244.77, 315.48, 285.44000000000005,
    316.98, 250.77, 257.12, 260.04999999999995, 203.91000000000003, 216.35, 224.03,
    235.51000000000002, 269.73, 241.1, 232.34999999999997, 234.89, 235, 198.38,
    198.78999999999996, 206.31, 209.10999999999999, 230.9, 287.47,
    268.21999999999997, 293.43, 283.28999999999996, 350.65, 293.12,
    301.83000000000004, 283.65, 268.45, 240.53, 214.7, 215.38000000000002,
    197.14000000000001, 184.23000000000002, 187.57, 195.22, 203.74,
    239.97000000000003, 332.69, 297.14, 253.95, 228.07999999999998, 283.26, 217.8,
    206.25999999999996, 211.76, 253.29000000000002, 246.13, 373.18,
    360.65000000000003, 366.03999999999996, 349.66999999999996, 447.85,
    468.03999999999996, 479.46, 485.67, 515.9599999999999, 453.14, 408.51, 266.38,
    294.74, 301.32000000000005, 308.47999999999996, 247.51, 259.91,
    225.95000000000002, 262.9, 191.8, 194.21, 250.52999999999997, 340.84000000000003,
    244.33999999999997, 239.27999999999997, 234.93999999999997, 365.14, 368.09,
    407.35, 390.21000000000004, 421.8, 378.52000000000004, 437.99,
    396.61999999999995, 499.8399999999999, 407.71999999999997, 448.36, 408.74,
    450.53, 400.08000000000004, 351.77, 263.01, 227.5, 231.55, 258.36,
    197.88000000000002, 185.36999999999998, 180.53, 188.92, 190.64,
    196.84000000000003, 200.43, 208.03, 248.36999999999998, 304.89,
    242.04000000000002, 333.83000000000004, 330.46000000000004, 412.34999999999997,
    340.25, 382.69000000000005, 280.99, 329.95, 222.77000000000004,
    255.11999999999995, 231.04000000000002, 286.41, 209.96, 252.93999999999997,
    203.21999999999997, 185.15, 179.19, 175.75, 178.77999999999997, 170.8, 199.07,
    194.18, 205.52999999999997, 209.75, 203.81, 197.12, 200.23999999999998, 205.99,
    212.33999999999997, 214.98, 208.54999999999998, 262.6, 190.15,
    219.15000000000003, 218.2, 314.22, 197.03, 196.92000000000002,
    199.32999999999998, 223.77, 194.44000000000003, 188.83, 193.95999999999998,
    216.87, 195.21, 190.81, 186.05, 181.82999999999998, 209.76, 209.89, 210.32,
    215.93, 227.1, 225.20999999999998, 210.38, 188.43, 196.09000000000003, 189.1,
    187.63, 191.1, 188.35999999999999, 269.74, 296.22, 222.06, 192.92, 246.5, 187.02,
    170.27, 179.24, 189.11999999999998, 190.67000000000002, 171.24, 191.28,
    189.60000000000002, 189.65000000000003, 183.92, 199.46, 196.25,
    192.07999999999998, 203.07, 199.2, 206.67, 204.76999999999998, 174.94,
    133.52999999999997, 133.26, 137.62, 159.78, 123.61000000000001, 122.8, 130.37,
    122.63999999999999, 123.17999999999999, 124.57, 127.31000000000002,
    111.61000000000001, 123.85000000000002, 124.07000000000001, 144.1,
    128.70000000000002, 130.69, 127.71, 136.51999999999998, 125.62,
    122.64000000000001, 161.92000000000002, 167.15, 141.25, 169.29000000000002,
    220.23, 199.28, 127.97999999999999, 132.09, 137.62000000000003, 127.96,
    123.05000000000001, 113.21000000000001, 137.07999999999998, 128.16, 121.54,
    137.77, 134.94, 132.73, 135.10000000000002, 136.57999999999998,
    149.85999999999999, 131.98, 133.51, 127.84, 134.97, 143.21, 140.41,
    109.20000000000002, 178.11, 169.05, 142.12, 183.83999999999997, 221.13, 176.43,
    113.76, 120.71000000000001, 127.83, 129.98000000000002, 123.14, 131.4, 135.42,
    133.63, 121.37, 121.73, 124.97, 132.34, 185.98, 132.76, 154.70999999999998,
    142.93, 124.69999999999999, 118.86999999999999, 124.5, 125.05, 101.42, 111.75,
    126.91, 129.44, 119.52000000000001, 124.49000000000001, 136.01999999999998,
    130.22, 116.18, 133.52, 143.51, 137.11, 167.25, 173.23, 195.63000000000002,
    153.44, 199.81, 157.04000000000002, 187.60999999999999, 151.22000000000003,
    228.10999999999999, 201.6, 218.41000000000003, 159.43, 238.74, 230.92,
    185.92999999999998, 173.82999999999998, 243.58999999999997, 152.51, 149.94,
    156.18, 136.51999999999998, 102.6, 173.65999999999997, 152.9, 129.17, 139.56,
    156.57000000000002, 137.54, 120.83, 122.35000000000001, 126.39999999999999,
    119.25999999999999, 113.89, 116.66000000000001, 181.39000000000001,
    167.72000000000003, 108.89, 112.38000000000001, 122.38, 118.50999999999999,
    101.05, 101.64, 117.95, 127.37000000000002, 117.02, 122.36, 127.63,
    130.60000000000002, 130.02, 140.07000000000002, 149.69, 145.49, 136.66, 112.49,
    124.1, 139.7, 130.77, 122.92, 133.10999999999999, 127.8, 106.97999999999999,
    107.46, 128.64000000000001, 136.56, 106.52999999999999, 105.29, 135.15, 128.99,
    104, 104.52, 126.88999999999999, 130.84, 107.97999999999999, 110.25, 155.17,
    158.48, 107.17999999999999, 124.07, 188.99, 164.54999999999998, 105.49,
    97.63999999999999, 117.94, 116.94999999999999, 100.87, 97.03999999999999, 129.54,
    118.33000000000001, 98.84, 96.45, 110.89000000000001, 117.10000000000001, 110.56,
    96.12, 123.38999999999999, 138.26999999999998, 114.81000000000002,
    100.00999999999999, 112.1, 118.97999999999999, 100.39999999999999,
    97.49000000000001, 122.18, 127.81, 101.95000000000002, 102.63999999999999,
    131.65, 139.08, 104.19000000000001, 101.98, 120.32, 121.44, 100.09, 99.86,
    113.25999999999999, 121.13, 107.27, 102.47, 113.9, 113.03, 100.49000000000001,
    100.05, 110.68, 108.53999999999999, 104.50999999999999, 103.35000000000001,
    112.41, 113.43, 104.29, 102.20999999999998, 125.67000000000002, 134.93,
    141.51999999999998, 104.47999999999999, 129.5, 125.02000000000001, 101.05,
    100.63000000000002, 106.89, 110.8, 101.29000000000002, 98.71, 111.5,
    111.76000000000002, 101.59, 102.63000000000001, 107.36999999999999,
    112.17999999999999, 103.56, 100.54, 114.30999999999999, 116.94, 112.26, 115.99,
    115.94999999999999, 116.82000000000001, 104.39, 116.16, 129.27, 130.64,
    120.63999999999999, 129.17, 132.03000000000003, 135.81, 171.38, 126.03,
    162.97000000000003, 137.69, 108.84, 100.88, 113.19, 129.87, 123.11, 102.41,
    117.08999999999999, 115.42999999999999, 101.55999999999999, 99.71, 113.74,
    113.33999999999999, 129.47, 97.94999999999999, 121.86000000000001, 111.62,
    122.19999999999999, 115.17, 147.84, 127.91000000000001, 103.08, 110.2, 179.23,
    157.67000000000002, 104.12, 104.22, 122.83000000000001, 134.39,
    114.46000000000001, 104.00999999999999, 129.79, 123.27000000000001, 99.12,
    96.89000000000001, 124.44000000000001, 122.89000000000001, 102.02,
    101.05999999999999, 113.94, 116.61, 101.31000000000002, 101.97000000000001,
    124.99, 109.89, 132.57, 107.13, 138.79999999999998, 129.54, 105.78, 109.08,
    134.79, 134.91, 103.32999999999998, 101.01999999999998, 134.24999999999997,
    126.55, 140.44, 102.75999999999999, 92.22, 93.35000000000001, 79.92,
    77.72999999999999, 115.19999999999999, 114.42000000000002, 121.82000000000001,
    126.97, 140.93, 157.81, 154.38, 162.79999999999998, 206.51, 135.88,
    121.97000000000001, 114.62, 126.28, 132.69, 118.7, 118.15, 148.26000000000002,
    135.25, 113.02000000000001, 105.19, 117.99999999999999, 133.46,
    151.29000000000002, 96.63, 111.33999999999999, 120.48999999999998, 125.86,
    113.53, 118.21000000000001, 123.16, 130.95, 114.88, 119.57000000000001, 117.59,
    109.94000000000001, 109.26, 130.66, 129.42, 110.54, 104.21, 134.76000000000002,
    124.96000000000001, 105.82000000000001, 109.37, 124.79, 121.11, 108.97,
    107.55000000000001, 127.66, 124, 108.49000000000001, 107.3, 158.1,
    127.83000000000001, 117.08999999999999, 100.14999999999999, 111.99,
    116.99000000000001, 100.05000000000001, 112.81, 113.50000000000001,
    118.10999999999999, 101.72999999999999, 109.61, 119, 123.92, 111.15,
    116.39999999999999, 165.49, 158.73000000000002, 134.94, 153.47, 164.23, 135.18,
    107.66, 104.51, 117.94, 129.45000000000002, 156.13, 133.96, 171.86, 128.78,
    161.82999999999998, 158.94, 186.85000000000002, 130.59, 186.51, 163.4, 180.69,
    151.15, 176.75, 103.23, 142.19, 131.2, 159.75, 105.86, 139.07999999999998,
    132.14000000000001, 107.23, 107.46, 173.28, 150.27, 107.17, 101.82999999999998,
    117.72, 140.57000000000002, 143.39999999999998, 102.72, 117.60000000000001,
    135.86, 152.31, 114.46, 127.41, 151.03000000000003, 196.69000000000003, 142.77,
    139.13000000000002, 166.84, 214.32, 149.86, 166.39999999999998, 162.63, 195.19,
    112.23, 125.21000000000001, 134.63, 160.88, 102.57, 122.74, 135.28,
    107.78999999999999, 100.76, 114.05000000000001, 118.03, 100.5, 93.67,
    104.02999999999999, 115.22999999999999, 143.97, 111.58, 123.75,
    135.48000000000002, 155.48999999999998, 95.15, 109.03, 119.64999999999999,
    126.16, 99.53999999999999, 111.53, 122.66999999999999, 175.93, 100.96, 109.56,
    109.85000000000001, 99.13000000000001, 112.84, 142.01, 136.06, 101, 103.53,
    128.82999999999998, 144.39, 128.43, 98.45, 125.01, 168.22000000000003,
    192.09999999999997, 102.99999999999999, 124.62, 156.48, 214.74999999999997,
    140.78, 182.69, 152.09, 134.53, 113.02, 117.53000000000002, 111.24,
    107.97999999999999, 94.44, 106.26, 112.61, 101.87, 95.16, 117.96000000000001,
    121.61999999999999, 104.15, 105.15, 119.26, 122.61000000000001,
    107.89000000000001, 107.01, 120.89, 123.57, 117.2, 105.22, 112.79, 121.18,
    106.81, 106.46000000000001, 116.91, 114.1, 100.13, 121.93, 125.58, 153.72, 114.9,
    110.19, 161.56, 168.29, 117.57, 108.54999999999998, 159.58, 154.75,
    106.35999999999999, 107.36000000000001, 139.82999999999998, 142.6, 125.06,
    110.53999999999999, 116.02000000000001, 121.96, 111.52000000000001, 101.34,
    138.5, 150.01, 124.82, 110.52, 158.55, 154.97, 127.52000000000001,
    109.99000000000001, 129.15, 137.17, 137.35000000000002, 110.56, 129.28, 142.45,
    132.51999999999998, 108.71000000000001, 140.4, 156.98000000000002, 115.59,
    120.86999999999999, 149.13, 150.23999999999998, 148.73000000000002, 105.63,
    115.84, 116.53, 102.2, 106.42, 140.51999999999998, 145.97, 122.44,
    127.89999999999999, 129.69, 125.92999999999999, 102.30999999999999, 109.32,
    138.76, 139.04, 124.96999999999998, 107.4, 140.10000000000002, 139.76, 112.3,
    152.42, 184.13, 153.11, 127.38, 123.72000000000001, 121.31, 153.94,
    178.04000000000002, 118.31, 131.10999999999999, 169.23000000000002,
    215.64999999999998, 165.37, 181.22000000000003, 182.93, 273.21999999999997,
    194.27, 198.73999999999998, 203.24, 254.45999999999998, 183.3, 217.81,
    190.14000000000001, 211.21, 118.43999999999998, 145.85000000000002,
    157.07000000000002, 169.75, 98.66999999999999, 165.31, 160.44,
    211.70000000000005, 208.26999999999998, 220.42000000000002, 222.91000000000003,
    288.6, 196.5, 221.19, 213.97000000000003, 307.03999999999996, 277.55,
    312.74999999999994, 312.08000000000004, 273.25, 166.60999999999999, 188.41,
    203.55, 198.07000000000002, 133.32999999999998, 192.12, 190.86,
    239.87999999999997, 144.97, 166.63, 136.73000000000002, 127.82, 111.98, 138.46,
    130.35999999999999, 104.29999999999998, 107.65, 113.14999999999999,
    125.49000000000001, 137.8, 114.05, 120.67, 131.76000000000002,
    174.61999999999998, 156.79999999999998, 147.10999999999999, 128.62, 117.02,
    111.66000000000001, 137.51, 133.71, 128.69, 120.45, 138.72, 137.59, 120.77,
    103.58000000000001, 125.44, 128.01999999999998, 101.85, 104.57,
    132.10000000000002, 133.87, 108.27999999999999, 112.96000000000001, 122.51,
    140.54000000000002, 138.34000000000003, 154.69, 164.82999999999998,
    127.77000000000001, 104.45000000000002, 108.15, 130.73, 139.15, 163.97,
    144.59000000000003, 170.09, 158.36, 145.1, 135.65000000000003, 154.55, 159.3,
    128.12, 107.45000000000002, 150.14, 133.8, 107.30999999999999, 109.91,
    157.01999999999998, 128.41, 108.48, 108.41, 113.50999999999999,
    116.92999999999999, 144.66, 171.72000000000003, 168.17000000000002, 173.01,
    143.01, 134.64, 150.1, 147.58, 130.57, 140.3, 157.53000000000003,
    158.26000000000002, 144.48000000000002, 114.54, 114.4, 118.94999999999999,
    105.97, 106.91, 126.11000000000001, 128.92000000000002, 106.71,
    105.93999999999998, 129.74, 128.91, 102.41, 105.41, 134.12, 183.08, 142.3,
    137.12, 171.78, 185.69000000000003, 185.16, 163.42, 221.76, 220.18, 180.16,
    142.45, 165.03, 177.88, 137.9, 161.51, 219.06, 162.37, 190.32, 102.37, 118.47,
    135.36, 108.56, 104.32999999999998, 123.43, 121.69, 99.39, 117.07000000000001,
    142.99, 131.88, 152.95, 104.54000000000002, 112.67999999999999,
    112.79000000000002, 104.16, 99.69, 105.19999999999999, 114.98000000000002,
    105.75999999999999, 98.70999999999998, 124.19999999999997, 126.10000000000001,
    129.9, 147.69, 185.63, 149.45, 166.47000000000003, 100.08, 101.55,
    103.28999999999999, 128.13, 193.54999999999998, 217.93, 170.47999999999996,
    133.20000000000002, 111.72000000000001, 181.09, 149.12, 188.56, 112.35, 146.98,
    117.46, 106.5, 99.48, 105.80000000000001, 108.35, 96.31, 102.94, 119.41,
    132.70999999999998, 117.99, 104.32999999999998, 160.35, 147.93, 195.76, 102.47,
    107.08000000000001, 114.02000000000001, 102.02, 108.78000000000002, 122.93,
    119.88, 121.86999999999999, 126.19000000000001, 114.86, 140.35,
    130.32999999999998, 107.54, 147.19, 155.79000000000002, 171.6,
    106.06000000000002, 172.61, 132.15, 132.57, 111.48, 122.24999999999999,
    118.88000000000001, 105.22, 93.91000000000001, 105.97000000000001,
    124.82999999999998, 157.19, 102.52000000000001, 108.63999999999999,
    116.94999999999999, 107.96000000000001, 100.52999999999999, 108.85, 117.9,
    116.92999999999999, 103.38000000000001, 112.78, 136.13, 130.77,
    106.46000000000001, 128.06, 170.72, 197, 112.52, 111.43, 123.32999999999998,
    139.13, 98.97000000000001, 137.98, 148.64000000000001, 173.94,
    148.45999999999998, 148.83, 162.45999999999998, 222.05, 170.59, 174.72, 192.5,
    232.67, 150.04000000000002, 159.29999999999998, 181.2, 222.01, 196.61, 277.95,
    322.47999999999996, 350, 269.43000000000006, 350.23999999999995,
    366.78000000000003, 382.44, 351.53999999999996, 352.55999999999995, 347.85,
    359.06, 296.43, 348.48999999999995, 344.78, 344.15, 296.95000000000005,
    350.39000000000004, 342.5, 364.70000000000005, 337.43000000000006, 361.22,
    372.82, 355.6700000000001, 293.04, 334.02000000000004, 320.84,
    339.40999999999997, 267.81, 250.07, 246.04000000000002, 241.67, 209.01,
    274.36999999999995, 308.95000000000005, 358.24, 279.79, 369.53999999999996,
    372.15, 388.47, 328.88, 352.66, 341.73, 405.03999999999996, 395.65000000000003,
    410.08, 406.6, 384.75, 185.26, 173.06, 213.38, 223.64, 173.98,
    197.49999999999997, 183.34, 171.01, 143.60999999999999, 319.22999999999996, 355,
    318.44000000000005, 181.99999999999997, 188, 187.58999999999997, 203.74,
    179.32999999999998, 309.01, 309.03, 310.95, 248.94, 344.83, 375.17, 338.48, 263,
    310.8, 290.53999999999996, 310.95000000000005, 176.01, 141.38, 158.47, 197.2,
    181.3, 177.01, 162.5, 150.53, 179.22, 181.52999999999997, 220.76999999999998,
    266.78, 197.61999999999998, 293.78999999999996, 327.64, 310, 176.48, 173.08,
    181.67000000000002, 202.88, 206.36, 310.98, 319.03999999999996,
    319.16999999999996, 246.97000000000003, 288.26, 286.15999999999997, 264.17,
    182.88, 199.24, 233.84, 263.48, 158.82, 153.16, 151.07, 167.65,
    157.42000000000002, 248.47999999999996, 273.68, 273.58, 221.95000000000002,
    340.84, 390.39, 420.14, 377.52, 408.84999999999997, 394.61, 370.56, 241.06,
    303.08000000000004, 268.93, 201.02, 158.7, 183.2, 234.13, 225.55,
    147.20999999999998, 151.7, 153.08, 151.66, 168.76999999999998, 160.69, 155.78,
    156.15999999999997, 164.66000000000003, 185.23, 215.33999999999997,
    208.24999999999997, 235.68, 365.61, 381.45000000000005, 366, 371.25,
    418.94999999999993, 436.69000000000005, 418.78999999999996, 457.4,
    428.28999999999996, 422.61, 424.42999999999995, 453.58000000000004,
    443.4600000000001, 458.30999999999995, 439.40000000000003, 309.24, 297.17,
    288.67999999999995, 246.54000000000002, 168.35000000000002, 175.23000000000002,
    170.32, 174.27, 198, 216.90999999999997, 243.78, 254.97000000000003,
    212.42000000000002, 301.75, 325.43, 252.74, 157.62999999999997, 153.67, 152.37,
    144.21, 147.63000000000002, 140.01, 141.63, 156.85000000000002, 179.46,
    193.60000000000002, 152.22, 149.03, 165.98, 157.85, 143.23, 163.35999999999999,
    182.05, 163.23, 157.84, 150.98, 155.17, 161.45000000000002, 170.54999999999998,
    179.02, 177.87, 161.37, 164.29, 169.45999999999998, 164.57999999999998, 171.82,
    167.98000000000002, 153.92000000000002, 151.05, 146.23000000000002, 202.82,
    218.88000000000002, 176.88, 273.59, 299.72, 326.64, 254.18, 309.19,
    341.41999999999996, 343.21, 191.70999999999998, 189.13, 228.26999999999998,
    277.34, 194.38, 266.8, 331.45000000000005, 348.09, 214.42999999999998, 236.28,
    193.96, 181.72,
  ],
  ITA: [
    1776.0700000000002, 1580.4299999999998, 1850.5999999999997, 1987.45, 1935.8,
    1892.24, 1869.9199999999998, 1768.58, 1397.29, 1494.23, 1505.31, 1582.04,
    1396.4199999999998, 1342.94, 1583.31, 1818.84, 1657.45, 1613.93, 1642.74, 1679.9,
    1677.73, 1677.5800000000002, 1697.24, 1644.8700000000003, 1581.1599999999999,
    1393.25, 1250.84, 1511.81, 1698.73, 1750.25, 1849.39, 1791.75,
    1758.7299999999996, 1928.1499999999999, 2144.5099999999998, 2231.09, 2251.39,
    2330.1, 2374.31, 2285.14, 2119.51, 2214.1, 2173.19, 2152.52, 1908.3000000000002,
    1773.3199999999997, 1850.28, 1977.8699999999997, 1828.3299999999997, 1629.69,
    1770.93, 1957.5, 1890.8799999999997, 1713.1000000000001, 1678.9399999999998,
    1767.52, 1809.9400000000003, 1728.9099999999999, 1691.6100000000001,
    1761.0400000000002, 1844.1999999999998, 2072.2000000000003, 2098.46, 2043.75,
    1920.6, 1956.0199999999998, 1976.7999999999997, 1770.1499999999999,
    1596.6299999999999, 1613.19, 1638.8900000000003, 1651.97, 1586.25,
    1668.6100000000001, 1786.04, 1861.36, 1557.7400000000002, 1380.02, 1370.68,
    1481.6599999999999, 1427.27, 1196.93, 1334.2800000000002, 1568.62,
    1791.4299999999998, 1800.6200000000001, 1913.4500000000003, 1898.01, 1749.67,
    1885.1499999999999, 1868.9899999999998, 1857.64, 1733.3300000000002, 1807.78,
    1882.5, 1861.63, 1732.69, 1813.94, 1916.69, 2073.62, 2025.6, 1963.67,
    2014.2700000000002, 2089.7099999999996, 1983.15, 1687.97, 1593.39, 1690.82,
    1463.8799999999999, 1280.72, 1341.3899999999999, 1550.59, 1737.74, 1770.6,
    1908.6799999999998, 2034.81, 2014.4399999999998, 1945.9699999999998, 2023.68,
    2228.06, 2222.74, 1998.0700000000002, 2063.22, 2305.09, 2108.02, 2067.06,
    2165.53, 2328.4599999999996, 2167.64, 1801.02, 1864.1499999999999, 2055.71,
    2085.47, 1643.69, 1673.67, 1913.59, 1863.88, 1500.98, 1544.6700000000003,
    1725.7700000000002, 1798.54, 1705.4899999999998, 1832.3, 1909.07, 1891.42,
    1829.1, 1929.2199999999998, 2038.35, 2044.43, 2012.8899999999999,
    2025.4299999999998, 2024.03, 1837.3899999999996, 1677.05, 1748.3500000000001,
    1862.93, 1743.77, 1640.1499999999999, 1745.02, 1867.27, 1663.2199999999998,
    1443.1100000000001, 1440.36, 1450.3400000000001, 1514.19, 1257.7900000000002,
    1266.35, 1424.6100000000001, 1668.9, 1668.87, 1845.3, 2075.38, 1945.48,
    1679.0700000000002, 1612.66, 1728.57, 1528.7899999999997, 1389.28, 1533.23,
    1771.49, 1738.4199999999998, 1651.2800000000002, 1803.46, 2103.33, 1980.17,
    1816.27, 1928.12, 2103.6899999999996, 1917.1900000000003, 1514.4, 1599.65,
    1930.5000000000002, 1765.55, 1296.21, 1473.84, 1836.37, 1765.96,
    1744.2699999999998, 1866.4999999999998, 2010.7999999999997, 1900.1699999999998,
    1738.2700000000002, 1811.27, 1945.91, 1701.97, 1498.08, 1695.04, 2036.42,
    1892.67, 1730.5, 1703.78, 1642.3500000000001, 1453.44, 1560.71,
    1550.7700000000002, 1496.29, 1497.3500000000001, 1324.63, 1456.21, 1726.72,
    1571.3199999999997, 1302.84, 1298.67, 1507.4399999999998, 1634.19,
    1794.8400000000001, 1841.7399999999998, 1822.4999999999998, 1732.66, 1787.28,
    1834.5400000000002, 1883.39, 1696.5600000000002, 1770.3200000000002,
    1738.6799999999998, 1665.3200000000002, 1529.99, 1804.3799999999999,
    2030.2000000000003, 2013.31, 1682.38, 1736.65, 1791.1700000000003, 1788.35,
    1432.7199999999998, 1222.76, 1172.2, 1366.8999999999999, 1213.06, 1026.71,
    1137.1599999999999, 1315.0800000000002, 1468.6799999999998, 1587.54,
    1700.8899999999999, 1855.58, 1717.0300000000002, 1473.88, 1695.72,
    1823.8900000000003, 1550.7999999999997, 1334.5900000000001, 1406.41, 1719.98,
    1652.3199999999997, 1554.1499999999999, 1765.23, 2012.5, 1884.99, 1603.39,
    1739.6200000000003, 1854.97, 1513.74, 1318.2, 1294.6599999999999, 1509.51,
    1447.52, 1093.93, 1066.02, 1364.6999999999998, 1541.71, 1306.5800000000002,
    1440.1899999999998, 1587.7600000000002, 1442.8600000000001, 1467.2199999999998,
    1585.99, 1862.3899999999999, 1697.3999999999996, 1550.42, 1659.44,
    2015.3199999999997, 1914.08, 1478.32, 1656.02, 1933.5499999999997, 1700.13,
    1457.28, 1584.4599999999998, 1760.5700000000002, 1408.95, 1025.07, 1197.07,
    1554.79, 1515.6899999999998, 1089.6100000000001, 1237.87, 1605.07, 1487.19,
    1429.3799999999999, 1681.71, 1816.53, 1752.58, 1422.24, 1447.19,
    1711.9599999999998, 1681.25, 1359.75, 1622.0200000000002, 2018.46, 1831.78,
    1360.5, 1526.3799999999999, 1830.56, 1851.74, 1445.74, 1580.44, 1895.32,
    1657.4599999999998, 1021.8199999999999, 1003.89, 1233.05, 1234.4499999999998,
    930.4, 964.3, 1302.8000000000002, 1612.8600000000001, 1276.75, 1654.82,
    1803.1399999999999, 1703.1000000000001, 1827.2900000000002, 1890.1299999999999,
    1844.01, 1600.46, 1624.27, 1501.54, 1519.4499999999998, 1421.3300000000002,
    1299.52, 1360.18, 1541.33, 1439.2199999999998, 1324.17, 1420.12,
    1631.0300000000002, 1462.64, 1126.78, 1163.22, 1411.5400000000002, 1281.82,
    1071.73, 1181.6599999999999, 1588.31, 1471.55, 1040.06, 1053.25, 1239.48,
    1391.1200000000001, 1013.8600000000001, 1146.9699999999998, 1617.35, 1781.26,
    1559.0399999999997, 1495.25, 1613.2600000000002, 1460.58, 1273.24,
    1333.8799999999999, 1796.65, 1734.1599999999999, 1272.0000000000002, 1331.23,
    1786.2799999999997, 1618.6000000000004, 1072.5400000000002, 1157.3300000000002,
    1517.3799999999999, 1376.9299999999998, 921.8800000000001, 1076.4099999999999,
    1418.97, 1598.28, 1221.76, 1373.13, 1657.5800000000002, 1478.92,
    1201.1100000000001, 1219.72, 1377.5500000000002, 1243.3500000000001, 1200.98,
    1341.0800000000002, 1647.1399999999999, 1544.24, 1117.4899999999998, 1228.24,
    1490.59, 1258.54, 913.29, 1094.93, 1384.77, 1111.71, 809.4499999999999, 926.44,
    1242.4299999999998, 1148.2, 796.23, 1088.62, 1407.0700000000002, 1288.95, 985.01,
    1097.58, 1190.6699999999998, 1059.39, 888.58, 953.73, 1139.06, 1196.56, 1003.59,
    1153.94, 1489.1599999999999, 1493.66, 1252.78, 1439.4700000000003,
    1642.1200000000001, 1307.8400000000001, 1011.6299999999999, 954.3399999999999,
    1276.43, 1149.5, 869.6099999999998, 1126.38, 1523.85, 1494.2099999999998, 801.46,
    1129.66, 1557.08, 1663.1699999999998, 1541.1900000000003, 1675.71,
    1921.0900000000001, 1773.69, 1450.66, 1329.02, 1650.97, 1721.56, 1394.04,
    1442.41, 1734.2900000000002, 1648.93, 1014.9099999999999, 1248.17, 2014.49,
    1885.7400000000002, 1457.7, 1734.32, 1947.28, 1911.0899999999997, 1381.53,
    1505.68, 1660.2499999999998, 1498.55, 1001.24, 1131.15, 1530.59,
    1468.0000000000002, 1079.75, 1280.2800000000002, 1775.7099999999998, 1512.09,
    939.6700000000001, 1064.56, 1555.81, 1523.5100000000002, 1080.6499999999999,
    1179.9299999999998, 1376.23, 1491.27, 1197.69, 1207.03, 1397.04, 1234.1, 961.33,
    1099.3, 1388.8400000000001, 1131.44, 817.93, 884.85, 1278.5100000000002, 1204.21,
    752.83, 880.3, 1341.31, 1370.12, 1137.4299999999998, 1295.81, 1621.5700000000002,
    1535.44, 1498.13, 1458.51, 1690.93, 1590.3999999999999, 1281.6399999999999,
    1416.51, 1475.91, 1130.1399999999999, 879.4, 984.12, 1193.75, 1097.04,
    813.2199999999999, 944.6, 1270.12, 1019.6199999999999, 705.73, 892.71,
    1291.3199999999997, 1189.35, 752.98, 916.05, 1308.0900000000001, 1332.55,
    1046.2800000000002, 1260.4, 1648.7400000000002, 1547.05, 1180.07, 1325.2,
    1702.0700000000002, 1605.94, 1394.9300000000003, 1440.1299999999999, 1575.2,
    1330.29, 1168.4299999999998, 1227.74, 1463.71, 1488.82, 1014.5, 1142.83,
    1625.6200000000001, 1390.4900000000002, 955.8299999999999, 1171.31, 1454.8,
    1182.92, 901.6099999999999, 1041.83, 1421.5099999999998, 1338.8600000000001,
    1169.62, 1353.79, 1555.54, 1262.9, 969.21, 994.47, 1221.07, 1131.5400000000002,
    909.6400000000001, 1063.2399999999998, 1368.07, 1235.21, 1022.9200000000001,
    1187.84, 1615.02, 1422.82, 1025.72, 1267.7600000000002, 1659.07,
    1426.8000000000002, 1006.1300000000001, 1144.3600000000001, 1411.46,
    1108.9299999999998, 684.5699999999999, 858.05, 1277.2500000000002, 1227.64,
    1060.73, 1334.71, 1708.3600000000001, 1510.4999999999998, 1229.3899999999999,
    1306.39, 1719.51, 1655.9999999999998, 1231.7199999999998, 1403.3899999999999,
    1762.06, 1584.72, 1240.5, 1250.06, 1463.99, 1211.49, 981.2400000000001, 1052.96,
    1344.03, 1066.22, 832.45, 1033.3, 1363.44, 1352.06, 891.94, 1028.1599999999999,
    1447.2799999999997, 1416.8799999999999, 1124.03, 1226.51, 1781.77, 1590.55,
    1187.8899999999999, 1391.1, 1796.56, 1592.78, 1138.46, 1314.78, 1827.28, 1634.55,
    1124.4, 1295.3600000000001, 1813.6000000000001, 1596.0100000000002, 1095.99,
    1263.9099999999999, 1705.25, 1333.62, 917.2, 1173.24, 1541.8799999999999,
    1276.95, 922.0500000000002, 990.0799999999999, 1214.58, 1164.96, 965.21, 1113.28,
    1468.3999999999999, 1384.75, 1278.89, 1488.8000000000002, 1833.4199999999998,
    1645.31, 1249.6100000000001, 1441.8700000000001, 1723.33, 1406.35,
    1121.9999999999998, 1042.29, 1523.37, 1380.3, 1040.22, 1128.76, 1539.64,
    1357.4099999999999, 950.7700000000001, 1041.2, 1320.1100000000001,
    965.0699999999999, 706.8199999999999, 830.76, 1176.73, 1312.41, 1131.98,
    1321.6699999999998, 1810.64, 1635.5, 1271.42, 1454.45, 1862.3899999999999,
    1689.6499999999999, 1445.96, 1623.4299999999998, 1834.21, 1757.37, 1528.98,
    1644.1499999999999, 1865.5, 1660.3999999999996, 1546.93, 1689.9099999999999,
    1825.4, 1337.65, 839.9200000000001, 958.6300000000001, 1293.38, 1122.15, 1053.03,
    1074.25, 1469.41, 1523.0300000000002, 1407.8700000000001, 1471.37, 1754.52,
    1572.72, 1308.81, 1452.51, 1710.0600000000002, 1551.3400000000001, 1280.04,
    1407.3, 1854.8400000000001, 1494.63, 1144.76, 1285.1799999999998, 1745.84,
    1554.8, 1106.89, 1171.28, 1622.24, 1226.52, 824.39, 1145.33, 1679.51, 1294.75,
    690.94, 833.5800000000002, 1429.5900000000001, 1419.13, 1315.01, 1572.01,
    1842.62, 1454.18, 1162.95, 1337.15, 1608.2399999999998, 1495.33, 1292.6,
    1387.4700000000003, 1706.3899999999999, 1533.58, 1065.68, 1224.8799999999999,
    1701.91, 1483.96, 1071.76, 1265.07, 1711.0500000000002, 1324.6200000000001,
    836.59, 1019.3900000000001, 1453.83, 1267.59, 846.06, 1047.95, 1546.47, 1375.08,
    1192.79, 1372.4199999999998, 1820.2699999999998, 1626.53, 1318.9099999999999,
    1507.52, 1878.57, 1697.53, 1412.1000000000001, 1596.23, 2031.2800000000002,
    1886.41, 1498.97, 1672.6699999999998, 2031.82, 1861.3899999999999,
    1614.4299999999998, 1665.3899999999999, 1875.07, 1506.75, 1023.76, 1174.83,
    1661.96, 1418.3000000000002, 935.2300000000001, 1180.91, 1752.3700000000001,
    1637.0600000000002, 1389.1, 1571.47, 1963.81, 1799.9399999999998, 1439.18,
    1622.82, 1995.51, 1832.29, 1508.38, 1662.31, 2027.16, 1847.7300000000002,
    1536.93, 1663.44, 2010.87, 1804.33, 1546.21, 1721.6899999999998,
    2009.9399999999998, 1739.84, 1145, 1324.93, 1871.9299999999998, 1555.62, 989.8,
    1284.8500000000001, 1782.1, 1700.2899999999997, 1545.2399999999998, 1645.71,
    1887.97, 1671.66, 1378.95, 1599.1, 1934, 1776.79, 1450.5300000000002, 1588.26,
    1942.64, 1787.17, 1424.0800000000002, 1607.89, 2014.8600000000001, 1857.79,
    1404.59, 1612.13, 2014.22, 1713.6599999999999, 1114.47, 1313.5500000000002,
    1834.45, 1611.68, 988.5600000000002, 1216.69, 1829.9299999999998, 1824.98,
    1450.61, 1630.61, 1996.01, 1782.37, 1443.0800000000002, 1545.21, 2036.9,
    1963.0300000000002, 1584.82, 1760.45, 2188.83, 2104.2799999999997,
    1666.6000000000001, 1761.8, 2081.0099999999998, 1931.3899999999999, 1550.71,
    1710.1100000000001, 2051.34, 1797.2599999999998, 1362.4499999999998, 1508.59,
    1926.75, 1852.7200000000003, 1158.4, 1383.6599999999999, 1902.43,
    1816.1000000000001, 1415.1299999999999, 1616.7099999999998, 2096.0999999999995,
    2044.1000000000001, 1528.56, 1710.5099999999998, 2141.34, 2042.97,
    1534.4600000000003, 1759.65, 2077.5099999999998, 1957.01, 1418.73,
    1589.7500000000002, 2040.25, 1913.15, 1324.52, 1468.28, 1970.26,
    1766.0100000000002, 1144.05, 1363.63, 1989.3800000000003, 1773.9700000000003,
    1069.82, 1382.96, 2018.9099999999999, 1966.1899999999998, 1536.3699999999997,
    1798.1499999999999, 2097.6600000000003, 2019.38, 1596.77, 1798.8400000000001,
    2143.5800000000004, 2081.8, 1585.89, 1793.3599999999997, 2182.66, 2126.94,
    1610.54, 1806.69, 2177.91, 2078.01, 1512.43, 1727.1699999999998, 2141.58,
    1988.66, 1309.7799999999997, 1549.95, 1992.3, 1833.8200000000002, 1267.35,
    1300.7, 1824.1000000000001, 1790.3300000000002, 1294.04, 1538.35, 1877.33,
    1695.0300000000002, 1297.4499999999998, 1438.94, 1894.12, 1802.4499999999998,
    1258.14, 1476.0100000000002, 1926.9499999999998, 1852.8299999999997, 1291.3,
    1558.4699999999998, 2043.67, 1964.31, 1408.29, 1697.1, 2129.38, 1937.46,
    1335.6499999999999, 1598.21, 2029.72, 1898.36, 1238.9, 1510.97,
    1919.1699999999998, 1793.01, 1471.9799999999998, 1705.91, 2096.05, 2078.24,
    1696.48, 1926.1599999999999, 2119.89, 2076.05, 1651.14, 1882.42, 2211.58,
    2125.85, 1633.51, 1842.2500000000002, 2231.75, 2238.6800000000003,
    1640.2700000000002, 1791.8600000000001, 2138.86, 1902.18, 1289.3500000000001,
    1590.8500000000001, 2053.2799999999997, 1831.2899999999997, 1236.6799999999998,
    1545.81, 2075.35, 2129.18, 1805.6400000000003, 1943.5400000000002,
    2252.1099999999997, 2230.12, 1805.12, 1981.63, 2348.01, 2267.43, 1824.29,
    2012.71, 2253.4, 2156.85, 1904.11, 2021.42, 2151.47, 2062.24, 1745.2699999999998,
    1868.4499999999998, 2181.84, 1938.73, 1236.28, 1538.57, 2072.1800000000003,
    1885.6799999999998, 1419.0800000000002, 1533.36, 1653.23, 1561.77,
    1440.3600000000001, 1506.42, 1674.06, 1481.9, 1140.43, 1393.7299999999998,
    1793.3899999999999, 1768.01, 1463.86, 1768.83, 1978.17, 1743.1,
    1530.3999999999999, 1654.7900000000002, 1640.14, 1256.3999999999999,
    1077.9099999999999, 1295.48, 1454.6200000000001, 1290.2400000000002, 959.17,
    1229.28, 1527.1499999999999, 1338.5900000000001, 948.73, 1289.55,
    1660.5900000000001, 1695.12, 1570.73, 1974.6600000000003, 2160.69, 2135.65,
    1902.8899999999999, 2002.23, 2196.62, 2158.9100000000003, 1883.46,
    2056.0699999999997, 2304.33, 2054.1, 1654.03, 1863.52, 2160.58,
    2041.8000000000002, 1573.52, 1821.2800000000002, 2097.18, 1837.8600000000001,
    1269.35, 1572.6100000000001, 1978.7700000000002, 1775.83, 1364.58, 1628.4,
    1950.2000000000003, 2117.79, 1969.3799999999999, 2116.14, 2123.59, 1763.96,
    1480.89, 1730.25, 1971.65, 1853.55, 1551.8, 1833.53, 2029.1599999999999, 1801.94,
    1497.3000000000002, 1587.81, 1626.15, 1495.6200000000001, 1313.8400000000001,
    1512.34, 1750.9399999999998, 1531.4099999999999, 986.6800000000001,
    1094.5900000000001, 1324.58, 1126.6699999999998, 737.4, 987.03, 1330.05,
    1487.5900000000001, 1254.72, 1605.1299999999999, 1975.19, 1912.6599999999996,
    1612.51, 1836.1799999999998, 1964.7900000000002, 1842.27, 1616.8700000000001,
    1781.5900000000001, 1832.3200000000002, 1739.6100000000001, 1743.5, 1809.71,
    1563.01, 1397.49, 1342.72, 1575.13, 1740.93, 1652.13, 1197.4399999999998,
    1347.5800000000002, 1636.9199999999998, 1491.4, 1136.67, 1429.56,
    1660.5399999999997, 1681.4099999999999, 1652.33, 1922.52, 1928.53, 1723.03,
    1574.8799999999999, 1653.7600000000002, 1469.72, 1450.73, 1431.03,
    1548.4499999999998, 1431.9, 1176.97, 1253.44, 1464.6299999999999, 1449.46,
    1230.54, 1134.6100000000001, 1383.8700000000001, 1584.72, 1456.54, 1042.59,
    1306.1000000000001, 1565.55, 1439.83, 1031.7199999999998, 1299.1200000000001,
    1544.05, 1650.95, 1511.99, 1839.89, 1884.25, 1739.8499999999997, 1485.9, 1744.68,
    1776.2199999999998, 1723.93, 1820.87, 1945.7600000000002, 1727.6000000000001,
    1646.09, 1797.2, 1924.6899999999998, 1816.4399999999998, 1757.0600000000002,
    1825.6800000000003, 1805.4499999999998, 1608.6100000000001, 1391.49, 1365.61,
    1381.4499999999998, 1410.64, 1525.23, 1286.3899999999999, 1330.04,
    1443.4299999999998, 1523.02, 1506.45, 1748.87, 1792.8, 1758.4199999999998,
    1806.65, 2011.41, 1902.88, 1789.7, 1917.1499999999999, 2086.09, 1872.5,
    1766.1599999999999, 1853.11, 2004.67, 1797.58, 1611.6899999999998,
    1733.0199999999998, 1842.77, 1558.53, 1264.5300000000002, 1035.53, 1189.25,
    1306.96, 1330.17, 1122.23, 1256.21, 1405.79, 1396.69, 1330.93, 1703.5, 1766.21,
    1622.13, 1626.9400000000003, 1945.06, 1922.35, 1663.46, 1580.93,
    1865.7600000000002, 1811.2199999999998, 1550.51, 1361.5100000000002,
    1717.0500000000002, 1752.97, 1792.15, 1376.6999999999998, 1674.3400000000001,
    1829.31, 2255.6, 1778.87, 1961.89, 1903.19, 1601.6100000000001,
    1209.6399999999999, 1496.1000000000001, 1696.62, 1855.43, 1739.69, 2047.08,
    2153.8, 2013.4000000000003, 1875.8200000000002, 2172.21, 2318.34, 2144.9,
    2116.84, 2283.71, 2359.87, 2077.98, 2054.2200000000003, 2236.5499999999997,
    2120.7, 1916.26, 1956.1999999999998, 2065.84, 2070.99, 1725.8400000000001,
    1451.47, 1752.12, 1921.04, 1850.68, 1476.9, 1754.26, 1877.1599999999999, 1818.13,
    1810.22, 2048.31, 2102.2, 1970.65, 2053.73, 2235.12, 2215.72, 2133.1, 2220.65,
    2416.11, 2417.7400000000002, 2155.71, 2151.17, 2265.4300000000003, 2093.55,
    1734.44, 1727.76, 1888.1, 1987.48, 1735.78, 1471.21, 1911.6200000000001,
    2162.1800000000003, 1843.3, 1433.7, 1678.02, 1810.02, 1807.9399999999998,
    1979.71, 2176.36, 2237.3999999999996, 1985.7199999999998, 1997.76,
    2078.5299999999997, 1943.47, 1641.8600000000001, 1759.43, 1804.97, 1837.42,
    1894.0300000000002, 2117.81, 2247.24, 2014.9299999999998, 1709.39,
    1635.5399999999997, 1799.81, 1932.7499999999998, 1684.2200000000003,
    1309.1299999999999, 1786.3600000000001, 2044.9700000000003, 1899.0300000000002,
    1525.5, 1915, 2058.9199999999996, 2029.37, 2115.56, 2281.12, 2311.69,
    2107.3500000000004, 2106.7200000000003, 2306.7, 2390.3, 2353.92, 2213.48,
    2375.05, 2441.73, 2341.39, 2327.94, 2355.75, 2269.3399999999997, 2199.8, 2216.17,
    2228.64, 1983.9599999999998, 1629.6699999999998, 1438.49, 1530.4699999999998,
    1552.99, 1199.94, 1085.86, 1354.8200000000002, 1560.01, 1624.02, 1944.33,
    2209.5399999999995, 2324, 2205.2400000000002, 2311.7799999999997, 2457.99,
    2464.25, 2291.28, 2460.54, 2550.92, 2374.04, 2001.1000000000001,
    1921.2099999999998, 1966.36, 1855.6200000000003, 1698.24, 2113.4300000000003,
    2189.11, 2119.81, 1785.11, 1705.98, 1975.2299999999998, 1845.62, 1212.47,
    1221.3700000000001, 1405.4199999999998, 1409.8600000000001, 1514.9299999999998,
    2004.21, 2147.9900000000002, 2147.36, 1996.6100000000001, 2197.12,
    2319.6299999999997, 2387.91, 2322.1400000000003, 2383.2599999999998, 2493.82,
    2496.21, 2366.4, 2403.36, 2493.67, 2528.06, 2181.04, 2396.61, 2430.3599999999997,
    2260.63, 1622.9700000000003, 1610.07, 1640.0200000000002, 1735.1599999999999,
    1610.33, 1434.8200000000002, 1581.73, 1651.6899999999998, 1553.63,
    1775.6299999999999, 2103.11, 2255.5200000000004, 2177.8199999999997, 2168.17,
    2265.99, 2289.78, 2060.3, 2261.81, 2389.4300000000003, 2337.3599999999997,
    2051.83, 2139.95, 2075.12, 1800.89, 1437.87, 1519.4800000000002, 1729.1, 1667.74,
    1175.7, 1052.5400000000002, 1448.99, 1730.49, 1476.86, 1181.23, 1236.79, 1226.14,
    1146.8400000000001, 1305.33, 1381.3400000000001, 1436.1399999999999, 1332.98,
    1336.02, 1511.31, 1559.3, 1262.6699999999998, 1070.51, 1228.52,
    1383.8600000000001, 1372.5800000000002, 1251.6100000000001, 1388.66, 1587.35,
    1536.44, 1474.93, 1739.7900000000002, 1839.5300000000002, 1655.9399999999998,
    1373.02, 1740.52, 2017.1799999999998, 2086.93, 1647.8700000000001,
    1988.8500000000001, 2292.92, 2289.76, 1944.59, 2210.0199999999995, 2402.79,
    2398.9, 2226.91, 2325.3, 2395.1400000000003,
  ],
  NOR: [
    329.73, 314.6, 305.19, 326.32000000000005, 335.46999999999997,
    215.73000000000002, 209.13, 277.15, 289.13, 271.97, 241.97000000000003, 265.95,
    309.59, 215.02999999999997, 228.48999999999998, 238.58999999999997, 232.63,
    180.57999999999998, 204.26, 248.85000000000002, 341.52, 327.62,
    333.05000000000007, 320.23999999999995, 350.75, 267.67, 321.51, 250.14,
    265.82000000000005, 278.1, 228.76000000000002, 218.66000000000003, 223.7, 223.7,
    211.56000000000003, 218.57999999999998, 232.78, 218.53, 193.76000000000002,
    180.17999999999998, 180, 185.79999999999998, 171.60999999999999, 175.99, 178.4,
    190.26, 197.04000000000002, 182.64000000000001, 224.54000000000002, 238.26,
    251.86, 265.23, 309.69, 220.80999999999997, 226.75999999999996,
    232.25000000000003, 257.59999999999997, 206.83999999999997, 241.42000000000002,
    284.16999999999996, 278.65999999999997, 287.24, 218.87000000000003,
    228.76000000000002, 230.70000000000002, 228.04000000000002, 183.87999999999997,
    188.87, 184.82999999999998, 212.98, 221.67, 188.77000000000004,
    225.48000000000002, 207.85000000000002, 202.48, 246.71999999999997, 249.23,
    214.51000000000002, 193.95000000000002, 197.23999999999998, 256.89, 274.25,
    271.4, 298.94, 306.22999999999996, 234, 228.16, 246.21, 291.18999999999994,
    216.17, 215.4, 253.39999999999998, 308.74, 256.19, 252.53, 279.01, 291.43,
    214.65000000000003, 186.10000000000002, 172.67, 181.91000000000003,
    204.03999999999996, 232.26999999999998, 201.53, 196.48000000000002, 190.28,
    189.13, 190.56, 179.35, 212.3, 214.88, 197.97, 207.84000000000003, 214.04,
    215.13, 207.05, 194.99, 200.87, 211.32999999999998, 209.46, 208.52999999999997,
    198.12000000000003, 197.32999999999998, 208.31, 218.95999999999998, 210.44,
    205.31, 194.47000000000003, 191.58, 185.29, 192.02, 230.76999999999998,
    287.84000000000003, 249.06, 234.20999999999998, 243.48, 307.25,
    294.90000000000003, 285.18, 296.19000000000005, 343.09, 237.95,
    242.08999999999997, 259.8, 331.21, 222.76999999999998, 231.46, 277.8,
    295.78000000000003, 241.99, 200.22000000000003, 209.64000000000001, 230.32,
    228.49, 232.98999999999998, 210.57, 242.54, 201.24999999999997,
    200.20999999999998, 188.47, 189.73, 204.46, 213.88, 222.7, 362.37,
    248.26999999999998, 204.75, 196.51999999999998, 192.85999999999996, 189.56,
    169.48000000000002, 178.65, 179.2, 199.49999999999997, 214.63,
    213.04000000000002, 248.19, 202.69, 198.73, 197.94, 194.98000000000002, 179.96,
    194.24, 199.29, 214.2, 214.06, 214.91, 214.99, 207.01, 198.95000000000002, 194.8,
    199.36999999999998, 196.48999999999998, 229.89000000000001, 205.91,
    225.26999999999998, 258.76000000000005, 194.56000000000003, 187.12, 201.75,
    194.80999999999997, 197.14000000000001, 181.78, 195.85, 200.73,
    189.83999999999997, 184.84, 222.79000000000002, 243.27, 195.11,
    193.42000000000002, 256.05999999999995, 301.84, 208.16000000000003,
    207.83000000000004, 206.83999999999997, 211.8, 219.24, 239.21,
    220.53000000000003, 219.4, 214.35000000000002, 214.67000000000002,
    196.09000000000003, 186.86, 187.70000000000002, 191.05, 205.64000000000001,
    189.08999999999997, 182.29, 176.59999999999997, 203.57000000000002, 206.03,
    206.71, 195.14, 188.95999999999998, 183.92000000000002, 179.63,
    184.38000000000002, 201.09, 200.49, 197.39000000000001, 194.95000000000005,
    203.08, 208.67, 202.5, 199.24, 206.31, 215.94, 229.73, 241.40999999999997,
    215.04000000000002, 212.63, 205.3, 200.17000000000002, 196.91,
    203.10999999999999, 212.77, 220.16, 223.2, 219.34, 206.02000000000004, 191.55,
    215.81000000000003, 210.01, 211.61, 201.19, 205.34, 200.18, 245.13, 269.86,
    220.76, 242.6, 276.23, 263.01, 215.20000000000002, 278.27, 314.59, 285.86,
    243.98000000000002, 264.68000000000006, 233.54000000000002, 230.07, 224.02,
    214.64000000000001, 240.18, 197.55, 194.90000000000003, 187.51, 178.8,
    181.85999999999999, 197.98, 195.20999999999998, 211.03, 209.27, 201.55, 235.45,
    232.82000000000002, 211.89999999999998, 187.73, 245.11, 219.1, 224.63, 181.44,
    183.68, 248.74, 196.02999999999997, 176.79999999999998, 179.6, 174.37, 176.14,
    179.01, 181.53, 179.02, 181.10999999999999, 181.01, 181.03000000000003, 176.89,
    176.71, 178.81, 181.19, 175.86, 166.43, 166.22, 200.32999999999998,
    174.39000000000001, 171.86, 173, 182.54000000000002, 266.19, 288.08, 272.17,
    379.34000000000003, 346.59, 249.70999999999998, 186.71999999999997,
    191.06000000000003, 182.97, 207.45999999999998, 197.7, 180.84, 179.83, 176.26,
    171.48000000000002, 173.23000000000002, 175.89000000000001, 177.35, 179.21,
    187.09, 211.45, 251.58999999999997, 244.65, 288.63, 265.96, 208.26, 177.5,
    182.04, 201.95, 198.88, 186.32999999999998, 191.16, 274.51, 236.87, 204.09,
    217.42999999999998, 190.41000000000003, 273.26, 251.37, 266.90999999999997,
    245.64999999999998, 217.73000000000002, 176.42999999999998, 179.94, 191.34,
    186.04999999999998, 190.23, 196.51000000000002, 183.91, 183.47, 178.33,
    190.82999999999998, 203.59, 239.07, 192.47000000000003, 208.37999999999997,
    258.8, 247.35, 210.81, 269.44, 276.40999999999997, 229.33, 181.25, 183.28,
    177.90000000000003, 179.20000000000002, 180.53, 183.25, 192.44,
    198.92999999999998, 178.96, 180.14999999999998, 173.22999999999996, 172.31,
    169.87, 182.63, 208.31, 175.6, 172.54000000000002, 181.17000000000002, 218.53,
    197.87, 174.73, 191.47000000000003, 269.88, 228.9, 185.14, 192.08, 246.14,
    217.99, 178.48999999999998, 195.08000000000004, 180.32, 198.13000000000002,
    199.8, 225.14999999999998, 190.6, 181.63, 178.74, 182.01, 182.45000000000002,
    179.49, 181.17000000000002, 178.35999999999999, 174.72000000000003,
    172.39000000000001, 168.07, 182.75000000000003, 204.7, 205.79,
    179.58999999999997, 181.53, 233.73000000000002, 213.34, 182.87, 185.78,
    282.35999999999996, 240.11, 177.21999999999997, 177.09000000000003, 178.98,
    182.26999999999998, 178.75, 181.42, 179.45, 174.78000000000003,
    173.69000000000003, 176.81, 182.57999999999998, 184.63, 179.01,
    179.61999999999998, 176.13000000000002, 183.57999999999998, 177.1,
    179.20999999999998, 201.93999999999997, 198.6, 183.74, 186.34,
    250.04999999999998, 230.65999999999997, 188.02, 257.99, 280.51, 233.9,
    167.14000000000001, 166.95999999999998, 185.85000000000002, 183.41, 167.31,
    174.02, 200.82, 195.51, 173.46, 173.51000000000002, 251.07, 235.07999999999998,
    173.38, 184.51000000000002, 247.26, 215.01000000000002, 183.16000000000003,
    185.91, 184.58, 185.45, 181.26000000000002, 184.2, 196.5, 195.2, 188.86,
    182.51000000000002, 247.44, 209.8, 180.17000000000002, 180.37, 175.94,
    177.72000000000003, 179.17, 183.91, 181.85, 176.10000000000002,
    181.45999999999998, 188.5, 189.08, 189.98, 188.8, 190.08999999999997, 236.87,
    213.13000000000002, 188.17, 190.78, 231.67000000000002, 207.71, 198.33, 200.01,
    264.35, 234.62000000000003, 196.39000000000001, 201.57999999999998, 311.38,
    257.86, 197.29999999999998, 207.37, 233.08, 206.12, 199.98000000000002,
    198.83999999999997, 229.58, 220.54000000000002, 194.48, 196.24,
    216.55999999999997, 207.88, 195.71, 200.08, 206.42, 201.54000000000002,
    188.64000000000001, 199.6, 202, 198.1, 197.07999999999998, 199.09,
    217.64000000000001, 210.22000000000003, 200.69, 203.73, 222.98, 210.37, 196.15,
    197.20000000000002, 232.24, 216.05, 197.05, 195.05, 189.85999999999999, 188.48,
    181.09, 182.41, 188.85999999999999, 184.71, 179.95, 182.31, 179.57,
    177.20999999999998, 179.88, 187.04, 186.04999999999998, 195.17, 198.07, 197.82,
    202.64000000000001, 206.44, 193.18999999999997, 195.22000000000003,
    264.59000000000003, 210.95, 190.42, 198.17, 192.42, 194.62, 199.29999999999998,
    204.5, 196.8, 196.88, 201.26, 209.49, 192.6, 195.97000000000003, 205.07, 207.26,
    197.91, 189.78, 198.62999999999997, 207.31, 202.05, 206.65999999999997,
    207.63000000000002, 212.74, 218.33, 206.5, 192.29999999999998,
    199.37999999999997, 238.65, 247.60000000000002, 196.11, 191.55999999999997,
    186.98, 186.81, 188.03, 201.77000000000004, 189.07, 187.96, 197.91000000000003,
    198.96, 191.03, 189.32000000000002, 192.43999999999997, 196.42000000000002,
    196.84, 186.75, 188.95000000000002, 195.81, 199.13000000000002,
    198.64000000000001, 199.63, 201.53, 255.45000000000005, 244.45999999999998,
    189.51, 199.44, 281.01, 241.31, 191.42000000000002, 188.72, 187.36, 192.56,
    193.21, 195.54000000000002, 217.98000000000002, 223.66000000000003, 194.82,
    194.16, 195.32, 194.13, 194.59000000000003, 193.99, 193.05, 198.98999999999998,
    198.42999999999995, 200.85, 195.70999999999998, 189.59, 193.04,
    221.44000000000003, 293.02, 247.01999999999998, 194.46, 226.09000000000003,
    298.03, 232.85, 195.88, 184.89999999999998, 189.02999999999997, 193.69, 191.47,
    199.77, 200.18, 195.69, 196.15000000000003, 196.32, 190.6, 188.42000000000002,
    191.26, 189.32, 186.31, 184.56, 193.47000000000003, 199.55, 193.92999999999998,
    198.44, 203.3, 207.13, 245.32999999999998, 226.48000000000002,
    202.98000000000002, 203.38000000000002, 283.21, 227.44, 190.82999999999998,
    188.23000000000002, 187.6, 188.17, 193.27000000000004, 200.73000000000002,
    227.64999999999998, 212.32000000000002, 200.78, 199.79999999999998,
    201.43999999999997, 195.91, 198.03000000000003, 204.32, 199.92,
    198.57000000000002, 194.96000000000004, 204.83, 205.29, 232.01,
    201.98000000000002, 204.82000000000002, 235.27000000000004, 206.01, 196.06,
    205.23999999999998, 270.74, 224.34, 197.14999999999998, 194.34, 185.95, 186.51,
    190.73999999999998, 199.76000000000002, 184.95000000000002, 189.04, 193.26,
    193.63000000000002, 187.70000000000002, 191.44, 193.51999999999998, 224.13,
    258.81, 241.56, 188.29, 206.47, 247.25000000000003, 229.42, 193.59999999999997,
    222.46, 298.6, 332.27000000000004, 256.64, 288.34000000000003, 306.65,
    222.07000000000002, 190.70999999999998, 187.79, 191.5, 194.76999999999998,
    194.87, 199.42, 217.55, 205.45000000000002, 195.54, 196.95000000000002, 188.02,
    186.33, 188.53, 195.90000000000003, 190.42, 193.17, 198.12, 201.29999999999998,
    196.17, 197.69, 201.23999999999998, 205.48000000000002, 245.63, 240.54, 201.12,
    204.44, 302.23, 235.10000000000002, 196.27, 190.22, 210.79999999999998, 202.37,
    197.23999999999998, 201.88, 222.02, 216.16, 195.55, 201.57000000000002, 195.07,
    191.20000000000002, 191.95999999999998, 197.23000000000002, 187.94, 188.26,
    191.63, 197.38, 189.14, 173.94, 183.83999999999997, 200.27999999999997, 244.2,
    230.39000000000001, 196.63, 198.75, 240.89000000000001, 202.23000000000002,
    190.88, 185.96, 191.22, 193.93, 192.46, 198.12, 189.36, 188.76, 189,
    195.44000000000003, 196.49, 204.10999999999999, 194.43, 202.01, 198.8,
    191.71999999999997, 189.82, 188.49999999999997, 182.39, 185.54999999999998,
    190.54, 197.32999999999998, 194.62, 192.42999999999998, 194.81, 195.75, 257.6,
    238.68, 183.12, 183.79, 234.10999999999999, 218.20999999999998,
    197.38000000000002, 196.17000000000002, 228.45000000000002, 202.78,
    187.43999999999997, 193.95, 186.63, 184.95999999999998, 188.54999999999998,
    192.23999999999998, 189.97, 190.90000000000003, 190.45999999999998, 197.32,
    192.64000000000001, 193.71000000000004, 194.42, 198.97000000000003,
    223.99999999999997, 211.46, 193.31, 196.17999999999998, 253.38,
    237.81000000000003, 192.7, 192.44, 196.17999999999998, 203.56,
    192.58999999999997, 196.70000000000002, 218.23000000000002, 202.06,
    188.04000000000002, 191.07999999999998, 192.44, 190.12, 180.98,
    187.57999999999998, 182.34, 183.53, 185.76999999999998, 204.56, 238.5, 227.71,
    179.74, 188.45, 241.86, 228.17, 176.43, 184.39, 268.25, 216.34,
    177.60000000000002, 185.79, 184.75, 192.07, 183.89000000000001, 193.81, 182.14,
    185.61999999999998, 185.84, 186.21999999999997, 183.45999999999998, 181.86,
    181.67000000000002, 186.73, 207.85, 188.03000000000003, 171.91, 172.67, 168.7,
    173.26, 176.32999999999998, 178.37, 177.57000000000002, 179.1,
    181.51999999999998, 186.32, 184.7, 186.58999999999997, 176.82,
    169.17000000000002, 163.06, 172.83999999999997, 171.39000000000001,
    174.07000000000002, 168.57999999999998, 167.85000000000002, 169.64999999999998,
    178.58999999999997, 218.82999999999998, 217.06, 176.61, 198.49, 192.17, 190.73,
    165.14, 178.9, 222.92000000000002, 203.16, 166.10999999999999, 176.69, 199.76,
    200.43, 173.56, 188.6, 247.67000000000002, 201.47000000000003, 170.64, 161.88,
    157.29000000000002, 162.66, 168.95999999999998, 177.26000000000002, 169.09,
    168.35, 170.02, 181.95999999999998, 174.54000000000002, 176.60999999999999,
    179.46, 186.10000000000002, 175.4, 175.42, 172.76, 181.40999999999997, 177.34,
    183.14, 186.21, 184.39999999999998, 195.92000000000002, 191.53000000000003,
    189.01, 195.01, 221.45, 204.98, 192.74, 180.95, 176.15, 181.97, 171.33,
    177.71000000000004, 176.2, 176.27, 177.42, 184.17, 182.88, 187.24, 183.99,
    189.53, 208.65, 211.31, 184.47, 189.52, 182.79, 188.67, 185.65, 199.04, 195.42,
    194.98000000000002, 191.18, 194.30999999999997, 191.78000000000003,
    184.98000000000002, 179.14999999999998, 175.64000000000001, 167.88, 171.04,
    174.14000000000001, 174.25, 173.26, 180.16, 168.66000000000003, 167.03, 169.51,
    170.17999999999998, 167.97, 170.91, 170.24, 170.01, 174.55, 185.29000000000002,
    181.07, 182.96, 183.09, 185.07, 213.26, 208.12, 184.76, 188.37,
    219.26000000000002, 197.4, 190.57, 188.23999999999998, 187.91, 188.85,
    185.35999999999999, 189.5, 187.85, 186.76999999999998, 180.57,
    182.71000000000004, 181.92000000000002, 188.83999999999997, 182.32000000000002,
    186.23000000000002, 188.92000000000002, 187.06, 186.82000000000002,
    192.12000000000003, 189.59000000000003, 187.15, 179.22, 186.35999999999999,
    224.39999999999998, 202.66, 192.95, 194.02000000000004, 211.89, 196.62, 191.14,
    192.57999999999998, 188.53, 191.55, 182.64, 187.7, 189.12, 189.94,
    178.44000000000003, 185.82, 175.09, 176.84999999999997, 176.73000000000002,
    181.53, 184.92, 185.45999999999998, 196.18, 271.43, 227.43, 210.77999999999997,
    221.61, 218.19, 224.95000000000002, 192.03, 163.29, 169.07, 221.32, 178.56,
    178.38000000000002, 202.13, 210.04000000000002, 184.19, 215.84, 223.56, 174.74,
    175.69, 178.68999999999997, 177.73, 177.76000000000002, 176.58, 172.38, 173.1,
    175.29999999999998, 177.60999999999999, 180.5, 184.95000000000002,
    180.27999999999997, 179.01999999999998, 183.56999999999996, 187.73,
    181.19000000000003, 179.53, 182.18, 186.69, 208.59, 196.82999999999998, 182.34,
    185.89999999999998, 178.95, 179, 177.57999999999998, 177.97, 176.10999999999999,
    178.54999999999998, 179.46, 179.23000000000002, 175.14000000000001, 174.28,
    177.55, 186.46, 198.39999999999998, 181.82, 177.67, 181.83, 182.16, 182.68,
    177.60000000000002, 180.81, 187.01, 173.9, 188.87999999999997, 228.36, 239.67,
    235.51000000000002, 180.96, 184.79, 182.28, 181.54999999999998, 178.92, 179.89,
    177.61, 178.73999999999998, 189.54999999999998, 192.92, 213.66, 183.15,
    173.47000000000003, 175.81, 168.73, 170.51000000000002, 174.3, 182.68, 181.01,
    180.6, 178.04999999999998, 181.71, 176.53, 176.57999999999998,
    179.20999999999998, 184.87, 220.85000000000002, 196.16000000000003, 187.89,
    187.54, 160.34, 162.42, 165.94, 168.32, 163.14, 161.25, 162.01000000000002,
    163.84, 162.78, 161.82999999999998, 164.84, 167.90000000000003, 169.89, 170.93,
    166.66, 167.37, 167.76, 168.86, 176.45999999999998, 187.92000000000002,
    185.34999999999997, 175.51, 181.35, 184.67000000000002, 180.01, 180.04, 177.76,
    184.63, 174.10000000000002, 173.9, 174.35, 176.95999999999998, 171.97, 167.31,
    164.74, 169.07000000000002, 166.44, 167.01999999999998, 170.41000000000003,
    175.82999999999998, 172.28, 172.22, 174.37, 174.95, 165.44, 164.93, 165.96,
    172.43, 168.41, 170.82, 171.23, 168.68, 167.92000000000002, 171.49, 173.76,
    180.76, 176.43, 176.74, 179.27, 181.93, 177.51, 174.95, 178.63,
    181.89000000000001, 176.51, 175.14, 178.60999999999999, 182.82999999999998,
    177.56, 175.82999999999998, 176.29000000000002, 179.22, 176.39999999999998,
    171.16, 173.38, 185.04000000000002, 180.95, 179.04, 181.85, 188.72,
    186.14000000000001, 185.82, 185.07, 188.7, 183.41000000000003, 178.61, 180.94,
    185.93, 182.12, 176.51999999999998, 179.11, 182.57999999999998,
    178.28000000000003, 176.08, 176.86, 176.37, 174.18999999999997,
    169.11999999999998, 157.5, 166.71, 171.82999999999998, 173.19000000000003,
    176.34999999999997, 181.12, 173.79999999999998, 174.85, 176.53,
    180.34000000000003, 176.94, 179.19, 179.49, 181.28, 177.11, 175.51999999999998,
    174.89000000000001, 189.95, 217.82999999999998, 197.92, 174.62, 175.36,
    174.92000000000002, 173.57, 174.45, 176.3, 182.85, 170.93, 172.98, 176.52,
    176.13000000000002, 174.09000000000003, 168.86, 170.67999999999998,
    175.33999999999997, 171.03, 246.82999999999998, 257.56, 253.17000000000002,
    226.39, 245.66, 235.28, 168.79, 167.36, 170.28000000000003, 180.81,
    175.79999999999998, 173.78, 174.29, 177.86, 176.82, 177.29, 177.33, 194.5,
    174.95000000000002, 172.83999999999997, 171.75, 174.43, 168.04000000000002,
    173.48000000000002, 172.34, 170.46, 168.87, 168.76, 170.98000000000002, 172.58,
    171.59, 172.19, 174.62, 177.24, 174.78, 168.92000000000002, 169.05999999999997,
    172.78, 174.48000000000002, 176.09, 174.41000000000003, 172.87,
    165.40999999999997, 165.66000000000003, 166, 168.55, 165.2, 164.03, 166.7,
    221.52, 173.20999999999998, 182.7, 174.13, 173.94, 170.92, 173.14, 174.91,
    180.76000000000002, 171.19, 173.01, 172.12, 179.91, 171.48999999999998, 171.46,
    173.26000000000002, 175.82, 192.89999999999998, 187.91, 170.17,
    168.35999999999999, 180.95000000000002, 197.14000000000001, 186.87,
    179.10999999999999, 183.65, 176.72, 174.73000000000002, 175.23000000000002,
    180.16, 173, 174.26999999999998, 165.8, 164.31, 162.91, 167.29,
    170.21999999999997, 165.43, 161.42000000000002, 180.35999999999999,
    240.42000000000002, 161.22, 163.16, 163.45, 166.73, 168.96, 172.75, 175.06,
    172.65, 165.19, 161.46999999999997, 161.66999999999996, 188.17,
    168.39000000000001, 163.28, 160.88, 158.02, 164.53, 167.92, 170.19, 178.53,
    177.98, 180.73999999999998, 223.88, 218.54999999999998, 190.41, 169.15,
    172.32999999999998, 192.43, 174.89000000000001, 173.81, 173.19, 171.95, 166.16,
    168.79999999999998, 169.84, 172.09, 172.65, 173.04, 171.87, 175.87, 172.45,
    173.36, 176.10000000000002, 178.54, 175.55, 175.27, 178.57, 177.67000000000002,
    172.69, 171.97, 170.97, 175.47000000000003, 169.72000000000003, 167.6, 173.04,
    177.66, 170.03999999999996, 164.73, 166.59, 172.13, 171.20000000000002, 172.03,
    193.97,
  ],
  POL: [
    4467.12, 4574.37, 4382.97, 4423.889999999999, 4750.45, 4672.14, 4648.71, 4158.92,
    3864.26, 4090.4100000000003, 4395.25, 4423.66, 4602.48, 4508, 4572.42,
    4773.040000000001, 5196.22, 5018.799999999999, 5108.83, 4997.0199999999995,
    4980.96, 4927.360000000001, 4783.22, 4578.58, 4694.79, 4722.6, 4660.67, 4660.78,
    4779.88, 4851.0599999999995, 5180.45, 5165.429999999999, 5255.79, 5116.66,
    5263.460000000001, 5372.49, 5423.36, 5145.700000000001, 5330.209999999999,
    5220.23, 4916.42, 4791.099999999999, 4831.48, 4990.24, 5365.16,
    4909.490000000001, 4460.500000000001, 4445.719999999999, 4400.7, 4449.65,
    4146.55, 3655.09, 3602.9700000000003, 3740.17, 3894.5, 3882.5,
    3702.1400000000003, 3867.5, 3998.1800000000003, 4257.139999999999, 4751.54,
    4877.799999999999, 5372.54, 5062.76, 4755.69, 4382.120000000001, 4541.82,
    4788.259999999999, 5012.25, 5124.3, 5188.7300000000005, 4643.75,
    4287.030000000001, 4280.4400000000005, 4289.63, 4026.06, 3490.6400000000003,
    3292.09, 3561.8199999999997, 4295.679999999999, 4517.44, 3908.63, 3522.68,
    3372.33, 3300.8199999999997, 3378.2700000000004, 3625.09, 3483.1, 3537.23,
    3627.08, 3734.62, 3692.7300000000005, 3400.6600000000003, 3609.9100000000003,
    3680.1099999999997, 3424.84, 3319.7, 3622.1899999999996, 4017.25,
    4428.3099999999995, 4977.95, 4942.139999999999, 4553.22, 3699.69,
    3311.8300000000004, 3368.07, 3835.5, 4272.02, 4748.14, 4467.360000000001,
    4683.27, 4275.7699999999995, 3986.79, 3678.05, 4180.98, 4098.59, 4285.11,
    4087.5000000000005, 4388.799999999999, 4128.950000000001, 4094.77, 4261.29,
    4446.469999999999, 3991.5, 3481.7800000000007, 3549.42, 3572.9700000000003,
    3683.2200000000003, 3785.8100000000004, 3754.55, 3904.23, 3378.59, 2920.8,
    2986.9, 3161.73, 3101.2999999999997, 2927.23, 2733.3599999999997,
    2965.0599999999995, 3016.9, 3198.7700000000004, 3600.43, 4065.7599999999998,
    4095.63, 3771.27, 3646.67, 3581.1299999999997, 3352.55, 3372.8599999999997,
    3896.8599999999997, 4402.85, 4839.63, 5245.37, 4903.29, 5175.67, 5389.36,
    5172.4400000000005, 4513.099999999999, 4374.29, 4684.35, 5105.35, 4727.18,
    4834.72, 4815.49, 4539.58, 4328.389999999999, 4474.24, 4745.79, 4866.85,
    4448.2699999999995, 4341.4800000000005, 4353.639999999999, 4202.4400000000005,
    4211.9, 4699.22, 4755.889999999999, 4988.74, 4198.9800000000005, 4688.58,
    4825.05, 4894.91, 4449.54, 4717.75, 4633.2, 4570, 3521.08, 3702.41,
    3837.1800000000003, 3836.23, 3664.3400000000006, 3979.15, 4755.67, 5091.52,
    4342.45, 4339.02, 3994.09, 3979.63, 3970.0099999999998, 4115.54, 4146.18,
    4292.88, 4304.719999999999, 4384.62, 4706.66, 4634.92, 4069.06, 4169.85, 4284.28,
    4213.66, 3997.8100000000004, 4085.95, 3693.86, 3288.5299999999997, 3750.89,
    4750.759999999999, 5010.4800000000005, 4690.42, 3775.8799999999997, 4019.78,
    4204.18, 4467.52, 3548.4100000000003, 4410.54, 4749.799999999999, 5136.13,
    4202.3, 4682.75, 4762.459999999999, 4941.67, 4616.27, 5100.33, 5252.219999999999,
    5297.28, 4916.85, 5063.549999999999, 5224.04, 5128.639999999999,
    4744.400000000001, 4685.37, 4475.46, 4267.77, 3948.52, 4300.7, 4331.27,
    4253.7300000000005, 4086.01, 4461.3099999999995, 4326.13, 4302.73, 3326.87,
    3904.49, 4372.07, 4578.05, 4231.41, 4498.43, 4855.69, 4858.950000000001, 4823.96,
    5122.07, 5305.779999999999, 5215.0599999999995, 4665.17, 4669.1, 4880.85,
    4978.98, 4074.98, 4592.870000000001, 5231.67, 5230.63, 3796.28,
    4233.490000000001, 4925.27, 4580.24, 3080.49, 3575.76, 3929.0800000000004,
    3619.54, 3289.0099999999998, 3141.1800000000003, 3327.5399999999995,
    3545.6900000000005, 3661.1800000000003, 4300.05, 4971.23, 5180.34, 4908.75,
    5085.33, 5408.499999999999, 5462.33, 4903.719999999999, 5147.39, 5154.3, 5061.8,
    4294.78, 4516.48, 4531.17, 4451.459999999999, 3714.7000000000003, 3816.46,
    4111.4400000000005, 3925.4699999999993, 3406.54, 3518.7900000000004, 3834.22,
    3435.99, 2890.5499999999997, 3771.1500000000005, 4514.08, 4719.23, 4601.9,
    5121.94, 5548.88, 5392.65, 4377.74, 4608.11, 5272.25, 5289.88, 4173.85, 4948.96,
    5464.860000000001, 5080.66, 4308.41, 4776.18, 5136.61, 5110.42, 4514.37, 4414.83,
    4531.96, 4972.870000000001, 4455.26, 4374.4, 4360.33, 4510.36,
    3644.2000000000003, 4137.2, 5012.539999999999, 5358.950000000001, 4622.01,
    4923.070000000001, 5659.610000000001, 5381.070000000001, 3445.78,
    3556.2000000000003, 3879.7, 3661.25, 2675.46, 3421.47, 4037.3300000000004,
    3581.75, 3351.77, 3490.91, 3967.4700000000003, 3577.43, 2483.86, 3551.91,
    4206.77, 4432.92, 3147.96, 3742.5599999999995, 3917.01, 3657.2200000000003,
    3102.2299999999996, 3796.2799999999997, 4241.02, 4165.44, 3257.58, 3531.21,
    3854.9700000000003, 3673.9900000000002, 3279.53, 3284.45, 3523.17,
    3864.1100000000006, 3329.5099999999998, 4101.889999999999, 4977.24, 4908.55,
    4149.33, 4292.41, 4036.31, 3969.96, 3415.25, 3936.7500000000005,
    3695.5699999999997, 3605.4300000000003, 2782.68, 3854.9399999999996,
    4796.7699999999995, 3582.5699999999997, 2657.1, 3901.8700000000003, 4719.9,
    4475.29, 3576.92, 4276.52, 4483.69, 4655.4800000000005, 3235.16,
    3613.5599999999995, 3969.7700000000004, 4028.2000000000003, 3571.2599999999998,
    3980.09, 4778.5, 4483.6900000000005, 2963.5699999999997, 3678.01, 4590.45,
    4507.9400000000005, 3548.15, 3858.5099999999998, 4272.9400000000005, 3938.98,
    2604.01, 3273.26, 4095.3199999999997, 2967.58, 2326.3399999999997, 2653.02,
    4154.94, 4919.92, 4177.55, 4545.5, 4582.04, 4053.1899999999996, 3146.57,
    3707.3999999999996, 4755.45, 5128.26, 4458.18, 4809.92, 5514.5,
    5452.389999999999, 4196.38, 4330.43, 4927.549999999999, 4569.46, 3690.5,
    4363.400000000001, 4976.91, 4608.97, 3664.3399999999997, 4276.66, 5119.35,
    4670.64, 3435.63, 3681.13, 4783.23, 4922.360000000001, 4418.91, 4978.68, 5677.99,
    5489.700000000001, 4071.7000000000003, 4616.88, 5211.099999999999, 5136, 4358.17,
    4807.74, 5429.32, 5428.86, 4163.88, 4390.13, 5117.56, 4870.89,
    3636.5599999999995, 4367.549999999999, 4693.0599999999995, 4495.13,
    3062.7400000000002, 3975.2, 4143.38, 3604.9500000000003, 2776.39, 3279.17,
    3652.4, 4194.2, 3223.1800000000003, 3958.24, 4379.0599999999995,
    4114.4400000000005, 2915.3, 3328.79, 3855.4100000000003, 3740.5399999999995,
    2810.3599999999997, 2995.82, 3342.92, 3333.36, 2533.3700000000003, 3051.97,
    3840.6699999999996, 3911.2, 2665.6200000000003, 3639.7200000000003,
    5006.910000000001, 4502.070000000001, 3052.37, 4012.96, 5198.07, 4543.94,
    3182.89, 3787.2699999999995, 4997.9, 4773.74, 3465.15, 4239.679999999999,
    5004.3099999999995, 4502.09, 3518.29, 3933.97, 4719.38, 4765.55, 3213.72,
    3717.37, 4890.76, 4972.84, 3072.1900000000005, 3789.85, 5247.31,
    5023.110000000001, 3590.0499999999993, 4451.6900000000005, 5438.69, 5399.32,
    3641.2799999999997, 3796.33, 4540.929999999999, 4248.97, 2816.4,
    3367.1600000000003, 4597.26, 4539.37, 2948.45, 3731.38, 4588.200000000001,
    4447.84, 2896.99, 3686.8199999999997, 4044.99, 3898.12, 2464.7799999999997,
    2947.57, 3854.85, 3589.84, 2364.1800000000003, 2850.54, 3786.56, 3417.54,
    2340.31, 2944.51, 4355.32, 4183.860000000001, 2874.27, 3933.82, 5307.34, 4959.35,
    3124.24, 3906.38, 5389.24, 5211.74, 3669.7099999999996, 4331.08,
    5047.900000000001, 4710.6900000000005, 3067.59, 3859.49, 4229.28,
    3978.1600000000003, 2943.13, 3856.55, 5189.01, 4909.67, 4029.5, 4615.83, 5538.66,
    5168.02, 3526.91, 4148.889999999999, 4986.28, 4685.71, 3086.7700000000004,
    4035.04, 5292.07, 4867.35, 2869.57, 3817.9700000000003, 4779.72, 4526.25,
    2962.91, 3907.2, 4913.879999999999, 4354.93, 3047.69, 3971.73, 5228.16, 5135.31,
    3556.1099999999997, 4140.18, 5415.57, 5108.99, 3243.9799999999996, 3755.54, 4984,
    4818.6, 3265.9900000000007, 4052.54, 4961.0199999999995, 4592.32, 3224.92,
    3866.9, 4943.22, 4738.2, 3269.7900000000004, 3665.92, 4866.91,
    4862.4800000000005, 4200.99, 4362.23, 5313.07, 5370.68, 4547.48,
    4672.5199999999995, 5302.58, 4742.25, 3291.53, 3932.42, 5341.0199999999995,
    4984.66, 3547.45, 4226.9, 5457.379999999999, 5145.39, 3859.3599999999997,
    4195.13, 5299.4400000000005, 4680.04, 2740.52, 3250.4500000000003, 3815.92,
    4013.5, 2631.3199999999997, 3294.15, 5342.01, 5075.719999999999, 3800.87,
    4335.53, 5307, 4431.7699999999995, 3045.77, 3283.09, 4486.4, 4364.219999999999,
    3341.97, 4132.74, 5264.51, 5060.449999999999, 4151.38, 4557.88, 5644.02, 4872.13,
    3397.66, 4239.09, 4794.08, 3916.1000000000004, 2614.7, 3334.92, 4396.66, 4293.83,
    3264.58, 3812.77, 4647.66, 4632.07, 3198.0199999999995, 3916.44,
    5236.9800000000005, 4756.3099999999995, 3291.8199999999997, 4068.2899999999995,
    4714.34, 4473.82, 3534.9399999999996, 4065.7199999999993, 4558.39, 4426.51,
    3028.7999999999993, 3614.3, 5015.24, 4933.8, 3317.7400000000002, 4009.63,
    4495.370000000001, 4175.29, 3326.83, 2898.74, 4177.36, 3654.32,
    3077.4300000000003, 3369.02, 4328.07, 4584.15, 3666.68, 4149.07, 5114.37,
    4979.61, 3561.88, 3974.8499999999995, 4907.860000000001, 4580.77, 3105.77,
    3884.1800000000003, 4680.14, 4460.2699999999995, 3140.2, 3839.04, 4694.29,
    4459.15, 3288.8399999999997, 3819.91, 4774.13, 4590.53, 2947.14,
    3558.2899999999995, 4153.9, 3385, 3013.9700000000003, 3428.48,
    4328.9800000000005, 4452.14, 3909.6499999999996, 4164.6, 5057.41, 4742.27,
    3666.8900000000003, 3660.13, 4576.41, 4481.41, 3627.44, 4217.110000000001,
    5080.6900000000005, 4745.250000000001, 3419.9100000000003, 3941.42, 4638.35,
    4424.29, 2857.3500000000004, 3577.3600000000006, 4517.39, 4136.48,
    2490.5200000000004, 2832.59, 3703.89, 3728.3999999999996, 2879.16, 3920.34,
    4697.55, 4581.27, 3306.97, 3948.56, 5067.58, 4785.26, 3292.67, 3734.81, 4228.32,
    4071.33, 3044.2700000000004, 3807, 4953.71, 4843.13, 3679.18, 4389.77, 5327.04,
    4999.389999999999, 3473.1, 4194.36, 4532.42, 4246.96, 2976.44,
    3374.3100000000004, 4740.42, 4640.84, 3012.53, 3555.9999999999995, 4648.72,
    4588.07, 3071.7900000000004, 3740.7200000000003, 4746.670000000001, 4309.54,
    3311.6200000000003, 3870.01, 4808.24, 4150.8, 3167.2299999999996,
    3837.6600000000003, 5080.18, 4757.16, 2935.57, 3610.3500000000004, 5069.77,
    4894.43, 3112.59, 3628.31, 4987.49, 4784.700000000001, 2861.83, 3507.08, 4777.67,
    4597.5199999999995, 2916.77, 3522.58, 4884.65, 4659.349999999999, 3496.46,
    3828.69, 4568.72, 4661.92, 3295.37, 3839.91, 4948, 4792.02, 3829.45,
    3983.3700000000003, 4721.3, 4826.54, 3420.5699999999997, 3924.39, 5066.64,
    4761.74, 3177.0099999999998, 4090.17, 4964.03, 4755.089999999999,
    3435.3100000000004, 4304.5599999999995, 4994, 4708.349999999999, 3277.45,
    2743.5699999999997, 3351.67, 3463.8199999999997, 2366.26, 2818.69, 4395.27,
    4575.139999999999, 2840.3199999999997, 3496.11, 5015.21, 4926.02, 2871.21,
    3638.7199999999993, 5026.650000000001, 4723.829999999999, 3318, 3850.59, 4848.41,
    4825.19, 3807.4399999999996, 4340.49, 4868.49, 4855.959999999999, 3275.32,
    3647.92, 4908.79, 4636.87, 3235.41, 3754.91, 4741.49, 4631.9, 3728.99, 3702.38,
    5074.22, 5059.76, 3402.28, 3988.16, 5078.620000000001, 4922.5, 3123.82, 3857.56,
    4971.4800000000005, 4806.950000000001, 3836.07, 4165.43, 4977.1, 4630.12,
    2908.09, 3694.58, 4550.610000000001, 4182.59, 2824.62, 3335.1099999999997,
    4430.9, 4014.2000000000003, 2867.4100000000003, 2982.52, 4503, 4554.11, 2749.66,
    3613.95, 4955.08, 4671.12, 2967.44, 3640.9100000000003, 4028.5,
    3944.6400000000003, 2749.3799999999997, 3512.9600000000005, 4349.21,
    4271.889999999999, 3047.23, 3909.86, 4790.450000000001, 4757.54,
    3121.4300000000003, 3928.73, 5241.320000000001, 4977.549999999999,
    3155.9100000000003, 4048.2299999999996, 5059.18, 4866.36, 3055.36,
    3885.6900000000005, 4899.040000000001, 4573.19, 3591.6500000000005, 4176.27,
    4941.74, 4903.97, 3710.5699999999997, 4392.22, 5034.200000000001, 4917.35,
    4096.49, 3692.5200000000004, 4389, 4317.5199999999995, 3610.6400000000003,
    4343.54, 4632.67, 4140.21, 2947.08, 3298.2000000000003, 4089.85, 4488.19,
    2934.89, 3450.08, 3504.96, 3328.79, 2808.67, 3506.1899999999996, 4881.2, 4933.59,
    3630.95, 4221.7300000000005, 5073.6, 5005.699999999999, 3106.91, 3911.48,
    4358.5599999999995, 4244.110000000001, 3076.8500000000004, 3985.36, 4279.05,
    4433.450000000001, 3273.48, 4178.57, 4892.87, 4820.46, 3350.27, 4230.93, 4930.11,
    4739.290000000001, 3379.8599999999997, 3999.11, 4771.610000000001, 4520.57,
    3272.0999999999995, 3832.2599999999998, 4780.97, 5022.14, 3371.58, 4249.99,
    4647.4, 4714.04, 3351.82, 4110.91, 4285.5599999999995, 4536.12,
    3274.3799999999997, 3902.2799999999997, 4116.7, 4081.13, 3013.85, 3374.24,
    3811.8, 4042.1000000000004, 2834.74, 3387.9800000000005, 3913.2300000000005,
    4028.02, 2953.9300000000003, 3625.72, 3869.8999999999996, 3956.0799999999995,
    2781.24, 3297.84, 3656.89, 3892.81, 3464.81, 3973.34, 4495.28, 4855.160000000001,
    4250.56, 4528.51, 4750.47, 4379.099999999999, 3266.6099999999997,
    4048.3199999999997, 5034, 5169.95, 4408.58, 4776.09, 5155.05, 4874.87, 4384.33,
    4087.6499999999996, 3965.91, 3421.9300000000003, 2774.43, 2994.36, 3407.73,
    3409.73, 2917.27, 3804.37, 4494.4, 4534.93, 3455.64, 3860.6, 4205.79, 4546.48,
    3431.4199999999996, 4099.49, 4790.379999999999, 4958.07, 3330.1, 3969.96,
    4604.36, 4855.96, 3392.67, 3735.53, 4235.139999999999, 4414.3, 2908.42, 3776.81,
    4538.6, 4838.75, 3046.2499999999995, 4015.1499999999996, 4786.58, 4982.37,
    3135.3399999999997, 3976.7799999999997, 4698.55, 4857.69, 3616.56, 4431.65,
    4682.38, 4548.5199999999995, 3176.71, 3765.9399999999996, 3784.42, 3742.88,
    3291.67, 4173.320000000001, 4182.929999999999, 4051.15, 3447.66,
    3567.5299999999997, 3528.13, 3255.5200000000004, 2548.5699999999997,
    3275.8999999999996, 3417.21, 3275.6600000000003, 3018.9700000000003, 3755.94,
    3961.88, 3962.24, 3165.13, 4021.4199999999996, 4431.63, 4573.08, 3159.01,
    4025.63, 3802.08, 4155.66, 3488.6, 4461.13, 4827.09, 4909.68, 4377.94,
    5098.7300000000005, 5136.61, 4965.99, 4447.610000000001, 4783.37, 5062.78,
    4957.740000000001, 4442.139999999999, 4579.59, 4959.1900000000005,
    4969.839999999999, 4329.54, 4585.87, 4913.85, 5188.65, 4336.820000000001,
    4831.209999999999, 5016.76, 4920.639999999999, 3773.7299999999996, 4307.87,
    4727.11, 4739.719999999999, 3382.39, 3970.21, 4297.53, 4378.349999999999,
    4017.49, 4279.58, 4213.7, 3639.07, 2676.54, 3461.96, 4198.7, 4341.99, 3687.27,
    4252.5, 4689.88, 4857.0599999999995, 3323.74, 4004.1400000000003, 3810.5,
    3787.3099999999995, 3038.24, 3254.48, 3230.4700000000003, 3545.71,
    3542.9700000000003, 4621.78, 5030.429999999999, 4956.67, 4087.79, 4783.42,
    5074.669999999999, 4796.41, 3282.0800000000004, 3822.71, 3475.26, 3380.02,
    2594.44, 3475.87, 3921.3899999999994, 4115.3099999999995, 3281.09, 3878.96,
    3963.0600000000004, 3759.0899999999997, 2940.3499999999995, 3614.29,
    3777.3900000000003, 3938.21, 3249.45, 3647.94, 3446.02, 3768.6899999999996,
    3703.4100000000003, 4690.46, 4949.36, 4963.95, 3441.21, 3964.2599999999998,
    4206.84, 4491.78, 3934.8, 4555.24, 4865.5, 5037.06, 4024.4500000000003, 4541.98,
    4643.28, 4616.37, 3864.16, 4530.28, 4860.589999999999, 5091.53, 3954.31, 4791.04,
    5037.43, 5020.63, 3677.43, 4341.88, 4514, 4789.639999999999, 4153.74, 4754.04,
    4885.2300000000005, 5115.4800000000005, 4763.57, 4970.490000000001,
    4969.889999999999, 4706.12, 4265.34, 4261.34, 4470.5, 4639.82,
    4066.5699999999997, 3904.9900000000002, 3523.0699999999997, 3092.62, 2741.7,
    3221.62, 3323.3199999999997, 3472.9000000000005, 2887.15, 4012.96, 4787.2,
    4220.61, 3151.39, 3524.6800000000003, 3927.399999999999, 4397.04,
    4424.530000000001, 5003.86, 5206.63, 4996.65, 4465.129999999999, 5117.22,
    5328.82, 5433.150000000001, 4843.78, 5349.110000000001, 5417.16, 5399.17,
    5091.139999999999, 5387.000000000001, 5444.169999999999, 5409.92,
    5100.650000000001, 5022.92, 5086.59, 4972.15, 4883.87, 5016.5199999999995,
    5218.59, 5260.870000000001, 5118.57, 5114.429999999999, 5156.599999999999,
    5225.419999999999, 5083.32, 5273.62, 5433.73, 5410.93, 5445.499999999999,
    5473.529999999999, 5474.75, 5450.610000000001, 5352.25, 5433.73, 5191.43, 4732.8,
    4531.49, 4716.23, 4834.39, 4889.1, 4605.099999999999, 4787.469999999999,
    4539.3099999999995, 3831.49, 3481.2499999999995, 3874.16, 3967.42, 3495.9,
    3151.2999999999997, 3485.79, 3416.5599999999995, 3468.85, 4019.7000000000003,
    4245.22, 4083.74, 4112.58, 4436.9400000000005, 4295.08, 4055.8599999999997,
    3721.8900000000003, 4104.35, 4390.08, 4522.56, 4234.070000000001, 4208.69,
    4402.0599999999995, 4544.77, 4636.56, 4612.120000000001, 4777.42, 4267.22,
    3831.61, 3467.5899999999997, 3937.3999999999996, 3836.69, 3480.54, 3465.04,
    3829.6899999999996, 3460.26, 3313.61, 3338.7999999999997, 3864.36, 3875.97,
    4303.03, 4551.36, 4883.7, 4800.99, 4865.3, 4773.42, 4936.81, 4271.070000000001,
    3653.8200000000006, 4274.35, 4674.46, 4635.030000000001, 4529.53, 4845.83,
    5036.5599999999995, 5196.95, 5009.749999999999, 4475.28, 4496.67,
    4431.629999999999, 4330.35, 4031.81, 4478.500000000001, 4367.67, 4181.85,
    4070.63, 4522.77, 4632.01, 4600.8, 4807.91, 5227.17, 5379.299999999999,
    5438.9800000000005, 5358.92, 5359.82, 5408.4800000000005, 5283.21, 5101.61,
    4949.64, 4371.29, 3672.0200000000004, 3834.08, 4366.4400000000005, 4845.54,
    4809.65, 4582.09, 4467.91, 4503.18, 4498.45, 4780.18, 4882.43, 4679.82, 4370.61,
    4564.35, 4442.27, 4440.15, 4522.09, 5188.3, 5429.070000000001, 5623.150000000001,
    5645.22, 5562.1, 5443.14, 5474.66, 5585.5199999999995, 5520.96, 5400.63,
    5416.129999999999, 5527.549999999999, 5143.419999999999, 5275.66, 4882.39,
    4737.650000000001, 4384.67, 4353.84, 3846.47, 3426.04, 3222.7,
    3616.8200000000006, 3328.62, 3265.9499999999994, 3730.5299999999997, 3706.18,
    3534.06, 3405.17, 3737.48, 4065.17, 4145.51, 4342.49, 4269.76, 3970.95, 3538.69,
    3493.61, 3494.9799999999996, 3788.7799999999997, 3663.84, 3551.8, 3659.63,
    3859.21, 3848.1600000000003, 3726.0899999999997, 3380.47, 3632.19, 3503.44,
    3521.13, 3407.1899999999996, 4206.669999999999, 4424.81, 4506.31, 4823.57,
    4898.0599999999995, 5157.92, 5287.3, 5405.46, 5438.360000000001,
    5440.2699999999995, 4911.15, 4338.97, 4746.49, 4757.07, 4877, 4665.650000000001,
    5167.81, 5352.570000000001, 5466.49, 5221.26, 5412.150000000001, 5670.15,
    5704.09, 5325.67, 5392.5599999999995, 5463.949999999999, 4960.43, 4265.47,
    4576.860000000001, 4342.26, 3774.34, 3585.9700000000003, 3813.3599999999997,
    3659.34, 3525.4700000000003, 3373.7699999999995, 3942.98, 3369.7799999999997,
  ],
  PRT: [
    735.74, 697.99, 538.78, 478.46000000000004, 446.61, 349.20000000000005,
    333.44000000000005, 346.40999999999997, 399.22, 449.55, 648.02, 804.6, 634.01,
    627.1899999999999, 599.9300000000001, 571.83, 411.90000000000003,
    369.30999999999995, 390.77, 463.81, 525.29, 475.86999999999995, 491.63, 633.49,
    672.5500000000001, 548.87, 581.74, 749.18, 934.4300000000001, 924.94, 1057.14,
    1125.73, 1434.25, 1461.85, 1439.28, 1387.7400000000002, 1510.72,
    1254.0400000000002, 1273.26, 1222.26, 1055.3400000000001, 997.49, 1071.75,
    905.89, 650.4200000000001, 661.5799999999999, 746.2, 702.81, 338.8,
    389.78000000000003, 593.67, 663.53, 314.13, 302.26, 423.22, 435.29999999999995,
    354.03999999999996, 655.6400000000001, 734.0699999999999, 694.9,
    550.0699999999999, 621.9499999999999, 526.37, 459.40999999999997,
    244.90000000000003, 269.37, 268.24, 292.79, 239.85000000000002, 373.47, 551.11,
    592.76, 327.95000000000005, 400.40999999999997, 426.12, 510, 337.72,
    430.98999999999995, 554.37, 616.54, 513.53, 392.21000000000004, 441.51,
    450.84000000000003, 406.19000000000005, 409.04999999999995, 516.17, 670.72,
    660.81, 784.52, 799.95, 923.35, 707.22, 669.01, 750.4100000000001, 795.79,
    686.1099999999999, 621.66, 666.15, 649.41, 476.29999999999995, 571.92, 551.68,
    534.75, 310.71999999999997, 296.72, 398.32000000000005, 382.66999999999996,
    301.35, 301.82, 391.34, 349.68, 413.35, 507.02, 625.4000000000001,
    734.4100000000001, 598.33, 586.8899999999999, 706.5799999999999, 679.06, 527.82,
    575.31, 612.78, 541.72, 464.54, 421.41, 490.86, 484.8, 460.58, 428.81, 464,
    383.89, 431.84, 414.90999999999997, 536.9300000000001, 625.9100000000001, 746.64,
    578.6899999999999, 536.5, 608.05, 696.8399999999999, 755.58, 813.03, 858.02,
    830.9200000000001, 821, 606.66, 590.8499999999999, 545.13, 394.41,
    445.94000000000005, 457.57, 337.64, 282.94, 278.16999999999996, 305.57,
    460.98999999999995, 463.04, 409.82000000000005, 373.24, 347.28, 281.1,
    263.83000000000004, 307.2, 539.96, 393.31999999999994, 356.99,
    440.96999999999997, 396.56, 388.61, 505.65000000000003, 721.77, 716.44, 685.38,
    750.01, 790.9, 825.47, 579.63, 572.0699999999999, 567.95, 596.4599999999999,
    600.04, 566.74, 677.55, 961.11, 770.1999999999999, 783.6800000000001,
    847.0500000000001, 897.33, 587.02, 582.64, 688.5800000000002, 930.97, 770.04,
    591.79, 727.95, 883.29, 605.64, 665.71, 675.87, 681.9100000000001,
    600.8100000000001, 648.5999999999999, 747.49, 764.64, 608.3, 657.12, 612.64,
    400.39000000000004, 302.96, 294.07, 318.71000000000004, 380.71,
    327.04999999999995, 306.68, 309.27, 261.13, 278.35, 296.5, 281.18,
    215.54000000000002, 203.27, 201.69, 242.75, 210.24, 245.84, 238.48, 278.76,
    268.26, 282.22, 352.90999999999997, 415.93, 289.56, 327.08, 540.8,
    581.0999999999999, 327.61999999999995, 273.65000000000003, 248.29999999999998,
    288.99, 270.67, 303.21, 308.56, 358.52000000000004, 241.36, 218.26999999999998,
    219.51999999999998, 292.1, 261.67, 301.2, 339.45, 479.72, 270.24,
    265.03000000000003, 307.96, 422.26, 406.97, 585.73, 663.74, 869.5899999999999,
    812.2199999999999, 609.5099999999999, 579.42, 612.6400000000001, 254.19,
    240.61999999999998, 258.08, 309.96000000000004, 229.42000000000002,
    241.79999999999998, 253.78000000000003, 233.67000000000002, 243.68, 248.89,
    246.23999999999998, 237.42000000000002, 230.53999999999996, 233.10999999999999,
    235.73000000000002, 283.53, 504.28999999999996, 462.92, 680.95, 815.85, 591.78,
    537.2, 655.23, 740.61, 520.3399999999999, 464.98, 624.34, 766.5800000000002,
    567.5300000000001, 538.62, 580.38, 659.4200000000001, 551.11, 621.97,
    633.6500000000001, 787.13, 659.77, 567.84, 607.02, 706.2199999999999, 708.23,
    499.65000000000003, 582.63, 780.87, 738.8499999999999, 685.97, 747.26, 815.45,
    836.54, 736.86, 765.16, 890.99, 896.12, 727.46, 628.1, 669.4, 575.4499999999999,
    523.99, 564.7, 572.15, 503.47999999999996, 525.86, 626.0899999999999,
    621.5799999999999, 233.76999999999998, 246.56000000000003, 294.37, 271.89,
    239.70000000000002, 298.59000000000003, 374.18, 541.2099999999999,
    499.24000000000007, 404.07, 297.51, 419.5, 303.77, 312.37, 275.86,
    253.72000000000003, 219.5, 244.04, 266.81, 268.85, 299.74, 279.84000000000003,
    274.11, 278.27000000000004, 302.3, 346.96, 388.41, 470.28, 317.35999999999996,
    289.19, 390.61, 477.68000000000006, 361.98, 279.57, 276.68, 261.03999999999996,
    221.51, 263.16, 299.34000000000003, 453.85, 255.82, 244.03, 282.39000000000004,
    386.09, 318.59, 355.40000000000003, 360.73, 426.40999999999997, 297.99,
    292.34000000000003, 285.24, 298.99, 247.71, 260.47, 294.3, 251.90999999999997,
    282.80999999999995, 332.61, 378.49, 380.09000000000003, 426.51,
    380.41999999999996, 423.40999999999997, 382.08, 254.23, 267.75, 317.82, 293.87,
    313.38, 359.29, 433.35, 469.98999999999995, 386.16999999999996,
    411.10999999999996, 499.34000000000003, 470.33, 296.22, 337.63000000000005,
    429.48, 501.84000000000003, 300.63, 363.56, 489.59999999999997,
    540.1600000000001, 397.23, 378.05, 435.23, 475, 361.23, 415.65000000000003,
    377.83, 361.35999999999996, 297.99, 356.46, 383.40000000000003, 452.41, 410.52,
    401.18999999999994, 417.07000000000005, 414.81, 313.35, 337.63,
    432.11000000000007, 401.59999999999997, 296.93, 332.34999999999997,
    413.87999999999994, 428.8, 319.23, 317.99, 510.42, 564.43, 381.69,
    368.42999999999995, 412.63, 409.65999999999997, 332.90999999999997,
    362.19999999999993, 405.09000000000003, 421.75, 374.32, 350.40000000000003,
    387.27000000000004, 376.25, 309.58, 362.04, 388.64, 397.78999999999996, 365.98,
    410.46000000000004, 442.41, 438.94, 336.91, 285.55, 238.23, 315.78999999999996,
    343.00999999999993, 413.12000000000006, 334.06, 311.31, 310.56, 327.63, 339.42,
    411.13, 450.25, 535.86, 428.77, 366.12, 369.56, 404.4, 369.97,
    431.15999999999997, 366.86, 424.19, 358.84000000000003, 418.28000000000003,
    410.05999999999995, 393.5, 311.58, 392.63, 552.63, 432.37, 408.47,
    433.08000000000004, 500.21, 409.78, 363.93, 373.01, 376.40999999999997, 323.87,
    334.4, 432.01000000000005, 378.92, 337.49, 320.13, 362.81000000000006, 468.24,
    395.69, 467.02, 470.81000000000006, 358.08000000000004, 421.13000000000005,
    491.80999999999995, 485.12, 288.45, 354.23999999999995, 474.97,
    511.84000000000003, 450.29, 431.77, 475.72, 578.22, 531.24, 470.12, 465.93,
    529.56, 552.81, 474.96999999999997, 383.49999999999994, 412.03, 555.43, 458.52,
    388.87, 365.23, 476.65, 408.66999999999996, 344.12999999999994, 324.47,
    351.84000000000003, 367.01, 326.65000000000003, 360.62, 433.85,
    429.96000000000004, 365.46999999999997, 419.75999999999993, 464.73,
    436.7900000000001, 546.08, 489.29, 343.33000000000004, 458.59, 412.76,
    427.74999999999994, 411.13000000000005, 466.64, 394.02000000000004, 399.05,
    575.52, 520.26, 395.5, 380.74, 562.15, 478.94, 439.14, 428.61,
    489.68999999999994, 449.36000000000007, 417.2, 456.62, 527.4, 439.32, 401.99,
    439.74, 416.99999999999994, 434.82000000000005, 475.64000000000004, 527.86,
    566.71, 497.84999999999997, 519.66, 557.75, 623.5699999999999,
    477.40000000000003, 401.52000000000004, 490.7, 632.56, 527.38, 400.08,
    445.2200000000001, 481.05, 415.13, 411.08000000000004, 512.04, 512.3299999999999,
    459.61999999999995, 451.48999999999995, 509.75, 529.8299999999999,
    506.5799999999999, 466.13, 517.89, 518.09, 446.08000000000004, 419.15, 457.25,
    364.82, 369.89, 394.34, 419.42999999999995, 336.62, 349.09, 395.64000000000004,
    381.96999999999997, 329.52, 351.05, 429.84, 466.99, 443.28999999999996,
    461.40000000000003, 560.67, 720.87, 817.1200000000001, 560.3299999999999, 545.9,
    867.51, 954.11, 568.75, 483.1600000000001, 654.8100000000001, 643.17, 544.05,
    552.5899999999999, 661, 514.83, 437.5, 500.07, 518.03, 559.46, 572.77, 470.8,
    600.6, 629.09, 523.1, 493.68, 622.72, 631.7, 487.80999999999995,
    464.08000000000004, 542.61, 550.15, 506.22, 462.83, 564.47, 530.72,
    476.95000000000005, 442.33, 578.02, 623.24, 536.92, 430.76000000000005, 566.77,
    591.3, 467.72, 360.68, 447.14, 434.81000000000006, 351.16, 328.37,
    449.53000000000003, 521.38, 437.11, 368.04, 483.86, 609.48, 466.59000000000003,
    406.73, 674.48, 655.77, 533.66, 483.34999999999997, 720.69, 759.5099999999999,
    583.77, 483.21000000000004, 558.5899999999999, 618.9100000000001, 524.41,
    460.56000000000006, 534.1800000000001, 625.04, 530.0999999999999,
    448.18000000000006, 539.15, 557.63, 404.88, 371.25, 438.80999999999995, 473.14,
    414.84000000000003, 411.51, 519.01, 546.79, 440.15999999999997,
    460.40000000000003, 617.85, 665.71, 510.03999999999996, 440.04999999999995,
    604.1899999999999, 684.8499999999999, 534.56, 522.31, 647.74, 606.52, 551.66,
    502.08000000000004, 607.32, 674.27, 596.9200000000001, 502.21999999999997,
    636.89, 646.4899999999999, 523.88, 419.84000000000003, 501.85999999999996,
    697.2299999999999, 555.09, 447.66, 547.6800000000001, 612.4100000000001, 480.85,
    434.79, 562.35, 537.55, 467.77, 458.65, 587.6, 623.49, 484.67999999999995,
    429.00000000000006, 614.8, 603.6700000000001, 542.79, 559.8199999999999, 719.95,
    773.4, 597.19, 498.83000000000004, 447.53999999999996, 379.66999999999996,
    346.49, 303.41, 389.1, 471.19, 427.24, 365.66999999999996, 480.75,
    636.3599999999999, 500.69000000000005, 431.03999999999996, 583.63, 641.4, 507.8,
    588.0699999999999, 778.1099999999999, 876.23, 653.5600000000001, 621.85, 923.03,
    796.3199999999999, 616.72, 545.0899999999999, 537.23, 570.39, 511.02000000000004,
    444.69999999999993, 607.76, 639.15, 466.25, 400.17999999999995, 532.99, 716.23,
    509.02, 403.23, 479.61999999999995, 596.09, 563.22, 512.83, 568.38,
    622.4799999999999, 610.6100000000001, 554.4499999999999, 670.77, 787.69, 664.9,
    599.53, 886.74, 1147.39, 894.6600000000001, 836.45, 1030.87, 1251.3,
    986.2200000000001, 780.92, 846.64, 843.8399999999999, 575.86, 421.68, 432,
    719.21, 584.1899999999999, 553.6, 561.1, 570.41, 557.28, 680.51, 817.22, 819.53,
    732.54, 692.85, 838.08, 899.14, 782.5699999999999, 675.28, 781.51, 812.18,
    643.04, 614.8000000000001, 660.89, 721.0500000000001, 658.05, 605.76, 653.22,
    782.2500000000001, 701.9599999999999, 613.68, 741.22, 810.0699999999999, 593.56,
    551.1999999999999, 923.16, 1124.67, 1016.4399999999999, 937.3000000000001,
    1043.0700000000002, 1025.37, 884.19, 706.86, 1087.46, 1290.41, 929.87,
    755.8199999999999, 917.1600000000001, 1162.66, 867.44, 685.72, 628.19, 530.62,
    544.79, 495.23, 592.6, 649.15, 485.67999999999995, 478.14, 756.97,
    945.4899999999999, 662.48, 540.66, 720.32, 972.9799999999999, 719.94,
    604.3399999999999, 710.5300000000001, 859.4, 746.43, 630.1, 682.87,
    782.7200000000001, 701.3199999999999, 650.16, 775.5899999999999, 882.59, 704.23,
    656.48, 792.39, 876.51, 746.01, 668.6, 775.98, 748.52, 599.44, 558.04, 793.68,
    925.5699999999999, 659.18, 546.72, 754.95, 878.7099999999999, 710.09, 599.97,
    614.3499999999999, 672.83, 646.45, 647.87, 659.0400000000001, 743.43, 699.77,
    633.5600000000001, 738.0699999999999, 773.3, 513.53, 436.15, 595.02, 862.73,
    738.22, 650.26, 698.52, 671.1700000000001, 621.43, 500.54999999999995, 485.11,
    610.54, 578.67, 497.72, 653.39, 710.15, 585.6800000000001, 484.38, 604.4, 655.96,
    633.9100000000001, 607.5699999999999, 674.24, 644.08, 547.06, 581.79,
    818.5699999999999, 791.6899999999999, 760.1800000000001, 656.4, 682.12, 794.72,
    744.61, 706.52, 818.6600000000001, 705.5, 563.3299999999999, 460.78999999999996,
    530.02, 564.39, 512.21, 520.23, 665.88, 780.64, 641.02, 716.84,
    953.9900000000001, 1078.3899999999999, 765.7700000000001, 635.72, 832.79, 990.26,
    779.4499999999999, 675.76, 876.01, 978.25, 770.0699999999999, 646.98, 843.13,
    1008.8199999999999, 817.05, 710.0699999999999, 997.03, 1122.02,
    883.9200000000001, 696.13, 805.3399999999999, 969.4, 865.8199999999999, 609.43,
    739.04, 935.6700000000001, 856.89, 702.48, 770.3299999999999, 885.1300000000001,
    775.4599999999999, 719.25, 798.0999999999999, 779.49, 637.48, 686.59,
    782.9000000000001, 758.7, 714.7900000000001, 675.2900000000001, 655.53, 719.17,
    653.77, 623.23, 760.2099999999999, 710.9200000000001, 674.3699999999999, 702.59,
    787.8700000000001, 875.19, 687.5100000000001, 510.5, 677.6700000000001,
    742.8199999999999, 716.1, 663.8399999999999, 776.97, 806.93, 706.53, 665.37,
    767.7900000000001, 660.15, 612.5999999999999, 598.25, 587.8599999999999, 559.39,
    618.6, 603.5, 592.51, 431.47999999999996, 540.3199999999999, 626.1800000000001,
    613.58, 661.8, 591.54, 675.13, 713.42, 886.95, 637.9300000000001, 603.41, 591.4,
    532.1600000000001, 491.24, 552.26, 553.1, 471.52, 454.37, 532.96, 497.39,
    435.59999999999997, 530.5, 693.38, 944.0999999999999, 969.5, 782.5999999999999,
    924.5800000000002, 1047.03, 1012.58, 802.81, 862.3900000000001,
    1048.8000000000002, 1095.3899999999999, 778.5400000000001, 716.85, 843.39,
    999.6200000000001, 873.74, 737.75, 689.0999999999999, 837.5899999999999, 721.52,
    661.59, 669.68, 751.99, 750.62, 691.38, 729.7600000000001, 664.71,
    497.40000000000003, 447.51, 458.78000000000003, 420.35999999999996, 422.72,
    462.11, 543.92, 523.73, 511.21000000000004, 495.92999999999995, 512.95,
    504.96999999999997, 496.88, 622.86, 666.24, 749.86, 627.48, 598.48, 654.51,
    804.43, 718.4100000000001, 775.37, 754.01, 786.7500000000001, 689.78, 779,
    789.44, 606.8100000000001, 563.3299999999999, 573.49, 662.0800000000002, 753,
    686.9599999999999, 729.9300000000001, 719.2299999999999, 795.47, 750.24, 804.31,
    817.45, 770.86, 523.6, 408.85999999999996, 387.39, 454.4599999999999, 450.49,
    388.88, 405.29, 619.97, 435.15999999999997, 390.29, 401.3, 440.88000000000005,
    422.40999999999997, 394.24999999999994, 373.24, 488.78, 499.0199999999999, 381.1,
    448.79, 563.66, 526.17, 681.72, 795.9499999999999, 449.85, 360.73, 405.39,
    375.46000000000004, 456.01000000000005, 526.0999999999999, 566.44, 436.49,
    403.11, 451.92999999999995, 566.22, 617.92, 829.6500000000001, 671.08,
    752.3600000000001, 698.54, 668.65, 555.34, 629.67, 605.26, 694.7099999999999,
    600.43, 654.9399999999999, 723.9599999999999, 672.97, 540.92, 548.1300000000001,
    545.43, 648.83, 527.72, 513.39, 541.51, 575.14, 475.98, 494.30999999999995,
    666.72, 905.86, 729.96, 716.67, 781.3100000000001, 1035.02, 739.18, 763.26,
    747.79, 812.4, 577.6500000000001, 644.8800000000001, 641.3, 700.4200000000001,
    576.1299999999999, 745.53, 729.22, 733.64, 582.5500000000001, 513.27, 609.28,
    680.75, 567.99, 563.51, 499.22, 721.0699999999999, 609.4899999999999, 489.32,
    337.57, 545.36, 564.57, 502.5, 404.9, 499.06, 411.73, 593.74, 594.11, 605.38,
    505.18, 556.18, 489.77, 646.9300000000001, 612.14, 734.95, 577.4100000000001,
    635.45, 553.21, 600.3199999999999, 602.0699999999999, 599.84, 601.04, 655.9,
    561.29, 621.0799999999999, 638.13, 798.68, 590.47, 691.55, 536.16, 503.67,
    482.30999999999995, 771.1899999999999, 554.3, 671.29, 657.4699999999999,
    792.3500000000001, 618.3699999999999, 772.79, 868.52, 945.22, 707.1599999999999,
    838.24, 762.22, 799.05, 640.6700000000001, 733.06, 622.87, 951.12,
    781.1999999999999, 801.23, 944.18, 1103.61, 899.1100000000001, 781.4200000000001,
    813.32, 971.87, 744.9200000000001, 676.96, 769.62, 961.0300000000001,
    644.8100000000001, 590.7, 610.21, 702.6899999999999, 640.3700000000001,
    692.9200000000001, 570.97, 562.6199999999999, 511.48999999999995, 513.83, 502.99,
    556.74, 514.8100000000001, 568.28, 604.07, 774.41, 619.3199999999999, 695.49,
    643.8500000000001, 756.6899999999999, 630.97, 615.19, 621.7799999999999, 707.13,
    753.99, 980.6099999999999, 952.51, 1467.81, 1006.6300000000001, 1056.44,
    1072.8200000000002, 1528.19, 959.3100000000001, 836.88, 749.0600000000001,
    708.34, 601.98, 623.93, 667.78, 715.37, 602.78, 545.4799999999999,
    536.1199999999999, 653.19, 789.5299999999999, 855.96, 730.09, 735.4100000000001,
    525.5799999999999, 512.03, 511.28, 525.9499999999999, 508.96999999999997,
    478.51000000000005, 480.53000000000003, 658.99, 656.79, 720.01,
    840.4599999999999, 1263.16, 951.21, 1026.6599999999999, 1055.51,
    1335.5900000000001, 862.7599999999999, 884.21, 689.2, 679.0799999999999, 563.52,
    599.76, 693.43, 864.3100000000001, 717.5799999999999, 852.7, 716.5400000000001,
    973.4000000000001, 713.2099999999999, 808.08, 737.02, 939.2199999999999, 859.44,
    827.56, 845.3800000000001, 1320.5299999999997, 1120.96, 1144.12, 1188.04,
    1459.83, 1158.0099999999998, 1008.6800000000001, 857.56, 810.14, 792.9, 837.03,
    997.2599999999999, 1180.3899999999999, 960.4100000000001, 953.14, 955.3,
    955.5100000000001, 804.21, 812.28, 781.8699999999999, 555.97, 478.62, 425.84,
    428.35, 435.97999999999996, 420.22, 411.7, 435.65000000000003,
    503.33000000000004, 488.69, 590.2299999999999, 778.5999999999999, 1095.94,
    1079.58, 1119.15, 1177.9099999999999, 1532.57, 1182.99, 1407.38, 1307.04,
    1581.14, 1122.56, 1359.3200000000002, 1312.1599999999999, 1752.1399999999999,
    1279.96, 1465.7000000000003, 1431.2399999999998, 1657.74, 1331.09, 1176.94, 1113,
    1039.86, 728.81, 673.43, 573.82, 688.37, 694.1700000000001, 755.48, 735.56,
    940.52, 824.52, 851.3599999999999, 790.8799999999999, 980.7, 734.5, 665.99,
    519.44, 546.5, 596.14, 653.0500000000001, 760.37, 903.4599999999999,
    775.5799999999999, 795.74, 784.62, 957.49, 772.79, 768.78, 787.85, 1056.08,
    840.12, 699.1399999999999, 676.47, 670.4, 672.17, 661.8999999999999, 623.95,
    574.39, 496.11, 552.8299999999999, 605.74, 775.8000000000001, 684.58,
    785.1800000000001, 790.9200000000001, 1112.9599999999998, 933.63, 913.36,
    1018.54, 1197.3600000000001, 844.58, 901.6, 973.4899999999999, 1108, 888.52,
    922.38, 1025.6799999999998, 1390.6000000000001, 1106.58, 960.5599999999998,
    1026.18, 1482.46, 1017.28, 1043.83, 1151.44, 1613.32, 1077.02, 998.1700000000001,
    1006.1,
  ],
  SWE: [
    356.44000000000005, 330.18, 199.89, 282.45, 324.59, 164.49, 138.04999999999998,
    205.41, 247.68000000000004, 188.57999999999998, 160.19, 165.16, 290.05, 178.06,
    279.02, 248.92, 338.78, 336.76, 372.20000000000005, 311.35, 416.95000000000005,
    404.77, 407.2, 395.49, 421.90999999999997, 394.89, 342.76000000000005,
    242.64999999999998, 282.95, 372.82, 304.58, 148.06, 132.07999999999998, 168.45,
    182.46999999999997, 151.09, 143.33, 175.89999999999998, 164.93, 128.44, 125.88,
    153.16000000000003, 172.23999999999998, 155.84000000000003, 140.81, 158.88,
    164.19, 156.11, 141.64, 145.56, 149.56, 159.62, 200.99, 190.45000000000002,
    173.04999999999998, 177.51999999999998, 170.18, 162.41, 182.85999999999999,
    157.04999999999998, 215.25, 395.5799999999999, 301.54, 157.92, 142.07,
    139.92000000000002, 141.29000000000002, 147.29000000000002, 141.07, 155.19,
    148.39, 128.02, 127.73, 192.18, 218.87, 252.5, 311.09000000000003,
    271.45000000000005, 237.44, 144.76, 134.70000000000002, 134.25, 134.89, 135.96,
    154.44, 125.57, 129.75, 137.57999999999998, 159.79, 133.98, 131.6, 151.45,
    208.17000000000002, 135.91, 154.82, 144.71, 173.1, 154.16, 148.28,
    147.51999999999998, 140.45, 138.49, 141.91000000000003, 129.9,
    119.21000000000001, 118.02000000000001, 111.19999999999999, 112.17999999999999,
    108.85, 115.30999999999999, 115.42999999999999, 114.20999999999998,
    113.10999999999999, 125.38, 150.4, 150.25, 146.04, 139.5, 137.91000000000003,
    141.36, 123.19999999999999, 118.14000000000001, 100.60999999999999,
    107.46000000000001, 107.06, 115.34, 113.87, 114.9, 117.1, 122.04,
    113.72000000000001, 115.53, 119.51, 112.31, 103.13999999999999, 108.89, 116.37,
    122.88, 127.61, 137.53, 191.57, 140.23, 155.39999999999998, 193.78, 235.72,
    256.5, 201.97000000000003, 203.20999999999998, 270.02, 279.78, 270.46, 163.32,
    141.29999999999998, 220.81, 215.97, 184.64, 228.23999999999998,
    196.73999999999998, 143.72, 129.8, 135.02, 136.41, 136.32, 134.41, 232.31,
    144.25, 132.71, 131.23, 137.56, 140.7, 139.51999999999998, 140.93, 137.94,
    148.45000000000002, 151.74999999999997, 148.84, 178.41, 171.11,
    161.20000000000002, 145.22, 141.93, 146.75, 146.28, 132.53, 131.10999999999999,
    124.86, 139.32, 126.23, 106.8, 113.15, 119.84, 125.69999999999999, 131.34,
    136.74, 128.08999999999997, 119.52000000000001, 156.25, 141.78, 144.35,
    131.67000000000002, 129.25, 155.73000000000002, 140.03, 124.69999999999999,
    127.64999999999999, 129.29, 135.10999999999999, 138.43, 124.97, 129.66, 132.74,
    129.55, 121.8, 105.07, 105.02, 102.52000000000001, 111.81, 130.61, 135.9,
    114.71000000000001, 91.97, 112.80999999999999, 123.17, 111.47999999999999,
    121.97, 142.52, 145.66, 134.69, 130.06, 146.7, 139.07, 123.43,
    113.08000000000001, 119.76, 119.6, 111.89, 100.53999999999999, 97.26,
    102.10000000000001, 110.94, 115.87, 126.11, 128.29999999999998,
    128.73000000000002, 137.34, 135.33, 141.29, 135.72, 134.01, 151.89, 183.38,
    124.66, 130.49, 169.71, 143.60000000000002, 131.98, 132.42000000000002, 136.04,
    138.47, 133.64, 139.4, 161.36, 152.34, 147.04, 138.95, 153.83, 150.83, 140.1,
    140.38, 178.19, 189.95999999999998, 146.82999999999998, 224.69,
    254.79000000000002, 206.32, 147.44, 247.51, 287.62, 205.44, 139.3,
    179.57999999999998, 161.64, 145.48000000000002, 134.85, 139.13,
    150.76999999999998, 152.51, 146.68, 142.49, 151.14999999999998, 143.42, 129.06,
    125.24000000000001, 127.20000000000002, 118.59000000000002, 114.44, 113.91,
    143.14, 142.73, 121.98, 120.53, 124.35000000000001, 132.39, 121.58000000000001,
    130.67999999999998, 202.64, 173.72000000000003, 131.48000000000002, 145.22,
    155.03, 152.81, 155.29, 146.64000000000001, 157.30999999999997, 158.48, 150.86,
    153.16000000000003, 166.81, 170.76, 160.13000000000002, 132.01, 215.92,
    155.46000000000004, 140.97, 131.48000000000002, 162.31, 151.7, 140.44, 145.59,
    256.94, 222.4, 200.13, 371.88, 370.91999999999996, 272.02, 140.92, 145.49, 205.1,
    167.95999999999998, 147.94, 145.84, 211.25, 182.06, 126.69, 132.01999999999998,
    162.35999999999999, 145.54999999999998, 141.25, 145.45, 178.91, 190.19, 129.41,
    116.97, 178.09, 169.12, 141.21, 148.7, 227.64, 190.26, 136.35000000000002,
    153.25, 306.65000000000003, 282.35, 169.79999999999998, 150.92, 205.12, 171.01,
    123.78999999999999, 127.08999999999997, 209.33, 192.89000000000001, 116.56,
    109.70999999999998, 127.44, 135.75, 125.27999999999999, 134.23000000000002,
    138.82, 128.38000000000002, 126.74999999999999, 132.35999999999999, 206.56,
    213.01999999999998, 155.54, 154.59, 254.96999999999997, 249.90000000000003,
    163.35999999999999, 170.90000000000003, 226.68, 169.79999999999998, 116.47,
    115.34000000000002, 153.20999999999998, 133.26, 125.63000000000001,
    129.35999999999999, 191.64, 158.2, 115.82000000000001, 110.72999999999999,
    114.41, 110.31, 100.11, 101.16, 136.39, 109.72, 93.13000000000001, 100.78,
    223.41, 165.63, 98.63000000000001, 97.41999999999999, 177.71, 173.95000000000002,
    127.26999999999998, 131.38, 201.95999999999998, 173.32999999999998, 95.34,
    113.72, 160.13000000000002, 162.84, 153, 148.14, 185.13, 155.17, 142.28, 168.23,
    212.16, 163.92000000000002, 141.42000000000002, 163.51, 249.91999999999996,
    175.24, 150, 161.62, 175.31000000000003, 162.13, 146.58, 129.71, 143.94, 137.79,
    132.52, 131.14000000000001, 287.28, 249.07999999999998, 148, 147.91, 183.34,
    198.02999999999997, 193.21999999999997, 163.52, 189.9, 194.39000000000001,
    191.33, 188.04, 252.85999999999999, 242.68, 167.8, 194.79999999999998, 237.79,
    190.13000000000002, 157.18999999999997, 149.26999999999998, 221.95, 186.06,
    150.22, 148.45000000000002, 320.59000000000003, 305.98999999999995,
    165.26000000000002, 305.61, 337.66999999999996, 238.87, 143.07, 145.94, 196.25,
    160.83, 138.09, 132.07, 223.98, 184.99, 127.51999999999998, 127.44000000000001,
    270.48, 206.39000000000001, 112.52999999999999, 113.79, 177.19, 144.64, 107.71,
    111.99, 147.60999999999999, 130.13, 106.95, 107.64999999999999,
    171.51999999999998, 145.23999999999998, 119.7, 113.02, 261.25, 203.87, 104.84,
    100.39, 147.06, 127.25, 114.69, 117.82000000000001, 151.15, 145.69,
    124.50999999999999, 122.88, 144.68, 130.48, 122.56, 117.06, 219.92000000000002,
    174.52, 93.89999999999999, 94.41, 156.8, 138.93, 110.11999999999999, 114.97,
    250.55, 205.58, 100.05, 101.19000000000001, 309.52, 247.14, 100.41, 104.02,
    200.64, 153.23999999999998, 101.14, 101.11, 198.08, 159.19, 107.80000000000001,
    104.97000000000001, 203.24, 139.4, 99.55000000000001, 100.60000000000001,
    203.45999999999998, 155.41, 94.35000000000001, 99.28, 178.35000000000002, 142.26,
    99.99000000000001, 108.18, 189.16, 152.38000000000002, 106.10999999999999,
    110.11999999999999, 194.62, 173.57, 103.62, 102.27999999999999, 201.89,
    149.57999999999998, 94.87, 97.68, 138.95, 126.64, 95.76, 98.26, 137.6, 123.34,
    97.57, 102.36999999999999, 138.64000000000001, 121.6, 92.78, 100.57, 108.74,
    110.29, 93.31, 97.26, 171.72, 141.46, 99.09, 101.39, 231.10000000000002, 170.8,
    93.55, 100.84000000000002, 132.15, 115.97, 104.88, 107.18, 132.12, 120.28,
    95.14000000000001, 98.78, 128.54000000000002, 117.85, 95.12, 94.13999999999999,
    151.17, 139.84, 136.82000000000002, 88.11, 118.95, 108.97, 89.13, 92.8,
    129.23000000000002, 134.19, 89.13000000000001, 97.03, 239.02, 193.69000000000003,
    94.56, 99.30000000000001, 118.22, 105.94999999999999, 87.69, 95.46, 131.19,
    115.62000000000002, 93.35, 98.51, 118.66, 107.36000000000001, 90.8,
    92.21000000000001, 125.11, 109.50000000000001, 86.87, 93.58, 126.48,
    122.04999999999998, 89.49, 92.62, 196.87, 148.71, 82.78, 92.78, 175.16,
    156.60000000000002, 87.91, 91.84, 112.82999999999998, 112.44, 96.15, 99.79,
    186.19, 164.31, 86, 88.02000000000001, 120.49, 106.05, 82.64999999999999,
    86.57000000000001, 105.99000000000001, 104.62, 98.22, 100.06, 116.71000000000001,
    110.99, 87.43, 125.35, 192.79, 196.98, 87, 136.95999999999998, 307.07, 222.62,
    94.49, 106.08000000000001, 130.35, 117.59000000000002, 103.38999999999999,
    109.85000000000001, 126.65, 121.57000000000001, 99.95, 104.84000000000002,
    125.02, 117.29, 92.05, 99.03999999999999, 138.15, 125.66, 101.05,
    109.69000000000001, 154.71, 140.3, 108.59, 110.03, 203.52, 213.49,
    107.80999999999999, 115.24, 340.81000000000006, 252.96, 107.3, 110.19, 145.62,
    139.20000000000002, 108.03, 105.83999999999997, 163.32999999999998,
    151.70999999999998, 108.1, 106.28, 142.02, 134.20000000000002, 104.45,
    102.30000000000001, 138.18, 124.97, 99.21000000000001, 101.53999999999999,
    138.51, 125.58999999999999, 95.52, 107.38, 134.39999999999998, 127.06, 106.94,
    116.32000000000001, 240.31, 187.39000000000001, 106.55000000000001,
    112.79999999999998, 130.29, 116.13999999999999, 93.49, 98.68, 125.09, 119.16,
    101.71000000000001, 102.87, 123.72, 117.83000000000001, 98.15,
    117.58999999999999, 155.72, 151.03, 102.66000000000001, 101.9, 177.43, 143.47,
    101.92, 140.05, 280.16999999999996, 205.65, 125.38000000000001, 123.09, 183.12,
    167.04999999999998, 111.19, 110.8, 125.52999999999999, 115.4, 98.94,
    103.24000000000001, 157.64, 134.20999999999998, 99.66, 102.79, 133, 120.62,
    97.98, 107.28, 124.61, 120.83999999999999, 106.48, 101.38999999999999, 125.25,
    119.13, 101.33000000000001, 106.03, 207.02, 183.67, 107.88999999999999,
    115.11000000000001, 255.96, 205.87999999999997, 104.92, 105.57000000000001,
    128.91000000000003, 115.53999999999999, 94.63000000000001, 97.80999999999999,
    137.51, 125.88, 85.94999999999999, 92.94999999999999, 108.39000000000001, 110.7,
    93.71000000000001, 93.09, 110.74, 105.23, 82.17999999999999, 87.68, 117.8,
    107.31, 82.2, 83.67999999999999, 176.32999999999998, 154.88000000000002,
    100.03999999999999, 96.52000000000001, 192.55, 131.88, 87.4, 88.93,
    105.53999999999999, 105.92, 88.53, 93.63000000000001, 114.4, 106.24, 91.47,
    90.44999999999999, 113, 118.91, 80.47, 83.97, 113.44000000000001,
    109.82999999999998, 81.05, 87.18999999999998, 107.64999999999999,
    96.83999999999999, 85.96000000000001, 88.87, 111.06, 107.92000000000002, 85.32,
    88.76, 157.04, 170.13, 81.38000000000001, 84.19999999999999, 163.26000000000002,
    133.9, 83.73, 86.47000000000001, 147.04, 112.32000000000001, 81.79,
    83.47999999999999, 110.42999999999998, 101.28999999999999, 78.4, 81.7, 114.86,
    104.73, 79.95, 82.87, 111.75999999999999, 100.3, 80.61, 85.33, 138.56, 130.53,
    77.50999999999999, 77.94999999999999, 211.01999999999998, 182.75000000000003,
    76.77000000000001, 80.65, 107.94, 104.75999999999999, 78.3, 81.19,
    131.17999999999998, 114.64, 78.33, 79.9, 105.38000000000001, 93.87,
    80.25999999999999, 80.68, 99.55000000000001, 94.06000000000002, 89.73,
    92.56000000000002, 116.84, 105.45999999999998, 89.47999999999999, 102.41, 164.77,
    140.3, 84.47, 87.63, 210.56, 175.44, 81.41999999999999, 82.39, 112.6, 99.22,
    79.37, 85.44, 135.32000000000002, 111.63, 79.78, 83.96, 120.19,
    106.14999999999999, 80.29999999999998, 87.49000000000001, 144.34, 116.64,
    90.72999999999999, 88.64, 93.49000000000001, 93.53000000000002,
    79.38000000000001, 79.95, 111.07000000000001, 101.74000000000001, 78.27, 80.04,
    105.46, 90.37, 83.86, 89.37, 114.47, 102.16, 80.53, 78.91, 108.47000000000001,
    95.95999999999998, 83.53999999999999, 79.65, 110.16999999999999, 110.13, 86.74,
    94.62, 122.11, 105.95000000000002, 77.24, 80.77000000000001, 115.91999999999999,
    104.29, 82.48, 91.71000000000001, 130.31, 127.57, 95.75, 102.88,
    118.52999999999999, 108.91999999999999, 90.89, 81.61000000000001, 100.51, 91.01,
    95.21000000000001, 86.71, 101.23, 94.9, 83.63000000000001, 87.65, 112.6, 98.94,
    75.44, 73.25999999999999, 101.22999999999999, 89.64999999999999, 87,
    101.17999999999998, 110.56, 96.79, 83.91000000000001, 77.35, 116.56000000000002,
    101.31, 81.63, 86.04999999999998, 129.84, 112.44, 80.13, 81.53999999999999,
    105.22000000000001, 97.86999999999999, 83.84, 81.5, 109.96999999999998,
    105.67000000000002, 84.91, 83.17, 108.4, 95.92999999999999, 77.02, 78.38, 140.93,
    125.5, 76.93, 80.38, 111.65, 97.75, 80.94, 84.5, 115.91999999999999,
    104.94999999999999, 77.72, 79.17, 135.71, 97.66, 84.24000000000001, 86.36,
    95.94999999999999, 86.84, 82, 84.11, 107.91, 98.48, 82.66, 81.94,
    93.02000000000001, 84.35000000000001, 80.33, 78.14999999999999, 97.23, 88.01,
    77.25999999999999, 79.22000000000001, 97.85, 90.55, 75.34, 77.53, 134.24, 125.38,
    77.25, 77.79999999999998, 142.34, 104.75, 78.04999999999998, 81.31,
    102.00999999999999, 96.19, 81.68, 81.16, 103.45999999999998, 93.13, 77.66, 75.89,
    100.92999999999999, 96.19999999999999, 73.28999999999999, 74.76,
    113.86000000000001, 99.53, 77.49999999999999, 74.16, 112.71999999999998, 97.14,
    72.07, 75.55000000000001, 110.36, 94.19, 69.28999999999999, 68.41, 92.36, 88.54,
    69, 69.81, 92.74000000000001, 87.09, 77.25, 79.21000000000001, 88.3, 83.36,
    81.47999999999999, 79.50999999999999, 88.06, 83.67, 82.09, 82.99, 98.34, 84.29,
    82.39, 99.35, 90.00999999999999, 83.94, 75.37, 74.89, 118.76000000000002,
    102.16999999999999, 73.32, 72.24, 108.13, 87.23, 74.61, 93.45, 115.72, 94.6,
    78.41, 77.35000000000002, 93.80000000000001, 91.46, 80.92, 81.91,
    103.50999999999999, 95.23000000000002, 83.46000000000001, 80.34,
    103.34000000000002, 95.69, 79.05000000000001, 78.15, 109.22999999999999,
    99.69999999999999, 85.89, 84.66999999999999, 99.51, 92.8, 83.39000000000001,
    81.08, 103.74, 107.85000000000001, 85.56, 93.27, 98.9, 93.46000000000001,
    82.66000000000001, 85.00999999999999, 98.3, 91.2, 86.02000000000001, 88.75,
    96.25, 85.23, 85.75, 90.56, 91.2, 86.58, 88.97, 89.67, 95.93, 87.57000000000001,
    79.48, 83.4, 97.73, 85.33000000000001, 81.63, 86.59, 130.33, 114.09, 85.01,
    86.97999999999999, 103.31999999999998, 100.01, 82.4, 83.06, 109.83,
    106.08000000000001, 88.88999999999999, 99.46000000000001, 106.85,
    95.12999999999998, 88.04, 86.03, 95.75, 89.03, 85.77, 82.61, 89.26, 86.54, 82.75,
    80.74, 87.09, 78.67999999999999, 80.82, 92.3, 104.23000000000002, 99.19,
    86.32000000000001, 78.61, 83.49, 81.03, 83.38000000000001, 91.29,
    96.58999999999999, 88.91, 85.70000000000002, 85.92, 101.35, 95.29, 87.55, 90.78,
    101.88999999999999, 98.98, 93.13, 94.68, 109.7, 101.37, 98.15, 93.51,
    141.04999999999998, 171.6, 93.41000000000001, 90.13000000000001, 92.61, 99.21,
    96.31, 88.23, 97.42999999999999, 101.27, 100, 99.61, 138.85, 106.59,
    91.74000000000001, 90.30999999999999, 103.02000000000001, 100.31, 89.59, 78.05,
    82.12, 80.67, 80.03, 84.57000000000001, 88.46000000000001, 79.39000000000001,
    76.5, 77.06, 98.64, 95.75999999999999, 80.49, 76.27, 79.05999999999999, 77.4,
    82.13999999999999, 97.58, 134.77, 124.75999999999999, 107.46, 95.3, 124.21,
    137.04999999999998, 122.55, 107.54, 123.46, 126.21, 114.47, 103.85000000000001,
    139.26, 143.37, 126.07, 112.30000000000001, 139.31, 133.2, 117.41000000000001,
    114.5, 109.64, 118.97999999999999, 115.05, 105.93, 112.07, 122.54,
    116.94000000000001, 113.16999999999999, 164.04000000000002, 163.99, 122.53,
    116.48, 196.57, 180.95, 122.75999999999999, 122.74000000000001,
    158.45999999999998, 137.33, 122.47, 112.44999999999999, 133.26, 133.35, 116.58,
    109.46000000000001, 113.54, 111.58, 96.66000000000001, 93.73, 100.74000000000001,
    97.57, 106.25, 104.37, 86.09, 90.95, 102.78, 163.72, 154.10999999999999, 143.63,
    151.14000000000001, 137.79000000000002, 170.74, 162.32999999999998, 128.73,
    109.48999999999998, 132.94, 133.81, 115.84, 99.09, 147.26000000000002, 152.33,
    141.98, 120.78, 228.14, 215.22, 135.22, 102.6, 110.82000000000001,
    118.67999999999999, 117.18, 138.86, 135.07000000000002, 104.23000000000002,
    96.71, 110.42, 111.69, 109.24000000000001, 110.54, 117.44, 116.14999999999999,
    120.97000000000001, 113.07, 117.69, 143.79, 178.39999999999998,
    170.42000000000002, 188.05, 155.47, 145.73000000000002, 138.4, 137.24, 155.81,
    132.05, 114.7, 105.16000000000001, 108.07999999999998, 106.06, 99.75,
    99.58999999999999, 106.38000000000001, 115.56, 123.12, 121.52999999999999,
    126.03, 124.78, 109.69, 100.38, 125.93, 135.42000000000002, 132.77999999999997,
    125.95000000000002, 149.61999999999998, 167.95000000000002, 144.73, 126.86,
    153.62, 143.75, 107.49000000000001, 107.19999999999999, 124.58000000000001,
    137.82999999999998, 128.19, 109.96000000000001, 114.33, 116.51, 111.09, 108.52,
    123.23, 135.68, 116.17, 106.96, 132.78, 139.92, 139.82, 135.4, 152.69,
    160.39999999999998, 150.95999999999998, 142.82, 170.53000000000003, 169.28,
    157.68, 147.57, 193.07999999999998, 205.72000000000003, 170.17,
    132.01999999999998, 150.98, 144.14999999999998, 127.49999999999999, 104.85,
    110.00999999999999, 110.28999999999999, 97.75, 144.35, 111.91,
    109.32999999999998, 120.59, 161.32999999999998, 104, 106.64000000000001,
    99.94000000000001, 141.12, 120.07, 146.89999999999998, 123.36000000000001,
    113.97, 125.59, 113.26, 93.54, 119.53, 106.04, 106.47, 94.07, 96.37,
    114.63000000000002, 115.51000000000002, 94.88000000000001, 86.94, 91.78, 95.57,
    124.65, 199.58, 97.61, 103.75, 109, 107.2, 127.22, 131.71, 133.85999999999999,
    131.35, 133.3, 118.25999999999999, 93.89, 94.57999999999998, 110.58,
    112.85999999999999, 100.59, 104.41000000000001, 117.38, 123.05000000000001,
    124.79, 134.87, 134.13, 127.19, 122.15, 118.57, 112.89999999999998, 105.76,
    100.46999999999998, 113.81000000000002, 111.16, 108.57, 103.84, 105.87, 109.59,
    118.51, 126.27999999999999, 123.81, 111.95000000000002, 116.95,
    113.97999999999999,
  ],
};
